window.H = ($ => {
    class Enums {
        static ChartVisualizationType = {
            Timeline: 0,
            Column: 1,
            Point: 2,
            Grid: 3
        };

        static Period = {
            Default: 0,
            Day: 1,
            Week: 2,
            Month: 3,
            Quarter: 4,
            HalfYear: 5,
            Year: 6,
            YTD: 7,
            CustomRange: 8
        };

        static MapColoring = {
            Target: 1,
            Gradient: 2
        };

        static AlarmState = {
            Normal: 0,
            Moderate: 1,
            Severe: 2
        };

        static Point = {
            Svg: 1,
            Png: 2
        }
    }

    function uniqueId() {
        return Math.random().toString(36).substr(2, 9);
    }

    function padl(value, char, length) {
        var txt = "";
        for (var i = 0; i < length; i++) {
            txt += char;
        }

        txt += value;

        return txt.slice(-length);
    }

    function formatFloat(number, format) {
        let result = numbro(number).format(format);

        if (typeof format === 'string' && format.includes('{auto}')) {
            if (Math.abs(number) < 1) {
                result = format.replace('{auto}', numbro(parseFloat(number.toPrecision(3))).format({ mantissa: 10, trimMantissa: true }));
            } else if (Math.abs(number) < 100) {
                result = format.replace('{auto}', numbro(number).format({ mantissa: 2, trimMantissa: true }));
            } else if (Math.abs(number) < 1000) {
                result = format.replace('{auto}', numbro(number).format({ mantissa: 1, trimMantissa: true }));
            } else {
                result = format.replace('{auto}', numbro(number).format({ mantissa: 0, thousandSeparated: true }));
            }
        }

        return result;
    }

    function formatDate(date) {
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    Vue.prototype.$formatDate = formatDate;

    Vue.prototype.$formatTime = date => {
        return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    };

    function formatDateTime(date) {
        return `${formatDate(date)} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    }

    function formatString(text, ...args) {
        let result = text;
        if (args && args.length > 0) {
            args.forEach((a, i) => {
                result = result.replaceAll(`{${i}}`, a);
            });
        }
        return result;
    }

    function notify(severity, title, message) {
        Vue.notify({
            group: 'default',
            type: severity,
            title: title,
            text: message
        });
    }

    function getColor(idx) {
        const commonColors = [
            "#4bb2c5", "#EAA228", "#c5b47f", "#579575", "#839557", "#958c12", "#953579", "#4b5de4", "#d8b83f",
            "#ff5800", "#0085cc", "#c747a3", "#cddf54", "#FBD178", "#26B4E3", "#bd70c7"
        ];

        return commonColors[idx % commonColors.length];
    }

    function invertColor(color) {
        let result = color;
        if (result[0] === '#') {
            result = result.substring(1);
        }

        result = ('000000' + (parseInt(result, 16) ^ 0xffffff).toString(16)).slice(-6);

        return '#' + result;
    }

    function getRgbaColor(color, opacity) {
        const result = d3.color(color);
        if (opacity) {
            result.opacity = opacity
        }
        return result.toString();
    }

    function getGisObjectSprite(gisObjectTypes, gisObjectTypeId) {
        const item = gisObjectTypes.find(t => t.id === gisObjectTypeId);
        if (item && item.index >= 0) {
            return H.getSprite(item.index + 1);
        } else {
            console.log('Sprite not found: ' + gisObjectTypeId);
        }
    }

    function getDefaultVisualizationPeriodId(dataPeriodId) {
        switch (dataPeriodId) {
            case H.Enums.Period.Day: return H.Enums.Period.Month;
            case H.Enums.Period.Week: return H.Enums.Period.Month;
            case H.Enums.Period.Month: return H.Enums.Period.Year;
            case H.Enums.Period.Quarter: return H.Enums.Period.Year;
            case H.Enums.Period.HalfYear: return H.Enums.Period.Year;
            case H.Enums.Period.Year: return H.Enums.Period.Year;
        }
    }

    function getResultingVisualizationPeriodId(dataPeriodId, visualizationPeriodId) {
        if (visualizationPeriodId === H.Enums.Period.Default) {
            return H.getDefaultVisualizationPeriodId(dataPeriodId);
        } else {
            return visualizationPeriodId;
        }
    }

    //Deprecated
    function getGisObjectSpriteFromLevelId(levelId) {
        var idx = 1;
        switch (levelId) {
            case 1: idx = 5; break;
            case 2: idx = 4; break;
            case 3: idx = 3; break;
            case 4: idx = 2; break;
        }

        return H.getSprite(idx);
    }

    function getSpinner(size) {
        if (!size) {
            size = 25;
        }

        return $('<div>', { class: 'h-spinner' }).html(
            '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 512 512">' +
            '<path class="h-spinner-t1" d="M256.001,0c-8.284,0-15,6.716-15,15v96.4c0,8.284,6.716,15,15,15s15-6.716,15-15V15C271.001,6.716,264.285,0,256.001,0z"/>' +
            '<path class="h-spinner-t2" d="M384.001,34.3c-7.175-4.145-16.349-1.686-20.49,5.49l-48.199,83.483c-4.143,7.173-1.684,16.347,5.49,20.49c2.362,1.364,4.941,2.013,7.486,2.013c5.184,0,10.226-2.69,13.004-7.503l48.199-83.483C393.634,47.616,391.175,38.442,384.001,34.3z"/>' +
            '<path class="h-spinner-t3" d="M477.702,128.002c-4.142-7.175-13.315-9.634-20.49-5.49l-83.484,48.2c-7.174,4.142-9.631,13.315-5.49,20.49c2.778,4.813,7.819,7.503,13.005,7.503c2.544,0,5.123-0.648,7.485-2.013l83.484-48.2C479.387,144.35,481.844,135.176,477.702,128.002z"/>' +
            '<path class="h-spinner-t4" d="M497,241.002h-96.398c-8.284,0-15,6.716-15,15s6.716,15,15,15H497c8.284,0,15-6.716,15-15S505.284,241.002,497,241.002z"/>' +
            '<path class="h-spinner-t5" d="M472.213,363.51l-83.484-48.198c-7.177-4.145-16.349-1.684-20.49,5.49c-4.142,7.175-1.685,16.349,5.49,20.49,l83.484,48.198c2.362,1.364,4.94,2.013,7.485,2.013c5.185,0,10.227-2.691,13.005-7.503C481.845,376.825,479.388,367.651,472.213,363.51z"/>' +
            '<path class="h-spinner-t6" d="M389.491,457.212l-48.199-83.483c-4.142-7.175-13.315-9.635-20.49-5.49c-7.174,4.142-9.633,13.315-5.49,20.49,l48.199,83.483c2.778,4.813,7.82,7.503,13.004,7.503c2.545,0,5.125-0.648,7.486-2.013C391.175,473.56,393.634,464.387,389.491,457.212z"/>' +
            '<path class="h-spinner-t7" d="M256.001,385.601c-8.284,0-15,6.716-15,15V497c0,8.284,6.716,15,15,15s15-6.716,15-15v-96.399C271.001,392.316,264.285,385.601,256.001,385.601z"/>' +
            '<path class="h-spinner-t8" d="M191.201,368.239c-7.175-4.145-16.349-1.685-20.49,5.49l-48.2,83.485c-4.142,7.175-1.684,16.349,5.49,20.49c2.362,1.364,4.941,2.013,7.486,2.013c5.184,0,10.227-2.691,13.004-7.503l48.2-83.485C200.833,381.555,198.376,372.381,191.201,368.239z"/>' +
            '<path class="h-spinner-t9" d="M143.765,320.802c-4.141-7.175-13.314-9.635-20.49-5.49l-83.486,48.2c-7.174,4.142-9.632,13.315-5.49,20.49c2.778,4.813,7.82,7.503,13.004,7.503c2.545,0,5.124-0.648,7.486-2.013l83.486-48.2C145.449,337.15,147.907,327.977,143.765,320.802z"/>' +
            '<path class="h-spinner-t10" d="M111.401,241.002H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h96.401c8.284,0,15-6.716,15-15S119.685,241.002,111.401,241.002z"/>' +
            '<path class="h-spinner-t11" d="M138.274,170.712L54.788,122.51c-7.174-4.145-16.348-1.685-20.49,5.49c-4.142,7.174-1.684,16.348,5.49,20.49,l83.486,48.202c2.362,1.364,4.941,2.013,7.486,2.013c5.184,0,10.226-2.691,13.004-7.503C147.906,184.028,145.448,174.854,138.274,170.712z"/>' +
            '<path class="h-spinner-t12" d="M196.691,123.272l-48.2-83.485c-4.142-7.175-13.315-9.635-20.49-5.49c-7.174,4.142-9.632,13.315-5.49,20.49l48.2,83.485c2.778,4.813,7.82,7.503,13.004,7.503c2.545,0,5.124-0.648,7.486-2.013C198.376,139.62,200.833,130.447,196.691,123.272z"/>' +
            '</svg>'
        );
    }

    $.fn.hpopulate = function (items, options) {
        var self = $(this);
        var found = false;

        var defaults = {
            selected: null,
            clear: false,
            clearable: false
        };
        var settings = $.extend(defaults, options);

        if (settings.clear) {
            self.empty();
        }

        items.forEach(function (item) {
            if (item.values) {
                var optgroup = $('<optgroup>', { label: item.text });
                item.values.forEach(function (childItem) {
                    var option = new Option(childItem.text, childItem.value, false, childItem.value === settings.selected);
                    if (childItem.cargo) {
                        option.setAttribute('data-cargo', childItem.cargo);
                    }
                    optgroup.append(option);
                    found = found || childItem.value === settings.selected;
                });
                self.append(optgroup);
            } else {
                var option = new Option(item.text, item.value, false, item.value === settings.selected);
                if (item.cargo) {
                    option.setAttribute('data-cargo', item.cargo);
                }
                self.append(option);
                found = found || item.value === settings.selected;
            }
        });

        if (!found && !settings.selected) {
            self.val(null);
        }

        if (settings.clearable) {
            self.prepend(new Option('', '', false, false));

            self.on('select2:unselecting', function () {
                self.data('unselecting', true);
            }).on('select2:open', function () {
                if (self.data('unselecting')) {
                    self.removeData('unselecting');
                    self.select2('close');
                }
            });
        }

        if (settings.selected && !found) {
            self.append(new Option(settings.selected, settings.selected, false, true));
        }
    };

    function unitMatcher(params, data) {
        if ($.trim(params.term) === '' || data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
            return data;
        }

        if (typeof data.text === 'undefined') {
            return null;
        }

        if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
            return data;
        }

        if (data.text.toLowerCase().replace('\u00B2', '2').replace('\u00B3', '3').indexOf(params.term.toLowerCase()) > -1) {
            return data;
        }

        return null;
    }

    function showUsageModal(options) {
        var husagemodal = $('#h-usagemodal');
        if (husagemodal.length === 0) {
            husagemodal = $('<div>', { class: 'h-modal', id: 'h-usagemodal' });
            $('body').append(husagemodal);
        }

        var modal = husagemodal.hmodal({
            header: options.header,
            background: '#f2f2f2',
            accept: options.close
        });

        var htree = $('<div>', { id: 'h-usagemodal-tree' });
        husagemodal.empty().append(htree);

        htree.hchecktree(options.items, {
            checkable: false,
            expanded: true
        });

        modal.open();
    }

    function textComparer(a, b, direction) {
        const c1 = (a === null || a === undefined) ? '' : a.toLowerCase();
        const c2 = (b === null || b === undefined) ? '' : b.toLowerCase();

        if (c1 < c2) {
            return direction;
        } else if (c2 < c1) {
            return -direction;
        }
        return 0;
    }

    function dateComparer(a, b, direction) {
        const c1 = (a === null || a === undefined) ? 0 : a.getTime();
        const c2 = (b === null || b === undefined) ? 0 : b.getTime();

        if (c1 < c2) {
            return direction;
        } else if (c2 < c1) {
            return -direction;
        }
        return 0;
    }

    function numberComparer(a, b, direction) {
        const c1 = typeof a === 'number' ? a : (direction > 0) ? -Infinity : Infinity;
        const c2 = typeof b === 'number' ? b : (direction > 0) ? -Infinity : Infinity;

        return (c2 - c1) * direction;
    }

    function boolComparer(a, b, direction) {
        if (a && !b) {
            return direction;
        } else if (!a && b) {
            return -direction;
        }
        return 0;
    }

    function setGridSort(gridConfig, sortCode, defaultSort) {
        H.session.register(sortCode);

        const sort = H.session[sortCode] || defaultSort;

        gridConfig.sortColumn = sort.key;
        gridConfig.sortDirection = sort.direction;

        gridConfig.on('headerCellClick', () => {
            H.session[sortCode] = {
                key: gridConfig.sortColumn,
                direction: gridConfig.sortDirection
            };
        });
    }

    var session = (function() {
        var register = function register(name) {
            if (!H.session.hasOwnProperty(name)) {
                Object.defineProperty(H.session, name, {
                    get: function get() {
                        return JSON.parse(sessionStorage.getItem(name));
                    },
                    set: function set(value) {
                        sessionStorage.setItem(name, JSON.stringify(value));
                    }
                });
            }
        };

        return {
            register: register
        };
    })();

    function ConnectionString(connectionString) {
        if (connectionString) {
            this.parse(connectionString);
        }
    }

    ConnectionString.prototype.parse = function(connectionString) {
        var self = this;
        var tokens = [];
        var idxFrom = 0;
        var inQuotes = false;
        for (var i = 0; i < connectionString.length; i++) {
            switch (connectionString[i]) {
            case ';':
                if (!inQuotes) {
                    tokens.push(connectionString.substring(idxFrom, i));
                    idxFrom = i + 1;
                }
                break;
            case '"':
                if (inQuotes) {
                    inQuotes = false;
                } else if (connectionString[i - 1] === '=') {
                    inQuotes = true;
                }
                break;
            }
        }

        if (idxFrom < connectionString.length) {
            tokens.push(connectionString.substring(idxFrom));
        }

        var knownProperties = [
            'Provider', 'Data Source', 'Initial Catalog', 'User ID', 'Password', 'MultipleActiveResultSets',
            'Persist Security Info', 'Extended Properties'
        ];

        tokens.forEach(function(token) {
            var idx = token.indexOf('=');
            if (idx > -1) {
                var prop = token.substring(0, idx);
                var value = token.substring(idx + 1);
                if (value[0] === '"') {
                    value = value.substring(1);
                }
                if (value[value.length - 1] === '"') {
                    value = value.substring(0, value.length - 1);
                }

                for (var i = 0; i < knownProperties.length; i++) {
                    if (prop.toLowerCase() === knownProperties[i].toLowerCase()) {
                        prop = knownProperties[i];
                        break;
                    }
                }

                self[prop] = value;
            }
        });
    };
    ConnectionString.prototype.toString = function() {
        var result = [];
        for (var prop in this) {
            if (this.hasOwnProperty(prop)) {
                if (this[prop].indexOf(';') > -1) {
                    result.push(prop + '="' + this[prop] + '"');
                } else {
                    result.push(prop + '=' + this[prop]);
                }
            }
        }
        return result.join(';');
    };
    ConnectionString.prototype.getNestedValue = function(prop, startsWith) {
        if (this[prop]) {
            var values = this[prop].split(';');
            for (var i = 0; i < values.length; i++) {
                if (values[i].substring(0, startsWith.length) === startsWith) {
                    return values[i];
                }
            }
        }
        return '';
    };
    ConnectionString.prototype.setNestedValue = function(prop, startsWith, value) {
        var values = this[prop].split(';').filter(function(item) { return item });
        for (var i = 0; i < values.length; i++) {
            if (values[i].substring(0, startsWith.length) === startsWith) {
                if (value) {
                    values[i] = value;
                } else {
                    values.splice(i, 1);
                }
                this[prop] = values.join(';');
                return;
            }
        }
        values.push(value);
        this[prop] = values.join(';');
    };
    Object.defineProperty(ConnectionString.prototype, 'type',
        {
            get: function () {
                if (this.Provider === 'SQLOLEDB' || this.Provider === 'MSOLEDBSQL') {
                    return 'sqlserver';
                }

                if (this.Provider === 'Microsoft.ACE.OLEDB.12.0') {
                    if (this.getNestedValue('Extended Properties', 'Excel') !== '') {
                        return 'excel';
                    }
                    return 'access';
                }

                return 'custom';
            }
        });

    class HEventManager {
        constructor(events) {
            this.eventNames = events;
            this.handlers = [];
        }

        registerEvent(eventName) {
            if (!this.eventNames.includes(eventName)) {
                this.eventNames.push(eventName);
            }
        }

        unregisterEvent(eventName) {
            const idx = this.eventNames.indexOf(eventName);
            if (idx > -1) {
                this.eventNames.splice(idx, 1);
            }
        }

        hasEvent(eventName) {
            return this.eventNames.includes(eventName);
        }

        on(eventNames, handler) {
            if (!Array.isArray(eventNames)) {
                eventNames = [eventNames];
            }
            const ids = [];

            eventNames.filter(e => this.eventNames.includes(e))
                .forEach((e) => {
                    const event = {
                        eventName: e,
                        handler,
                        id: Math.random().toString(36).slice(2)
                    };
                    ids.push(event.id);
                    this.handlers.push(event);
                });

            if (ids.length === 1) {
                return ids[0];
            } else {
                return ids;
            }
        }

        off(events) {
            if (!Array.isArray(events)) {
                events = [events];
            }
            events.forEach((e) => {
                if (typeof e === 'string') {
                    for (let i = 0; i < this.handlers.length; i++) {
                        if (e === this.handlers[i].eventName) {
                            this.callbacks.splice(i, 1);
                        }
                    }
                } else {
                    for (let i = 0; i < this.handlers.length; i++) {
                        if (e === this.handlers[i].id) {
                            this.callbacks.splice(i, 1);
                            break;
                        }
                    }
                }
            });
        }

        trigger(eventName, data) {
            let result = true;

            this.handlers.filter(h => h.eventName === eventName).forEach((h) => {
                const res = h.handler(Object.assign({ event: eventName }, data));
                if (res === undefined || res === true) {
                    result = result && true;
                } else {
                    result = false;
                }
            });

            return result;
        }
    }

    class HEventable {
        constructor(events) {
            Object.defineProperty(this, '_eventManager', { value: new HEventManager(events) })
        }

        registerEvent(eventName) { this._eventManager.registerEvent(eventName) };
        unregisterEvent(eventName) { this._eventManager.unregisterEvent(eventName) };
        hasEvent(eventName) { return this._eventManager.hasEvent(eventName) };
        on(eventNames, handler) { this._eventManager.on(eventNames, handler) };
        off(events) { this._eventManager.off(events) };
        trigger(eventName, data) { this._eventManager.trigger(eventName, data) };
    }

    class HPointVisualization {
        static Symbols = [];

        constructor(options) {
            options = options || {};

            this.symbolId = options.symbolId || 1;

            this.stroke = options.stroke || '#333333ff';
            this.fill = options.fill || '#ddddddff';
            this.size = options.size || 20;

            this.operator = options.operator;
            this.value = options.value || 0;
            this.description = options.description || '';
        }

        get symbolTypeId() {
            return H.HPointVisualization.Symbols.find(s => s.id === this.symbolId).typeId;
        }

        get symbolData() {
            const symbol = H.HPointVisualization.Symbols.find(s => s.id === this.symbolId);
            return this.symbolTypeId === H.Enums.Point.Svg ? symbol.data : JSON.parse(symbol.data).data;
        }

        get bitmapWidth() {
            return JSON.parse(H.HPointVisualization.Symbols.find(s => s.id === this.symbolId).data).width;
        }

        get bitmapHeight() {
            return JSON.parse(H.HPointVisualization.Symbols.find(s => s.id === this.symbolId).data).height;
        }

        get pointStyle() {
            return new vpointstyle.PointStyle({
                type: this.symbolTypeId === H.Enums.Point.Svg ? 'svg' : 'png',
                symbol: this.symbolData,
                stroke: this.stroke,
                fill: this.fill,
                size: this.size
            });
        }

        get dataUrl() {
            if (this.symbolTypeId === H.Enums.Point.Svg) {
                return `data:image/svg+xml,${this.getSvg()}`;
            } else {
                return `data:image/png;base64,${this.symbolData}`;
            }
        }

        getSvg(size) {
            return `<svg width="${size ?? this.size}" height="${size ?? this.size}" fill="${H.getRgbaColor(this.fill)}" stroke="${H.getRgbaColor(this.stroke)}"` + this.symbolData.substring(4);
        }

        get scale() {
            if (this.symbolTypeId === H.Enums.Point.Svg) {
                return 1;
            } else {
                return this.size / Math.max(this.bitmapWidth, this.bitmapHeight);
            }
        }
    }

    class HPointLayerVisualization {
        constructor() {
            this.default = new H.HPointVisualization();
            this.rules = [];
        }

        parse(visualization) {
            const viz = JSON.parse(visualization);
            if (viz) {
                this.default = new H.HPointVisualization({
                    description: viz.default.description,
                    symbolId: viz.default.symbolId,
                    stroke: viz.default.stroke,
                    fill: viz.default.fill,
                    size: viz.default.size
                });

                this.rules = viz.rules.map(r => new H.HPointVisualization({
                    operator: r.operator,
                    value: r.value,
                    description: r.description,
                    symbolId: r.symbolId,
                    stroke: r.stroke,
                    fill: r.fill,
                    size: r.size
                }));
            }

            return this;
        }

        toString() {
            const visualization = {
                default: {
                    description: this.default.description,
                    symbolId: this.default.symbolId,
                    stroke: this.default.symbolTypeId === H.Enums.Point.Svg ? this.default.stroke : undefined,
                    fill: this.default.symbolTypeId === H.Enums.Point.Svg ? this.default.fill : undefined,
                    size: this.default.size
                },
                rules: this.rules.map(r => {
                    return {
                        operator: r.operator,
                        value: r.value,
                        description: r.description,
                        symbolId: r.symbolId,
                        stroke: r.symbolTypeId === H.Enums.Point.Svg ? r.stroke : undefined,
                        fill: r.symbolTypeId === H.Enums.Point.Svg ? r.fill : undefined,
                        size: r.size
                    }
                })
            }

            return JSON.stringify(visualization);
        }
    }

    let spriteUrl;

    const initSprite = url => {
        spriteUrl = url;
    };

    const getSprite = (icon, cls) => {
        let result = cls ? '<svg class="' + cls + '">' : '<svg>';
        return result + '<use xlink:href="' + spriteUrl + '#h-' + icon + '"/></svg>';
    };

    const getSpriteUrl = icon => {
        return spriteUrl + '#h-' + icon;
    };

    const getFile = (url, filename, mimeType) => {
        fetch(url)
            .then(r => r.arrayBuffer())
            .then(r => {
                const el = document.createElement('a');
                el.href = window.URL.createObjectURL(new Blob([r], { type: mimeType }));
                el.download = filename;

                document.body.appendChild(el);
                el.click();
                document.body.removeChild(el);
            });
    };

    class HAxios {
        constructor(options) {
            this.axios = axios.create({
                baseURL: options.url
            });
        }

        request(config) {
            vstore.status.pendingRequests++;
            return this.axios(config)
                .then(r => {
                    if (r.data.hasValidationErrors) {
                        return Promise.reject({
                            errors: r.data.validationErrors.map(v => {
                                return {
                                    key: v.key,
                                    message: v.value
                                };
                            })
                        });
                    } else {
                        return Promise.resolve(r.data.model);
                    }
                })
                .catch(e => {
                    if (e instanceof Error) {
                        H.notify('error', e.message);
                        return Promise.reject(e);
                    } else if (e.errors) {
                        return Promise.reject(e);
                    } else {
                        return Promise.reject({
                            errors: [{ key: null, message: e.response.data.error.message }],
                            response: e.response
                        });
                    }
                })
                .finally(() => {
                    vstore.status.pendingRequests--;
                });
        }

        get(url, params) {
            return this.request({
                method: 'GET',
                url: url,
                params: params
            });
        }

        post(url, data, params) {
            return this.request({
                method: 'POST',
                url: url,
                data: data,
                params: params
            });
        }

        downloadFile(url, params, filename) {
            vstore.status.pendingRequests++;
            return this.axios
                .post(url, params, { responseType: 'arraybuffer' })
                .then(response => {
                    const el = document.createElement('a');
                    el.href = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
                    el.download = filename || response.headers['content-disposition'].substring(response.headers['content-disposition'].indexOf('filename=') + 9);

                    document.body.appendChild(el);
                    el.click();
                    document.body.removeChild(el);
                    Promise.resolve(true)
                })
                .catch(error => {
                    if (error.response.status === 404) {
                        H.notify('error', e.message, error.response.data.messageDetail);
                    }
                    Promise.reject(error)
                })
                .finally(() => {
                    vstore.status.pendingRequests--;
                });
        }

        uploadFiles(data) {
            vstore.status.pendingRequests++;
            return this.axios
                .post('File/Send', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .finally(() => {
                    vstore.status.pendingRequests--;
                });
        }

        getUrl(url, params) {
            return this.axios.getUri({ url: this.axios.defaults.baseURL + url, params });
        }
    }

    const admApi = new HAxios({
        url: '/api/'
    });

    const contentApi = new HAxios({
        url: '/contentapi/'
    });

    const downloadFile = function(data, mimeType, filename) {
        const el = document.createElement('a');
        el.href = window.URL.createObjectURL(new Blob([data], { type: mimeType }));
        el.download = filename;

        document.body.appendChild(el);
        el.click();
        document.body.removeChild(el);
    }

    const downloadFileFromDataUrl = function (dataUrl, filename) {
        const el = document.createElement('a');
        el.href = dataUrl;
        el.download = filename;

        document.body.appendChild(el);
        el.click();
        document.body.removeChild(el);
    }

    class HTreeNode {
        constructor(value, cargo) {
            this.value = value;
            this.cargo = cargo;
            this.nodes = new Set();
        }

        get hasChildren() {
            return this.nodes.size > 0;
        }

        get childCount() {
            return this.nodes.size;
        }

        get nodeCount() {
            let result = 1;

            for (const c of this.nodes) {
                result += c.nodeCount;
            }

            return result;
        }

        findNode(value) {
            if (this.value === value) {
                return this;
            }

            for (const c of this.nodes) {
                const node = c.findNode(value);
                if (node !== undefined) {
                    return node;
                }
            }
        }

        findChildNode(value) {
            for (const c of this.nodes) {
                if (c.value === value) {
                    return c;
                }
            }
        }

        findNodeByValues(values) {
            let result = this.findChildNode(values[0]);
            if (result) {
                if (values.length > 1) {
                    return result.findNodeByValues(values.slice(1));
                } else {
                    return result;
                }
            }
        }

        add(node) {
            this.nodes.add(node);
            return node;
        }

        ensureNodes(values) {
            let node = this.findChildNode(values[0]);
            if (!node) {
                node = this.add(new HTreeNode(values[0]));
            }
            if (values.length > 1) {
                return node.ensureNodes(values.slice(1));
            } else {
                return node;
            }
        }

        hasChild(value) {
            for (const c of this.nodes) {
                if (c.value === value) {
                    return true;
                }
            }

            return false;
        }

        map(cb, childrenProperty = 'nodes') {
            const result = cb(this.value, this.cargo);

            if (this.hasChildren) {
                result[childrenProperty] = result[childrenProperty] || [];
                for (const c of this.nodes) {
                    result[childrenProperty].push(c.map(cb, childrenProperty));
                }
            }

            return result;
        }
    }

    class HTree extends HTreeNode {
        get nodeCount() {
            return super.nodeCount() - 1;
        }
    }

    return {
        uniqueId: uniqueId,
        padl: padl,
        formatFloat: formatFloat,
        formatDate: formatDate,
        formatDateTime: formatDateTime,
        formatString: formatString,
        notify: notify,
        getColor: getColor,
        invertColor: invertColor,
        getRgbaColor: getRgbaColor,
        getDefaultVisualizationPeriodId: getDefaultVisualizationPeriodId,
        getResultingVisualizationPeriodId: getResultingVisualizationPeriodId,
        getGisObjectSpriteFromLevelId: getGisObjectSpriteFromLevelId,
        getGisObjectSprite: getGisObjectSprite,
        getSpinner: getSpinner,
        ConnectionString: ConnectionString,
        unitMatcher: unitMatcher,
        showUsageModal: showUsageModal,
        textComparer: textComparer,
        numberComparer: numberComparer,
        dateComparer: dateComparer,
        boolComparer: boolComparer,
        session: session,
        HEventable: HEventable,
        HPointVisualization: HPointVisualization,
        HPointLayerVisualization: HPointLayerVisualization,
        initSprite: initSprite,
        getSprite: getSprite,
        getSpriteUrl: getSpriteUrl,
        getFile: getFile,
        admApi: admApi,
        contentApi: contentApi,
        Enums: Enums,
        HTreeNode: HTreeNode,
        HTree: HTree,
        setGridSort: setGridSort,
        HAxios: HAxios,
        downloadFile: downloadFile,
        downloadFileFromDataUrl: downloadFileFromDataUrl
    };
})(jQuery);

class HPersistentStore {
    constructor(pageId) {
        this.pageId = pageId;
    }

    get(prop) {
        let data = window.localStorage.getItem(this.pageId);
        if (data !== null) {
            data = JSON.parse(data);
            if (data.sessionId === window.localStorage.getItem('sessionId')) {
                return data[prop];
            }
        }

        return;
    }

    set(prop, value) {
        let data = window.localStorage.getItem(this.pageId);

        if (data === null) {
            data = {}
        } else {
            data = JSON.parse(data);
        }

        data.sessionId = window.localStorage.getItem('sessionId');
        data[prop] = value;

        window.localStorage.setItem(this.pageId, JSON.stringify(data));
    }

    remove(prop) {
        let data = window.localStorage.getItem(this.pageId);

        if (data !== null) {
            data = JSON.parse(data);
        }

        data.sessionId = window.localStorage.getItem('sessionId');
        delete data[prop]

        window.localStorage.setItem(this.pageId, JSON.stringify(data));
    }

    clear() {
        window.localStorage.setItem(this.pageId, JSON.stringify({
            sessionId: window.localStorage.getItem('sessionId')
        }));
    }
}

window.hcron = function(pattern) {
    'use strict';

    function partToString(part, lower, upper) {
        if (part.length === upper - lower + 1) {
            return lower + '-' + upper;
        } else {
            return part.join(',');
        }
    }

    function Cron() {
        this.minutes = [];
        this.hours = [];
        this.days = [];
        this.months = [];
        this.weekdays = [];
    }

    Cron.prototype.get = function () {
        if (this.minutes.length === 0 &&
            this.hours.length === 0 &&
            this.days.length === 0 &&
            this.months.length === 0 &&
            this.weekdays.length === 0) {
            return '';
        }
        return partToString(this.minutes, 0, 59) +
            ' ' +
            partToString(this.hours, 0, 23) +
            ' ' +
            partToString(this.days, 1, 31) +
            ' ' +
            partToString(this.months, 1, 12) +
            ' ' +
            partToString(this.weekdays, 0, 6);
    };

    Cron.prototype.set = function(pattern) {
        var elements = [];

        var parts = pattern.split(' ');
        parts.forEach(function(part) {
            var idx = part.indexOf('-');
            if (idx > -1) {
                var from = parseInt(part.substring(0, idx));
                var to = parseInt(part.substring(idx + 1));
                var el = [];
                for (var i = from; i <= to; i++) {
                    el.push(i);
                }
                elements.push(el);
            } else {
                elements.push(part.split(',').map(function(n) { return parseInt(n) }));
            }
        });

        if (elements.length === 5) {
            this.minutes = elements[0];
            this.hours = elements[1];
            this.days = elements[2];
            this.months = elements[3];
            this.weekdays = elements[4];
        }
    };

    Cron.prototype.pretty = function(language) {
        var m = moment();
        var weekdayNames = moment.weekdays();
        var monthNames = moment.months();

        var result = '';

        language = language.substring(0, 2).toLowerCase();

        let translations;

        switch (language) {
            case 'da':
                translations = {
                    custom: 'Tilpasset',
                    yearly: 'Årligt, den {day}. {month}, kl. {time}',
                    monthly: 'Den {day}. i hver måned kl. {time}',
                    weekly: 'Hver {weekday} kl. {time}',
                    weekdays: 'Alle hverdage kl. {time}',
                    daily: 'Hver dag kl. {time}'
                };
                break;
            default:
                 translations = {
                    custom: 'Custom',
                    yearly: 'Yearly, {month} {day} at {time}',
                    monthly: 'Day {day} of every month at {time}',
                    weekly: 'Every {weekday} at {time}',
                    weekdays: 'Every weekday at {time}',
                    daily: 'Every day at {time}'
                };
        }

        if (this.minutes.length > 0 &&
            this.hours.length > 0 &&
            this.days.length > 0 &&
            this.months.length > 0 &&
            this.weekdays.length > 0) {
            result = translations.custom;
        }

        if (this.hours.length === 1 && this.minutes.length === 1) {
            m.hours(this.hours[0]);
            m.minutes(this.minutes[0]);
            if (this.weekdays.length === 7 && this.days.length === 1 && this.months.length === 1) {
                result = translations.yearly;
            } else if (this.weekdays.length === 7 && this.days.length === 1 && this.months.length === 12) {
                result = translations.monthly;
            } else if (this.weekdays.length === 1 && this.days.length === 31 && this.months.length === 12) {
                result = translations.weekly;
            } else if (this.weekdays.length === 5 &&
                this.weekdays[0] === 1 &&
                this.weekdays.indexOf(0) === -1 &&
                this.weekdays.indexOf(6) === -1 &&
                this.days.length === 31 &&
                this.months.length === 12) {
                result = translations.weeksdays;
            } else if (this.weekdays.length === 7 && this.days.length === 31 && this.months.length === 12) {
                result = translations.daily;
            }
            result = result.replace('{month}', monthNames[this.months[0] - 1]);
            result = result.replace('{day}', this.days[0]);
            result = result.replace('{weekday}', weekdayNames[this.weekdays[0]]);
            result = result.replace('{time}', m.format('HH:mm'));
        }

        return result;
    };

    var cron = new Cron();
    if (pattern) {
        cron.set(pattern);
    }

    return cron;
};
window.vstore = (() => {
    const store = Vue.observable({
        sizing: {
            splitV: 0,
            splitH: 0
        },
        status: {
            pendingRequests: 0
        },
        user: {
            id: null,
            name: null,
            culturCode: null
        },
        company: {
            id: null,
            name: null,
            isParent: null
        },
        shared: {
            chart: {
                visualizationTypeId: H.Enums.ChartVisualizationType.Timeline,
                visualizationPeriod: {
                    id: H.Enums.Period.Default,
                    startDate: new Date(moment(new Date()).add(-1, 'days').toDate().toDateString()),
                    endDate: new Date((new Date()).toDateString())
                }
            },
            dataPeriodId: H.Enums.Period.Day,
            kpis: [],
            gisObject: null,
            mapSelection: null
        },
        benchmark: {
            kpi: null,
            gisObjects: []
        },
        pointLayers: {
            selected: [],
            selectedPoints: [],
            chart: {
                visualizationTypeId: H.Enums.ChartVisualizationType.Timeline,
                visualizationPeriod: {
                    startKind: 'auto',
                    startTimestamp: moment(new Date()).add(-1, 'days').toDate(),
                    endKind: 'auto',
                    endTimestamp: new Date()
                }
            },
            mapSelection: null
        }
    });

    return store;
})();

(function ($) {
    'use strict';

    $.fn.hchecktree = function (data, options) {
        var defaults = {
            id: 'checktree',
            selectable: false,
            collapsable: true,
            draggable: false,
            droppable: false,
            droppableBetween: false,
            checkable: true,
            readonly: false,
            expanded: false,
            showChildCount: false,
            icons: {
                expander: 'right-angle',
                unchecked: 'checkbox-unchecked',
                checked: 'checkbox-checked',
                indeterminate: 'checkbox-indeterminate'
            }
        };

        return (function (tree) {
            var settings = $.extend(defaults, options);

            var callbacks = [];

            var dragInfo = {};

            var on = function (event, cb) {
                if (!Array.isArray(event)) {
                    event = [event];
                }
                event.forEach(function (e) {
                    if (['click', 'candrop', 'candropbetween', 'drop', 'dropbetween', 'select'].indexOf(e) > -1) {
                        callbacks.push({ event: e, cb: cb });
                    }
                });
            };

            var setDragData = function(data) {
                dragInfo.data = data;
                dragInfo.internal = false;
            };

            var clearDragData = function() {
                dragInfo.data = undefined;
            };

            function addNodes(parent, nodedefs) {
                nodedefs.forEach(function (nodedef) {
                    var node = add(parent, nodedef);
                    if (nodedef.nodes) {
                        addNodes(node, nodedef.nodes);
                    }
                });
            }

            function createNode(options) {
                var nodeoptions = {
                    content: '',
                    selectedContent: null,
                    title: null,
                    cargo: undefined,
                    expanded: settings.expanded,
                    selectable: settings.selectable,
                    draggable: settings.draggable,
                    droppable: settings.droppable
                };

                $.extend(nodeoptions, options);

                var cls = 'h-checktree-node';
                if (settings.checkable) {
                    cls += ' h-checkable';
                }
                if (nodeoptions.expanded) {
                    cls += ' h-expanded';
                }
                if (nodeoptions.selectable) {
                    cls += ' h-selectable';
                }

                var node = $('<div>', { class: cls });
                if (nodeoptions.id) {
                    node.data('id', nodeoptions.id);
                }
                if (nodeoptions.cargo) {
                    node.data('cargo', nodeoptions.cargo);
                }
                node.attr('tabindex', 0);
                var item = $('<div>', { class: 'h-checktree-item' });
                if (settings.collapsable) {
                    item.append($('<div>', { class: 'h-checktree-expander', style: 'visibility: hidden' }).append(H.getSprite(settings.icons.expander)));
                }
                item.append($('<div>', { class: 'h-checktree-checker' }));
                var content = $('<div>', { class: 'h-checktree-content', title: nodeoptions.title });
                if (nodeoptions.draggable) {
                    content.draggable({
                        containment: 'window',
                        helper: 'clone',
                        revert: 'invalid',
                        zIndex: 9999,
                        start: function (e, ui) {
                            dragInfo.node = $(this).closest('.h-checktree-node');
                            dragInfo.data = dragInfo.node.data('cargo');
                            dragInfo.internal = true;
                        },
                        stop: function (e, ui) {
                            dragInfo.data = undefined;
                        }
                    });
                }
                content.html(nodeoptions.content);
                item.append(content);
                if (settings.showChildCount) {
                    content.append($('<div>', { class: 'h-checktree-childcount' }));
                }
                if (nodeoptions.selectedContent) {
                    item.append($('<div>', { class: 'h-checktree-selectedcontent' }).append(nodeoptions.selectedContent));
                }
                node.append(item);
                if (nodeoptions.droppable) {
                    content.droppable({
                        accept: acceptDrop,
                        tolerance: 'pointer',
                        classes: {
                            'ui-droppable-hover': 'h-dropping'
                        }
                    });
                }

                if (settings.droppableBetween) {
                    var dropBetween = $('<div>', { class: 'h-checktree-dropbetween' });
                    node.append(dropBetween);

                    dropBetween.droppable({
                        accept: acceptBetweenDrop,
                        tolerance: 'pointer',
                        classes: {
                            'ui-droppable-hover': 'h-dropping'
                        }
                    });
                }

                return node;
            }

            function acceptDrop() {
                var node = $(this).closest('.h-checktree-node');
                return trigger('candrop', { node: node, nodeData: node.data('cargo'), dragNode: dragInfo.node, dragData: dragInfo.data, internal: dragInfo.internal });
            }

            function acceptBetweenDrop() {
                var node = $(this).closest('.h-checktree-node');    
                return trigger('candropbetween', { node: node, nodeData: node.data('cargo'), dragNode: dragInfo.node, dragData: dragInfo.data, internal: dragInfo.internal });
            }

            var add = function (parent, options) {
                var node = createNode(options);
                if (parent) {
                    var children = parent.find('> .h-checktree-children');
                    if (children.length === 0) {
                        children = $('<div>', { class: 'h-checktree-children' });
                        parent.append(children);
                    }
                    if (options.prepend) {
                        children.prepend(node);
                    } else {
                        children.append(node);
                    }
                    updateExpander(parent);
                } else {
                    tree.append(node);
                }

                setChecker(node, options.checked || false);

                updateChildCount();

                return node;
            };

            var insert = function (previous, options) {
                var node = createNode(options);
                if (previous) {
                    node.insertAfter(previous);
                    var parent = previous.parent().closest('.h-checktree-node');
                    updateExpander(parent);
                } else {
                    tree.append(node);
                }

                setChecker(node, options.checked || false);

                updateChildCount();

                return node;
            };

            var get = function (id) {
                var result = null;
                tree.find('.h-checktree-node').each(function () {
                    if ($(this).data('id') === id) {
                        result = $(this);
                    }
                });
                return result;
            };

            var getParent = function (node) {
                var parent = node.parent().closest('.h-checktree-node');
                if (parent.length === 0) {
                    return null;
                } else {
                    return parent;
                }
            };

            var getChildren = function (node) {
                return node.find('> .h-checktree-children > .h-checktree-node');
            };

            var getRootNodes = function () {
                return tree.find('> .h-checktree-node');
            };

            var getAllNodes = function () {
                var result = [];
                
                function getNode(node) {
                    result.push(node);
                    getChildren(node).each(function () {
                        getNode($(this));
                    });
                }
                
                getRootNodes().each(function () {
                    getNode($(this));
                });

                return result;
            };

            var remove = function (node) {
                var parent = node.parent().closest('.h-checktree-node');
                node.remove();
                var children = parent.find('.h-checktree-children');
                if (children.find('.h-checktree-node').length === 0) {
                    children.remove();
                }
                updateCheckerUp(parent);
                updateExpander(parent);
                updateChildCount();
            };

            var move = function (node, parent, previous) {
                var oldParent = node.parent().closest('.h-checktree-node');
                node.detach();

                var children = parent.find('> .h-checktree-children');
                if (children.length === 0) {
                    children = $('<div>', { class: 'h-checktree-children' });
                    parent.append(children);
                }
                if (previous) {
                    node.insertAfter(previous);
                } else {
                    children.append(node);
                }
                updateCheckerUp(parent);
                updateExpander(parent);
                updateCheckerUp(oldParent);
                updateExpander(oldParent);
                updateChildCount();                
            };

            var expand = function(node) {
                node.addClass('h-expanded');
            };

            var collapse = function(node) {
                node.removeClass('h-expanded');
            };

            var check = function(node, checked) {
                setChecker(node, checked !== false);
            };

            var getChecked = function () {
                var result = [];
                tree.find('.h-checktree-node').each(function() {
                    if ($(this).find('> .h-checktree-children .h-checktree-node').length === 0) {
                        if ($(this).data('checked') === 'checked') {
                            result.push($(this).data('cargo'));
                        }
                    }
                });
                return result;
            };

            var select = function(node) {
                var toggle = node.hasClass('h-selected');
                tree.find('.h-checktree-node').removeClass('h-selected');
                tree.find('.h-checktree-selectedcontent').toggle(false);
                if (node.hasClass('h-selectable')) {
                    node.toggleClass('h-selected', !toggle);
                    node.find('> .h-checktree-item > .h-checktree-selectedcontent').toggle(!toggle);
                    trigger('select', { node: node, select: !toggle, cargo: node.data('cargo') });
                }
            };

            var disable = function () {
                tree.addClass('h-disabled');
            };

            var enable = function () {
                tree.removeClass('h-disabled');
            };

            function trigger(event, data) {
                var result = true;
                callbacks.filter(function (e) {
                    return e.event === event;
                }).forEach(function (value) {
                    var res = value.cb($.extend({ event: event }, data));
                    if (res === undefined || res === true) {
                        result = result && true;
                    } else {
                        result = false;
                    }
                });
                return result;
            }

            function updateExpander(node) {
                if (node.find('> .h-checktree-children .h-checktree-node').length === 0) {
                    node.find('> .h-checktree-item .h-checktree-expander').css('visibility', 'hidden');
                } else {
                    node.find('> .h-checktree-item .h-checktree-expander').css('visibility', 'visible');
                }
            }

            function setChecker(node, checked) {
                if (checked) {
                    node.data('checked', 'checked');
                    node.find('> .h-checktree-item .h-checktree-checker').html(H.getSprite(settings.icons.checked));
                } else {
                    node.data('checked', 'unchecked');
                    node.find('> .h-checktree-item .h-checktree-checker').html(H.getSprite(settings.icons.unchecked));
                }
                node.find('> .h-checktree-children').children().each(function () {
                    setChecker($(this), checked);
                });

                updateCheckerUp(node.parent().closest('.h-checktree-node'));
            }

            function updateCheckerUp(node) {
                if (node.length > 0) {
                    updateChecker(node);
                    updateCheckerUp(node.parent().closest('.h-checktree-node'));
                }
            }

            function updateChecker(node) {
                var children = node.find('> .h-checktree-children').children('.h-checktree-node');

                var checked = 0;
                var unchecked = 0;
                var total = children.length;

                children.each(function () {
                    var data = $(this).data('checked');
                    if (data === 'checked') {
                        checked++;
                    } else if (data === 'unchecked') {
                        unchecked++;
                    }
                });

                if (checked === total) {
                    node.data('checked', 'checked');
                    node.find('> .h-checktree-item .h-checktree-checker').html(H.getSprite(settings.icons.checked));
                } else if (unchecked === total) {
                    node.data('checked', 'unchecked');
                    node.find('> .h-checktree-item .h-checktree-checker').html(H.getSprite(settings.icons.unchecked));
                } else {
                    node.data('checked', 'indeterminate');
                    node.find('> .h-checktree-item .h-checktree-checker').html(H.getSprite(settings.icons.indeterminate));
                }
            }

            function nextVisibleNode(node) {
                var result = node.find('.h-checktree-node:not(:hidden)').first();
                if (result.length === 0) {
                    result = node.next();
                }
                if (result.length === 0) {
                    result = node.parent().closest('.h-checktree-node').next();
                }

                return result;
            }

            function prevVisibleNode(node) {
                var result = node.prev().find('.h-checktree-node:not(:hidden)').last();
                if (result.length === 0) {
                    result = node.prev();
                }
                if (result.length === 0) {
                    result = node.parent().closest('.h-checktree-node');
                }

                return result;
            }

            function isInViewport(node) {
                var nodeRect = node.find('> .h-checktree-item').get(0).getBoundingClientRect();
                var treeRect = tree.get(0).getBoundingClientRect();

                return (nodeRect.top > treeRect.top && nodeRect.bottom < treeRect.bottom);
            }

            function scrollNodeIntoView(node, direction) {
                var item = node.find('> .h-checktree-item').get(0);
                var itemRect = item.getBoundingClientRect();
                var treeRect = tree.get(0).getBoundingClientRect();

                if (itemRect.top < treeRect.top || itemRect.bottom > treeRect.bottom) {
                    item.scrollIntoView(direction === 'top');
                }
            }

            function updateChildCount() {
                if (settings.showChildCount) {
                    tree.find('.h-checktree-node').each(function () {
                        var children = $(this).find('> .h-checktree-children > .h-checktree-node');
                        if (children.length > 0) {
                            $(this).find('> .h-checktree-item .h-checktree-childcount').text('(' + children.length + ')');
                        } else {
                            $(this).find('> .h-checktree-item .h-checktree-childcount').text('');
                        }
                    });
                }
            }

            tree.off();

            tree.on('click', '.h-checktree-expander', function () {
                if (!tree.hasClass('h-disabled')) {
                    $(this).closest('.h-checktree-node').toggleClass('h-expanded');
                }
            });

            tree.on('click', '.h-checktree-node .h-checktree-checker', function () {
                if (!tree.hasClass('h-disabled') && !tree.hasClass('h-readonly')) {
                    var node = $(this).closest('.h-checktree-node');
                    if (!node.hasClass('h-disabled')) {
                        setChecker(node, node.data('checked') !== 'checked');
                        select(node);
                    }
                }
            });

            tree.on('click', '.h-checktree-node .h-checktree-content', function () {
                if (!tree.hasClass('h-disabled')) {
                    var node = $(this).closest('.h-checktree-node');
                    trigger('click', { node: node, cargo: node.data('cargo') });
                }
            });

            tree.on('click', '.h-checktree-node.h-selectable .h-checktree-content', function () {
                if (!tree.hasClass('h-disabled')) {
                    select($(this).closest('.h-checktree-node'));
                }
            });

            tree.on('keydown', function (e) {
                if (!tree.hasClass('h-disabled')) {
                    var selected;
                    var next;

                    switch (e.which) {
                        case 38: //UP
                            selected = tree.find('.h-checktree-node.h-selected');
                            if (selected.length === 1) {
                                var prev = prevVisibleNode(selected);
                                if (prev.length === 1) {
                                    select(prev);
                                    scrollNodeIntoView(prev, 'top');
                                }
                                e.preventDefault();
                            }
                            break;
                        case 40: //DOWN
                            selected = tree.find('.h-checktree-node.h-selected');
                            if (selected.length === 1) {
                                next = nextVisibleNode(selected);
                                if (next.length === 1) {
                                    select(next);
                                    scrollNodeIntoView(next, 'bottom');
                                }
                                e.preventDefault();
                            }
                            break;
                        case 37: //LEFT
                            selected = tree.find('.h-checktree-node.h-selected');
                            if (selected.length === 1) {
                                if (selected.hasClass('h-expanded')) {
                                    if (settings.collapsable) {
                                        collapse(selected);
                                    }
                                } else if (selected.find('> .h-checktree-children .h-checktree-node').length === 0 || !selected.hasClass('h-expanded')) {
                                    var parent = selected.parent().closest('.h-checktree-node');
                                    if (parent.length === 1) {
                                        select(parent);
                                    }
                                }
                                e.preventDefault();
                            }
                            break;
                        case 39: //RIGHT
                            selected = tree.find('.h-checktree-node.h-selected');
                            if (selected.length === 1 && selected.find('> .h-checktree-children .h-checktree-node').length > 0) {
                                if (!selected.hasClass('h-expanded')) {
                                    if (settings.collapsable) {
                                        expand(selected);
                                    }
                                } else {
                                    next = nextVisibleNode(selected);
                                    if (next.length === 1) {
                                        select(next);
                                        next.focus();
                                    }
                                }
                                e.preventDefault();
                            }
                            break;
                        case 36: //HOME
                            selected = tree.find('.h-checktree-node.h-selected');
                            if (selected.length === 1) {
                                var first = tree.find('.h-checktree-node:not(:hidden)').first();
                                if (first.length === 1) {
                                    select(first);
                                    scrollNodeIntoView(first, 'top');
                                }
                                e.preventDefault();
                            }
                            break;
                        case 35: //END
                            selected = tree.find('.h-checktree-node.h-selected');
                            if (selected.length === 1) {
                                var last = tree.find('.h-checktree-node:not(:hidden)').last();
                                if (last.length === 1) {
                                    select(last);
                                    scrollNodeIntoView(last, 'bottom');
                                }
                            }
                    }
                }
            });

            tree.on('drop', function (e, ui) {
                if (!tree.hasClass('h-disabled')) {
                    var node = $(e.target).closest('.h-checktree-node');
                    var parentNode = node.parent().closest('.h-checktree-node');
                    var event = $(e.target).hasClass('h-checktree-dropbetween') ? 'dropbetween' : 'drop';
                    trigger(event, { node: node, parentNode: parentNode, nodeData: node.data('cargo'), dragNode: dragInfo.node, dragData: dragInfo.data, internal: dragInfo.internal });
                }
            });

            tree.empty();
            tree.addClass('h-checktree');
            if (settings.readonly) {
                tree.addClass('h-readonly');
            }
            addNodes(null, Array.isArray(data) ? data : [data]);
            on('candrop', function () {
                return true && !tree.hasClass('h-disabled');
            });

            return {
                on: on,
                add: add,
                insert: insert,
                move: move,
                get: get,
                getParent: getParent,
                getChildren: getChildren,
                getRootNodes: getRootNodes,
                getAllNodes: getAllNodes,
                getChecked: getChecked,
                check: check,
                select: select,
                remove: remove,
                expand: expand,
                collapse: collapse,
                setDragData: setDragData,
                clearDragData: clearDragData,
                disable: disable,
                enable: enable
            };
        })(this);
    };
})(jQuery);
(function ($) {
    'use strict';

    var ControlFactory = (function () {
        var checkbox = function(label, checked) {
            var uid = H.uniqueId();

            var hcontainer = $('<div>', { style: 'display: flex; align-items: center; margin-top: 5px' });
            var hinput = $('<input>', { type: 'checkbox', style: 'margin: 0 3px 0 0', id: uid }).prop('checked', checked === true);
            var hlabel = $('<label>', { for: uid }).html(label);
            hcontainer.append(hinput).append(hlabel);

            return {
                container: hcontainer,
                input: hinput,
                label: hlabel
            };
        };

        var radio = function (name, label, checked) {
            var uid = H.uniqueId();

            var hcontainer = $('<div>', { style: 'display: flex; align-items: center' });
            var hinput = $('<input>', { type: 'radio', style: 'margin: 0 3px 0 0', id: uid, name: name }).prop('checked', checked === true);
            var hlabel = $('<label>', { for: uid }).html(label);
            hcontainer.append(hinput).append(hlabel);

            return {
                container: hcontainer,
                input: hinput,
                label: hlabel
            };
        };

        var select = function (items, selected, options) {
            var defaultOptions = {
                initiallyEmpty: false,
                topMargin: 0,
                label: false
            };

            var settings = $.extend(true, {}, defaultOptions, options);

            var style = 'margin-top: ' + settings.topMargin + 'px';
            var hcontainer = $('<div>', {style: style });

            if (settings.label) {
                hcontainer.append($('<label>', { style: 'font-weight: bold; margin-bottom: 2px' }).html(settings.label));
            }

            var hselectcontainer = $('<div>');
            hcontainer.append(hselectcontainer);

            var hselect = $('<select>', { id: H.uniqueId() });
            hselectcontainer.append(hselect);

            if (settings.initiallyEmpty) {
                hselect.append($('<option>'));
            }
            items.forEach(function (item) {
                if (item.group) {
                    var hgroup = $('<optgroup>', { label: item.group });
                    item.items.forEach(function (subitem) {
                        var option = $('<option>', { value: subitem.value }).html(subitem.text).prop('selected', subitem.value === selected);
                        if (subitem.cargo) {
                            option.data('cargo', subitem.cargo);
                        }
                        hgroup.append(option);
                    });
                    hselect.append(hgroup);
                } else {
                    var option = $('<option>', { value: item.value }).html(item.text).prop('selected', item.value === selected);
                    if (item.cargo) {
                        option.data('cargo', item.cargo);
                    }
                    hselect.append(option);
                }
            });

            return {
                container: hcontainer,
                selectContainer: hselectcontainer,
                select: hselect,
                validate: function() {
                    hselectcontainer.toggleClass('h-ee-invalid', hselect.val() === '');
                },
                cargo: function () {
                    var selected = hselect.select2('data');
                    if (selected.length === 1) {
                        return $(selected[0].element).data('cargo');
                    }
                    return null;
                }
            };
        };

        var grid = function (columns, rows) {
            var hcells = [];
            var csizes = [];
            var i, j;
            for (i = 0; i < columns; i++) {
                csizes.push('auto');
            }
            csizes = csizes.join(' ');
            var rsizes = [];
            for (j = 0; j < rows; j++) {
                rsizes.push('auto');
            }
            rsizes = rsizes.join(' ');
            var gridstyle = [
                'display: -ms-grid',
                'display: grid',
                '-ms-grid-columns: ' + csizes,
                'grid-template-columns: ' + csizes,
                '-ms-grid-rows: ' + rsizes,
                'grid-template-rows: ' + rsizes,
                'align-items: center'
            ];

            var hgrid = $('<div>', { style: gridstyle.join(';') });

            for (i = 0; i < columns; i++) {
                hcells.push([]);
                for (j = 0; j < rows; j++) {
                    var cellstyle = [
                        '-ms-grid-column: ' + (i + 1),
                        'grid-column-start: ' + (i + 1),
                        '-ms-grid-row: ' + (j + 1),
                        'grid-row-start: ' + (j + 1)
                    ];
                    if (i > 0) {
                        cellstyle.push('margin-left: 5px');
                    }
                    if (j > 0) {
                        cellstyle.push('margin-top: 5px');
                    }
                    var hcell = $('<div>', { style: cellstyle.join(';') });
                    hgrid.append(hcell);
                    hcells[i].push(hcell);
                }
            }

            return {
                grid: hgrid,
                cells: hcells
            };
        };

        return {
            checkbox: checkbox,
            radio: radio,
            select: select,
            grid: grid
        };
    })();

    var constRefs;
    var periods;
    var aggPeriods;
    var aggFunctions;
    var aggLevels;
    var dataItems;
    var gisObjects;
    var dataTypes; //TODO: Indeholder en oversat liste af kildedata typer, altså om det er rådata eller en variabel. Bliver ikke præsenteret nogen steder lige nu.

    var Formula = (function () {
        var rootNode;
        var redraw;
        var translations;

        var NodeDefs = {
            defs: [
                { id: 1, type: 'arithmetic', arity: 2, caption: '', parameters: { operator: '+' } },
                { id: 2, type: 'arithmetic', arity: 2, caption: '', parameters: { operator: '-' } },
                { id: 3, type: 'arithmetic', arity: 2, caption: '', parameters: { operator: '*' } },
                { id: 4, type: 'arithmetic', arity: 2, caption: '', parameters: { operator: '/' } },
                { id: 5, type: 'arithmetic', arity: 2, caption: '', parameters: { operator: '%' } },
                { id: 6, type: 'data', arity: 0, caption: '', parameters: null },
                { id: 7, type: 'const', arity: 0, caption: '', parameters: null },
                { id: 8, type: 'constref', arity: 0, caption: '', parameters: null },
                { id: 9, type: 'aggc', arity: 1, caption: '', parameters: null },
                { id: 10, type: 'aggt', arity: 1, caption: '', parameters: null },
                { id: 11, type: 'ctxgisobj', arity: 1, caption: '', parameters: null }
                //{ id: 12, type: 'ctxparent', arity: 1, caption: '', parameters: null }
            ],
            get: function(id) {
                for (var i = 0; i < this.defs.length; i++) {
                    if (this.defs[i].id === id) {
                        return this.defs[i];
                    }
                }
                return null;
            },
            list: function () {
                return this.defs;
            }
        };

        function Node(type, arity) {
            this.type = type;
            this.parameters = null;
            this.children = arity === 2 ? [null, null] : (arity === 1 ? [null] : []);
            this.parent = null;

            this.hnode = null;
            this.hcontent = null;
            this.hheader = null;
            this.hbody = null;
            this.hcaption = null;
        }
        Node.prototype.remove = function () {
            if (this === rootNode) {
                if (this.arity === 0) {
                    rootNode = new GenericNode();
                } else {
                    rootNode = this.children[0];
                    rootNode.parent = null;
                }
            } else {
                var idx = this.parent.children.indexOf(this);
                if (this.arity === 0) {
                    this.parent.children[idx] = null;
                } else {
                    this.parent.attach(this.children[0], idx);
                }
            }
            redraw();
        };
        Node.prototype.getParameters = function() {
            return this.parameters;
        };
        Node.prototype.attach = function (node, idx) {
            if (!idx) {
                idx = 0;
            }
            this.children[idx] = node;
            node.parent = this;
        };
        Object.defineProperty(Node.prototype, 'formula',
            {
                get: function () {
                    if (this.type === 'nop') {
                        return null;
                    }
                    var result = {
                        type: this.type,
                        parameters: this.getParameters()
                    };

                    if (this.arity > 0) {
                        result.children = [];
                        this.children.forEach(function (child) {
                            result.children.push(child.formula);
                        });
                    }

                    return result;
                }
            });
        Object.defineProperty(Node.prototype, 'arity',
            {
                get: function () {
                    return this.children.length;
                }
            });

        function GenericNode() {
            Node.call(this, 'nop', 0);
        }
        GenericNode.prototype = Object.create(Node.prototype);
        GenericNode.prototype.constructor = GenericNode;
        GenericNode.prototype.valid = function() {
            return false;
        };
        GenericNode.prototype.render = function () {
            var items = NodeDefs.list().map(function(item) {
                return { value: item.id, text: item.caption };
            });

            var hselect = ControlFactory.select(items, null, { initiallyEmpty: true });
            this.hbody.append(hselect.container);
            hselect.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1,
                placeholder: translations.selectOperation
            }).maximizeSelect2Height();

            var self = this;
            hselect.select.on('change', function () {
                var def = NodeDefs.get(parseInt($(this).val()));
                var node = createNode(def.type, def.parameters);
                if (self === rootNode) {
                    rootNode = node;
                } else {
                    var idx = self.parent.children.indexOf(self);
                    self.parent.attach(node, idx);
                }
            });
            hselect.select.on('select2:close', function() {
                redraw();
            });
        };

        function ArithmeticNode() {
            Node.call(this, 'arithmetic', 2);
            this.parameters = {
                operator: '+'
            };
        }
        ArithmeticNode.prototype = Object.create(Node.prototype);
        ArithmeticNode.prototype.constructor = ArithmeticNode;
        ArithmeticNode.prototype.valid = function () {
            return true;
        };
        ArithmeticNode.prototype.render = function () {
            this.hcaption.html(translations.arithmeticOperation);

            var items = [
                { value: '+', text: translations.arithmeticPlus },
                { value: '-', text: translations.arithmeticMinus },
                { value: '*', text: translations.arithmeticMul },
                { value: '/', text: translations.arithmeticDiv },
                { value: '%', text: translations.arithmeticMod }
            ];

            var hselect = ControlFactory.select(items, this.parameters.operator);

            this.hbody.append(hselect.container);
            hselect.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1
            });
            var self = this;
            hselect.select.on('change', function () {
                self.parameters.operator = $(this).val();
            });
        };

        function ConstNode() {
            Node.call(this, 'const', 0);
            this.parameters = {
                value: 0
            };
        }
        ConstNode.prototype = Object.create(Node.prototype);
        ConstNode.prototype.constructor = ConstNode;
        ConstNode.prototype.valid = function () {
            return !isNaN(this.parameters.value);
        };
        ConstNode.prototype.render = function () {
            this.hcaption.html(translations.const);

            if (isNaN(this.parameters.value)) {
                this.parameters.value = 0;
            }

            var hcontainer = $('<div>');
            this.hbody.append(hcontainer);
            var hinput = $('<input>', { type: 'number', step: 'any', style: 'width: 75px' });
            hcontainer.append(hinput);
            hinput.val(this.parameters.value);
            var self = this;
            hinput.on('change', function () {
                self.parameters.value = parseFloat($(this).val());
                var valid = self.valid();
                if (valid) {
                    $(this).val(self.parameters.value);
                }
                hcontainer.toggleClass('h-ee-invalid', !valid);
            });
        };

        function ConstRefNode() {
            Node.call(this, 'constref', 0);
            this.parameters = {
                id: null
            };
        }
        ConstRefNode.prototype = Object.create(Node.prototype);
        ConstRefNode.prototype.constructor = ConstRefNode;
        ConstRefNode.prototype.valid = function () {
            return this.parameters.id !== null;
        };
        ConstRefNode.prototype.render = function () {
            this.hcaption.html(translations.constref);

            var self = this;

            var items = constRefs.map(function(constRef) {
                return {
                    value: constRef.id,
                    text: `${constRef.name} (${constRef.value})`
                };
            });

            var hselect = ControlFactory.select(items, this.parameters.id, { initiallyEmpty: true });
            this.hbody.append(hselect.container);
            hselect.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: 10
            });
            hselect.validate();
            hselect.select.on('change', function () {
                self.parameters.id = parseInt($(this).val());
                hselect.validate();
            });
        };

        function AggregationChildrenNode() {
            Node.call(this, 'aggc', 1);
            this.parameters = {
                func: aggFunctions[0].id,
                aggLevels: [],
                level: null,
                ignore: false
            };
        }
        AggregationChildrenNode.prototype = Object.create(Node.prototype);
        AggregationChildrenNode.prototype.constructor = AggregationChildrenNode;
        AggregationChildrenNode.prototype.valid = function () {
            return this.parameters.level !== null;
        };
        AggregationChildrenNode.prototype.render = function () {
            this.hcaption.html(translations.aggc);

            var self = this;

            var items = aggFunctions.map(function (aggFunc) {
                return {
                    text: aggFunc.name,
                    value: aggFunc.id
                };
            });

            var hfunc = ControlFactory.select(items, this.parameters.func, { label: translations.function });

            this.hbody.append(hfunc.container);
            hfunc.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1,
                width: '100%'
            });
            hfunc.select.on('change', function () {
                self.parameters.func = parseInt($(this).val());
            });

            var checkboxes = [];

            this.hbody.append($('<label>', { style: 'font-weight: bold; margin-top: 3px; margin-bottom: 2px' }).html(translations.aggregationLevels));
            aggLevels.forEach(function (l, i) {
                var disabled = l.id < self.parameters.level;
                var hcheckbox = ControlFactory.checkbox(l.name, !disabled && self.parameters.aggLevels.includes(l.id));
                hcheckbox.container.css('margin-left', '10px');
                hcheckbox.input.data('level', l.id);
                hcheckbox.input.prop('disabled', disabled);
                hcheckbox.input.on('change', function () {
                    var levelId = $(this).data('level');
                    if ($(this).prop('checked')) {
                        if (!self.parameters.aggLevels.includes(levelId)) {
                            self.parameters.aggLevels.push(levelId);
                        }
                    } else {
                        if (self.parameters.aggLevels.includes(levelId)) {
                            self.parameters.aggLevels.splice(self.parameters.aggLevels.indexOf(levelId), 1);
                        }
                    }
                });
                self.hbody.append(hcheckbox.container);
                checkboxes.push(hcheckbox);
            });

            items = aggLevels.filter(function (level, idx) {
                return idx > 0;
            }).map(function (level) {
                return { text: level.name, value: level.id };
            });

            var hlevel = ControlFactory.select(items, this.parameters.level, { initiallyEmpty: true, topMargin: 5, label: translations.aggregationChildLevel });
            this.hbody.append(hlevel.container);
            hlevel.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1,
                width: '100%',
                placeholder: translations.selectLevel
            });
            hlevel.validate();
            hlevel.select.on('change', function () {
                self.parameters.level = parseInt($(this).val());
                hlevel.validate();

                checkboxes.forEach(function (c) {
                    var disabled = parseInt(c.input.data('level')) < self.parameters.level;
                    c.input.prop('disabled', disabled);
                    if (disabled) {
                        c.input.prop('checked', false);
                        var levelId = $(c.input).data('level');
                        if (self.parameters.aggLevels.includes(levelId)) {
                            self.parameters.aggLevels.splice(self.parameters.aggLevels.indexOf(levelId), 1);
                        }
                    }
                });
            });

            var hcheckbox = ControlFactory.checkbox(translations.ignoreMissingValues, this.parameters.ignore);
            this.hbody.append(hcheckbox.container);

            hcheckbox.input.on('change', function () {
                self.parameters.ignore = $(this).prop('checked');
            });
        };

        function AggregationTimeNode() {
            Node.call(this, 'aggt', 1);
            this.parameters = {
                func: aggFunctions[0].id,
                period: null,
                subperiod: null,
                ignore: false
            };
        }
        AggregationTimeNode.prototype = Object.create(Node.prototype);
        AggregationTimeNode.prototype.constructor = AggregationTimeNode;
        AggregationTimeNode.prototype.valid = function () {
            return this.parameters.period !== null;
        };
        AggregationTimeNode.prototype.render = function () {
            this.hcaption.html(translations.aggt);

            var self = this;

            var items = aggFunctions.map(function(aggFunc) {
                return {
                    text: aggFunc.name,
                    value: aggFunc.id
                };
            });

            var hfunc = ControlFactory.select(items, this.parameters.func, { label: translations.function });
            this.hbody.append(hfunc.container);
            hfunc.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1,
                width: '100%'
            });
            hfunc.select.on('change', function () {
                self.parameters.func = parseInt($(this).val());
            });

            items = aggPeriods.map(function(period) {
                return {
                    text: period.name,
                    value: period.id
                };
            });

            var hperiod = ControlFactory.select(items, this.parameters.period, { initiallyEmpty: true, topMargin: 5, label: translations.aggregationPeriod });
            this.hbody.append(hperiod.container);

            hperiod.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1,
                width: '100%',
                placeholder: translations.selectPeriod
            });

            items = periods.map(function (period) {
                return {
                    text: period.name,
                    value: period.id
                };
            });
            var hsubperiod = ControlFactory.select(items, this.parameters.subperiod, { initiallyEmpty: true, topMargin: 5, label: translations.aggregationChildPeriod });
            this.hbody.append(hsubperiod.container);

            hsubperiod.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1,
                width: '100%',
                placeholder: translations.selectPeriod
            });
            hsubperiod.validate();

            hperiod.validate = function () {
                var valid = hperiod.select.val() !== '';
                if (valid) {
                    valid = hperiod.select.val() > hsubperiod.select.val();
                }
                hperiod.selectContainer.toggleClass('h-ee-invalid', !valid);
            };
            hperiod.validate();

            hperiod.select.on('change', function () {
                self.parameters.period = parseInt($(this).val());
                hperiod.validate();
            });

            hsubperiod.select.on('change', function () {
                self.parameters.subperiod = parseInt($(this).val());
                hperiod.validate();
                hsubperiod.validate();
            });

            var hcheckbox = ControlFactory.checkbox(translations.ignoreMissingValues, this.parameters.ignore);
            this.hbody.append(hcheckbox.container);

            hcheckbox.input.on('change', function () {
                self.parameters.ignore = $(this).prop('checked');
            });
        };

        function ContextGisObjectNode() {
            Node.call(this, 'ctxgisobj', 1);
            this.parameters = {
                id: null
            };
        }
        ContextGisObjectNode.prototype = Object.create(Node.prototype);
        ContextGisObjectNode.prototype.constructor = ContextGisObjectNode;
        ContextGisObjectNode.prototype.valid = function () {
            return this.parameters.id !== null;
        };
        ContextGisObjectNode.prototype.render = function () {
            var self = this;

            this.hcaption.html(translations.ctxgisobj);

            var items = gisObjects.map(function(gisObject) {
                return {
                    group: gisObject.companyName,
                    items: gisObject.items.map(function(item) {
                        return { text: item.name, value: item.id };
                    })
                };
            });

            var hselect = ControlFactory.select(items, this.parameters.id, { initiallyEmpty: true });
            this.hbody.append(hselect.container);
            hselect.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: 10
            });
            hselect.validate();
            hselect.select.on('change', function () {
                self.parameters.id = parseInt($(this).val());
                hselect.validate();
            });
        };

        function ContextParentNode() {
            Node.call(this, 'ctxparent', 1);
            this.parameters = {
                mode: 'level',
                level: null,
                type: null
            };
        }
        ContextParentNode.prototype = Object.create(Node.prototype, 1);
        ContextParentNode.prototype.constructor = ContextParentNode;
        ContextParentNode.prototype.valid = function () {
            if (this.parameters.mode === 'level') {
                return this.parameters.level !== '';
            } else {
                return this.parameters.type !== null;
            }
        };
        ContextParentNode.prototype.render = function () {
            var self = this;

            this.hcaption.html(translations.ctxparent);

            var name = H.uniqueId();

            var hgrid = ControlFactory.grid(2, 2);

            var hradiolevel = ControlFactory.radio(name, translations.ofLevel, this.parameters.mode === 'level');
            hgrid.cells[0][0].append(hradiolevel.container);

            var hlevelinput = $('<input>', { type: 'number' });
            hlevelinput.val(this.parameters.level);
            if (this.parameters.mode !== 'level') {
                hlevelinput.prop('disabled', true);
            } else {
                hlevelinput.toggleClass('h-ee-invalid', hlevelinput.val() === '');
            }

            hgrid.cells[1][0].append(hlevelinput);

            var hradiotype = ControlFactory.radio(name, translations.ofType, this.parameters.mode === 'type');
            hgrid.cells[0][1].append(hradiotype.container);

            var items = aggLevels.map(function (l) {
                return { value: l.id, text: l.name };
            });

            var htypeselect = ControlFactory.select(items, this.parameters.type, { initiallyEmpty: true });
            hgrid.cells[1][1].append(htypeselect.container);

            htypeselect.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: -1,
                width: '100%',
                placeholder: translations.selectLevel
            });
            if (this.parameters.mode !== 'type') {
                htypeselect.select.prop('disabled', true);
            } else {
                htypeselect.validate();
            }

            this.hbody.append(hgrid.grid);

            hradiolevel.input.on('change', function () {
                self.parameters.mode = 'level';
                hlevelinput.prop('disabled', false);
                htypeselect.select.prop('disabled', true);
                hlevelinput.toggleClass('h-ee-invalid', hlevelinput.val() === '');
                htypeselect.container.removeClass('h-ee-invalid');
            });
            hradiotype.input.on('change', function () {
                self.parameters.mode = 'type';
                hlevelinput.prop('disabled', true);
                htypeselect.select.prop('disabled', false);
                hlevelinput.removeClass('h-ee-invalid');
                htypeselect.validate();
            });

            hlevelinput.on('change', function () {
                self.parameters.level = parseInt($(this).val());
                $(this).toggleClass('h-ee-invalid', $(this).val() === '');
            });

            htypeselect.select.on('change', function () {
                self.parameters.type = parseInt($(this).val());
                htypeselect.validate();
            });
        };

        function DataNode() {
            Node.call(this, 'data', 0);
            this.parameters = {
                id: null,
                type: null,
                latest: true
            };
        }
        DataNode.prototype = Object.create(Node.prototype);
        DataNode.prototype.constructor = DataNode;
        DataNode.prototype.valid = function () {
            return this.parameters.id !== null;
        };
        DataNode.prototype.render = function () {
            var self = this;

            this.hcaption.html(translations.data);

            var items = dataItems.map(function(dataItem) {
                return {
                    group: dataItem.companyName,
                    items: dataItem.items.map(function (item) {
                        return { value: item.type + '-' + item.id, text: item.name, cargo: item };
                    })
                };
            });

            function renderOption(item) {
                if (item.id) {
                    return $('<div>', { class: 'h-ee-datanode-option' })
                        .append($(H.getSprite($(item.element).data('cargo').type === 1 ? 'binary' : 'sigma', 'h-ee-datanode-svg')))
                        .append($('<span>', { style: 'margin-left: 5px'}).html(item.text));
                }
                return item.text;
            }
            
            var hselect = ControlFactory.select(items, this.parameters.type + '-' + this.parameters.id, { initiallyEmpty: true });
            this.hbody.append(hselect.container);
            hselect.select.select2({
                language: vstore.user.cultureCode,
                minimumResultsForSearch: 10,
                placeholder: translations.selectData,
                templateResult: renderOption,
                templateSelection: renderOption
            });
            hselect.validate();
            hselect.select.on('change', function () {
                self.parameters.id = parseInt($(this).val().substring($(this).val().indexOf('-')+1));
                self.parameters.type = hselect.cargo().type;

                hselect.validate();
            });

            var hcheckbox = ControlFactory.checkbox(translations.latestValue, this.parameters.latest);
            this.hbody.append(hcheckbox.container);

            hcheckbox.input.on('change', function () {
                self.parameters.latest = $(this).prop('checked');
            });
        };

        var root = function (node) {
            if (node) {
                rootNode = node;
            }
            return rootNode;
        };

        var createNode = function (type, parameters) {
            var result;

            switch (type) {
            case 'arithmetic':
                result = new ArithmeticNode();
                break;
            case 'aggc':
                result = new AggregationChildrenNode();
                break;
            case 'aggt':
                result = new AggregationTimeNode();
                break;
            case 'data':
                result = new DataNode();
                break;
            case 'const':
                result = new ConstNode();
                break;
            case 'constref':
                result = new ConstRefNode();
                break;
            case 'ctxgisobj':
                result = new ContextGisObjectNode();
                break;
            case 'ctxparent':
                result = new ContextParentNode();
                break;
            default:
                result = new GenericNode();
            }
            result.parameters = $.extend(result.parameters, parameters);
            return result;
        };

        var init = function(cb, tl) {
            redraw = cb;
            translations = tl;

            NodeDefs.get(1).caption = translations.arithmeticPlus;
            NodeDefs.get(2).caption = translations.arithmeticMinus;
            NodeDefs.get(3).caption = translations.arithmeticMul;
            NodeDefs.get(4).caption = translations.arithmeticDiv;
            NodeDefs.get(5).caption = translations.arithmeticMod;
            NodeDefs.get(6).caption = translations.data;
            NodeDefs.get(7).caption = translations.const;
            NodeDefs.get(8).caption = translations.constref;
            NodeDefs.get(9).caption = translations.aggc;
            NodeDefs.get(10).caption = translations.aggt;
            NodeDefs.get(11).caption = translations.ctxgisobj;
            //NodeDefs.get(12).caption = translations.ctxparent;
        };

        var get = function () {
            return JSON.stringify(rootNode.formula);
        };

        const getAsObject = () => {
            return rootNode.formula;
        };

        var set = function (json) {
            function createNodeRecursive(formula) {
                var result;
                if (formula === null) {
                    result = createNode();
                } else {
                    result = createNode(formula.type, formula.parameters);
                    if (formula.children) {
                        formula.children.forEach(function(child, idx) {
                            result.attach(createNodeRecursive(child), idx);
                        });
                    }
                }
                return result;
            }

            rootNode = createNodeRecursive(JSON.parse(json));
        };

        var valid = function () {
            function isValid(node) {
                if (node.valid()) {
                    for (var i = 0; i < node.children.length; i++) {
                        if (!isValid(node.children[i])) {
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            }

            return isValid(rootNode);
        };

        var defs = function() {
            return NodeDefs;
        };

        return {
            init: init,
            get: get,
            getAsObject: getAsObject,
            set: set,
            root: root,
            createNode: createNode,
            defs: defs,
            valid: valid
        };
    })();

    $.fn.hexpressioneditor = function (translations) {
        return (function (tree) {
            function addSvgChild(parent, child) {
                var result = document.createElementNS('http://www.w3.org/2000/svg', child);
                parent.appendChild(result);

                return result;
            }

            function setSvgAttribute(element, attribute, value) {
                element.setAttributeNS(null, attribute, value);
            }

            function getMeasures(el) {
                var pos = el.offset();
                return {
                    left: pos.left,
                    top: pos.top,
                    width: el.outerWidth(),
                    height: el.outerHeight()
                };
            }

            function addAddSvg(svg, x, y, cls) {
                var g = addSvgChild(svg, 'g');
                var c = addSvgChild(g, 'circle');
                setSvgAttribute(c, 'r', 7.5);

                var p = addSvgChild(g, 'path');
                setSvgAttribute(p, 'd', 'M 0 -4 L 0 4 M -4 0 L 4 0');
                setSvgAttribute(g, 'transform', 'translate(' + x + ',' + y + ')');
                setSvgAttribute(g, 'class', cls);

                return g;
            }

            function addSwapSvg(svg, x, y, cls) {
                var g = addSvgChild(svg, 'g');
                var c = addSvgChild(g, 'rect');
                setSvgAttribute(c, 'x', -5);
                setSvgAttribute(c, 'y', -5);
                setSvgAttribute(c, 'width', 10);
                setSvgAttribute(c, 'height', 10);
                setSvgAttribute(c, 'fill', 'transparent');
                setSvgAttribute(c, 'stroke', 'transparent');

                var p = addSvgChild(g, 'path');
                setSvgAttribute(p, 'd', 'M -4 -3 L 4 -3 M -4 3 L 4 3');
                p = addSvgChild(g, 'path');
                setSvgAttribute(p, 'd', 'M -5 -3 L -3 -4 L -3 -2 Z');
                p = addSvgChild(g, 'path');
                setSvgAttribute(p, 'd', 'M 5 3 L 3 4 L 3 2 Z');
                setSvgAttribute(g, 'transform', 'translate(' + x + ',' + y + ')');
                setSvgAttribute(g, 'class', cls);

                return g;
            }

            function addOrInsert(parent, parentIdx, child, x, y) {
                var hinsert = $('<div>', { style: 'position: absolute' });

                var items = Formula.defs().list().filter(function(item) {
                    return item.arity > 0;
                }).map(function(item) {
                    return { value: item.id, text: item.caption };
                });

                var hselect = ControlFactory.select(items, null, { initiallyEmpty: true });
                hinsert.append(hselect.container);
                tree.append(hinsert);
                hselect.select.select2({
                    language: vstore.user.cultureCode,
                    minimumResultsForSearch: -1,
                    placeholder: translations.selectOperation
                });
                var l = Math.max(x - (hinsert.outerWidth() / 2), 0);
                //if (l > 0 && l + hinsert.outerWidth() > tree.closest('.h-tab').width()) {
                //    l = tree.closest('.h-tab').width() - hinsert.width();
                //}
                
                hinsert.css('left', l);
                hinsert.css('top', y - (hinsert.outerHeight() / 2));
                hselect.select.select2('open');
                hselect.select.on('change', function () {
                    var def = Formula.defs().get(parseInt($(this).val()));

                    var insertNode = Formula.createNode(def.type, def.parameters);
                    insertNode.attach(child, 0);
                    if (parent) {
                        parent.attach(insertNode, parentIdx);
                    } else {
                        Formula.root(insertNode);
                    }
                });
                hselect.select.on('select2:close', function () {
                    hinsert.remove();
                    render();
                });
            }

            function renderConnections(svglayer, node) {

                var nodeSize = getMeasures(node.hcontent);
                var parentX;
                var parentY;

                if (node.parent === null) {
                    var connection = addSvgChild(svglayer.svg, 'path');
                    parentX = nodeSize.left - svglayer.size.left + nodeSize.width / 2;
                    parentY = nodeSize.top - svglayer.size.top;
                    var childX = parentX;
                    var childY = parentY - 30;

                    var d = 'M ' + parentX + ' ' + parentY + ' L ' + childX + ' ' + childY;

                    setSvgAttribute(connection, 'd', d);
                    setSvgAttribute(connection, 'stroke', 'black');
                    setSvgAttribute(connection, 'stroke-width', 1);

                    var aicon = addAddSvg(svglayer.svg, childX, childY - 7.5, 'h-ee-add');

                    $(aicon).on('click', function() {
                        addOrInsert(null, null, node, childX, childY - 3);
                    });
                }

                parentX = nodeSize.left - svglayer.size.left + nodeSize.width / 2;
                parentY = nodeSize.top - svglayer.size.top + nodeSize.height;

                node.children.forEach(function (child, idx) {
                    if (child) {
                        var childSize = getMeasures(child.hcontent);
                        var connection = addSvgChild(svglayer.svg, 'path');
                        var childX = childSize.left - svglayer.size.left + childSize.width / 2;
                        var childY = childSize.top - svglayer.size.top;

                        var d = 'M ' + parentX + ' ' + parentY + ' L ' + childX + ' ' + childY;

                        setSvgAttribute(connection, 'd', d);
                        setSvgAttribute(connection, 'stroke', 'black');
                        setSvgAttribute(connection, 'stroke-width', 1);

                        var iicon = addAddSvg(svglayer.svg, (parentX + childX) / 2, (parentY + childY) / 2, 'h-ee-insert');

                        $(iicon).on('click', function () {
                            addOrInsert(node, idx, child, (parentX + childX) / 2, (parentY + childY) / 2);
                        });

                        renderConnections(svglayer, child);
                    }
                });

                if (node.arity === 2) {
                    var icon = addSwapSvg(svglayer.svg, parentX, parentY + 10, 'h-ee-swap');
                    $(icon).on('click', function() {
                        var left = node.children[0];
                        node.children[0] = node.children[1];
                        node.children[1] = left;
                        render();
                    });
                }
            }

            function renderNode(hcontainer, node) {
                node.hnode = $('<div>', { class: 'h-ee-node' });
                if (node === Formula.root()) {
                    node.hnode.addClass('h-ee-node-root');
                }

                if (node.type === 'nop') {
                    node.hnode.addClass('h-ee-node-generic');
                }
                hcontainer.append(node.hnode);

                node.hcontent = $('<div>', { class: 'h-ee-node-content h-ee-node-content-exp' });
                node.hnode.append(node.hcontent);

                if (node.type !== 'nop') {
                    node.hheader = $('<div>', { class: 'h-ee-node-content-header' });
                    node.hcontent.append(node.hheader);

                    node.hcaption = $('<div>', { class: 'h-ee-node-content-caption' });
                    node.hheader.append(node.hcaption);

                    var hdelete = $('<div>', { class: 'h-ee-node-content-delete' }).append(H.getSprite('bin'));
                    node.hheader.append(hdelete);

                    hdelete.on('click', function () {
                        hmodal.open({
                            header: translations.deleteExpression,
                            content: translations.confirmDeleteExpression,
                            accept: translations.yes,
                            reject: translations.no
                        }, function(e) {
                            if (e.accept) {
                                node.remove();
                            }
                        });
                    });
                }

                node.hbody = $('<div>', { class: 'h-ee-node-content-body' });
                node.hcontent.append(node.hbody);

                node.render();

                if (node.arity > 0) {
                    var hchildren = $('<div>', { class: 'h-ee-nodes' });
                    node.hnode.append(hchildren);

                    node.children.forEach(function (child, idx) {
                        if (!child) {
                            child = Formula.createNode();
                            node.attach(child, idx);
                        }
                        renderNode(hchildren, child);
                    });
                }
            }

            var render = function () {
                tree.empty();

                var hconnections = $('<svg xmlns="http://www.w3.org/2000/svg"></svg>');
                hconnections.addClass('h-ee-connections');
                tree.append(hconnections);

                renderNode(tree, Formula.root());

                setSvgAttribute(hconnections.get(0), 'viewBox', '0 0 ' + hconnections.width() + ' ' + hconnections.height());

                var svglayer = {
                    svg: hconnections.get(0),
                    size: getMeasures(tree)
                };

                renderConnections(svglayer, Formula.root());
            };

            var getFormula = function () {
                return Formula.get();
            };

            const getFormulaAsObject = () => {
                return Formula.getAsObject();
            };

            var setFormula = function (json) {
                Formula.set(json);
            };

            var validate = function() {
                return Formula.valid();
            };

            var setConstRefs = function(value) {
                constRefs = value;
            };

            var setLookups = function (lookups) {
                dataItems = lookups.dataDelegates;
                periods = lookups.periods;
                aggPeriods = lookups.aggregationPeriods;
                aggFunctions = lookups.aggregationFunctions;
                aggLevels = lookups.aggregationGisObjectTypes;
                gisObjects = lookups.gisObjects;
                dataTypes = lookups.dataDelegateTypes;
            };

            tree.addClass('h-expressioneditor');

            Formula.init(render, translations);
            Formula.root(Formula.createNode());

            return {
                render: render,
                getFormula: getFormula,
                getFormulaAsObject: getFormulaAsObject,
                setFormula: setFormula,
                setConstRefs: setConstRefs,
                setLookups: setLookups,
                validate: validate
            };
        })(this);
    };
})(jQuery);

(function ($) {
    'use strict';

    $.fn.hform = function () {
        var hform = $(this);

        var validate = function (cb) {
            var result = true;
            hform.find('.h-form-group').removeClass('h-form-error');

            hform.find('input, textarea, select').each(function () {
                var errorMessage;
                if (this.checkValidity() === false) {
                    result = false;
                    var pm;

                    errorMessage = this.validationMessage;
                    if (this.validity.patternMismatch) {
                        pm = $(this).data('patternmismatch');
                        if (pm) {
                            errorMessage = pm;
                        }
                    } else if (this.validity.valueMissing) {
                        pm = $(this).data('valuemissing');
                        if (pm) {
                            errorMessage = pm;
                        }
                    } else if (this.validity.typeMismatch) {
                        pm = $(this).data('typemismatch');
                        if (pm) {
                            errorMessage = pm;
                        }
                    }

                    var hint = null;
                    if (errorMessage !== this.validationMessage) {
                        hint = this.validationMessage;
                    }

                    updateErrorMessage($(this), 'set', errorMessage, hint);
                }
            });

            if (cb) {
                result = cb() && result;
            }

            return result;
        };

        function updateErrorMessage(hinput, action, text, hint) {
            var hformgroup = hinput.parents('.h-form-group');
            var hmessage = hformgroup.find('.h-form-errormessage');
            switch (action) {
                case 'set':
                    hformgroup.addClass('h-form-error');
                    hmessage.html(text);
                    if (hint) {
                        hmessage.attr('title', hint);
                    }
                    break;
                case 'clear':
                    hformgroup.removeClass('h-form-error');
                    hmessage.empty();
                    break;
            }
        }

        var setErrorMessage = function(selector, text) {
            updateErrorMessage(hform.find(selector), 'set', text);
        };

        var clearErrorMessage = function(selector) {
            updateErrorMessage(hform.find(selector), 'clear');
        };

        var hblock = null;
        var blockers = 0;
        var blockInput = function (enable) {
            if (enable) {
                blockers++;
                if (hblock === null) {
                    hform.addClass('h-form-blocked');
                    hblock = $('<div>', { class: 'h-form-blocker' });
                    hblock.append(H.getSpinner(100));
                    hform.append(hblock);
                }
            } else {
                if (hblock !== null) {
                    blockers--;
                    if (blockers === 0) {
                        hform.removeClass('h-form-blocked');
                        hblock.remove();
                        hblock = null;
                    }
                }
            }
        };

        return {
            validate: validate,
            setErrorMessage: setErrorMessage,
            clearErrorMessage: clearErrorMessage,
            blockInput: blockInput
        };
    };
})(jQuery);

(function ($) {
    'use strict';

    $.fn.hlisttable = function (options) {
        var defaults = {
            compact: false,
            sortable: false,
            selectable: false,
            checkable: false,
            checkAllRowIndex: 0,
            placeholder: false,
            spinner: false,
            fixedHeader: false,
            icons: {
                sort: '3dots',
                unchecked: 'checkbox-unchecked',
                checked: 'checkbox-checked'
            },
            pager: false
        };

        if (!this.hasClass('h-listtable')) {
            return null;
        }

        return (function (table) {
            var settings = $.extend(defaults, options);
            var hpager = null;
            var hplaceholder = null;
            var hspinner = null;
            var pageCount = 0;
            var currentPage = 1;

            var callbacks = [];

            var on = function (event, cb) {
                if (!Array.isArray(event)) {
                    event = [event];
                }
                event.forEach(function (e) {
                    if (['select', 'check', 'checkAll', 'sort', 'headsort', 'action', 'pager'].indexOf(e) > -1) {
                        callbacks.push({ event: e, cb: cb });
                    }
                });
            };

            function trigger(event, data) {
                var result = true;
                callbacks.filter(function (e) {
                    return e.event === event;
                }).forEach(function (value) {
                    var res = value.cb($.extend({ event: event }, data));
                    if (res === undefined || res === true) {
                        result = result && true;
                    } else {
                        result = false;
                    }
                });
                return result;
            }

            var setPageCount = function (count) {
                pageCount = count;

                if (pageCount === 0) {
                    hpager.closest('tr').hide();
                } else {
                    hpager.closest('tr').show();
                    setPage(0);
                }
            };

            if (settings.compact) {
                table.addClass('h-listtable-compact');
            }

            if (settings.fixedHeader) {
                table.addClass('h-listtable-fixedheader');
            }

            if (settings.selectable) {
                table.on('click', 'tbody tr', function () {
                    selectRow($(this).attr('id'));
                });
            }

            if (settings.checkable) {
                table.find('tbody tr').each(function () {
                    var column = $(this).find('td:not(.h-listtable-transparent)').first();
                    var checbox = $('<td>', { class: 'h-listtable-checkable' }).append($(this).data('checked') === true ? H.getSprite(settings.icons.checked) : H.getSprite(settings.icons.unchecked));
                    checbox.insertBefore(column);
                });
                var idx = table.find('tbody tr td:not(.h-listtable-transparent)').first().index();
                if (idx === -1) {
                    idx = 0;
                }

                var theadrows = table.find('thead tr');
                theadrows.each(function (i) {
                    var checkall;
                    if (i === settings.checkAllRowIndex) {
                        checkall = $('<th>', { class: 'h-listtable-checkable' }).append($(this).data('checked') === true ? H.getSprite(settings.icons.checked) : H.getSprite(settings.icons.unchecked));
                    } else {
                        checkall = $('<th>');
                    }
                    checkall.insertBefore($(this).find('th:nth-child(' + (idx + 1) + ')'));
                });
            }
            
            if (settings.sortable) {
                table.find('thead tr').prepend($('<th>'));

                table.find('tbody tr').each(function () {
                    var column = $(this).find('td:not(.h-listtable-transparent)').first();
                    var sort = $('<td>', { class: 'h-listtable-sort' }).append(H.getSprite(settings.icons.sort));
                    sort.insertBefore(column);
                });

                table.tableDnD({
                    onDragClass: 'h-dragging',
                    dragHandle: '.h-listtable-sort',
                    onDrop: function(table, row) {
                        trigger('sort', { table: table, row: row });
                    }
                });
            }

            var hfoot = $('<tfoot>');
            table.append(hfoot);

            if (settings.placeholder) {
                hplaceholder = $('<tr>').append($('<td>', { class: 'h-listtable-placeholder', colspan: 100 }).html(settings.placeholder));
                hfoot.append(hplaceholder);
                if (table.find('tbody tr').length > 0) {
                    hplaceholder.hide();
                }
            }

            if (settings.pager) {
                var colCount = table[0].rows[0].cells.length;
                hpager = $('<div>', { class: 'h-listtable-pager' });
                hfoot.append($('<tr>').append($('<td>', { colspan: colCount }).append(hpager)));

                setPageCount(0);
            }

            hspinner = $('<tr>').append($('<td>', { class: 'h-listtable-spinner', colspan: 100 }).append(H.getSpinner(50)));
            hfoot.append(hspinner);
            hspinner.toggle(settings.spinner);

            table.on('click', '.h-listtable-action[data-action]:not(.h-disabled), .h-listtable-action-inline[data-action]:not(.h-disabled)', function (e) {
                var row = $(this).closest('tr');

                if (row.hasClass('h-selected')) {
                    e.stopPropagation();
                }

                trigger('action', {
                    action: $(this).data('action'),
                    row: row,
                    cargo: row.data('cargo'),
                    target: $(this)
                });
            });

            table.on('click', '.h-listtable-pager-previous:not(.h-disabled)', function () {
                setPage(currentPage - 1);
            });

            table.on('click', '.h-listtable-pager-next:not(.h-disabled)', function () {
                setPage(currentPage + 1);
            });

            table.on('click', '.h-listtable-pager-page', function () {
                setPage($(this).data('page'));
            });

            table.on('click', '.h-listtable-sort', function () {
                var asc = $(this).hasClass('h-listtable-sort-asc');
                $(this).parent().find('th').removeClass('h-listtable-sort-asc').removeClass('h-listtable-sort-desc');
                if (asc) {
                    $(this).addClass('h-listtable-sort-desc');
                } else {
                    $(this).addClass('h-listtable-sort-asc');
                }
                trigger('headsort', {
                    direction: asc ? 'desc' : 'asc',
                    col: $(this).index(),
                    target: $(this) 
                });
            });

            table.on('click', 'tbody .h-listtable-checkable svg', function (e) {
                e.stopPropagation();
                var row = $(this).closest('tr');
                var checked = !row.data('checked');
                if (checked) {
                    $(this).parent('.h-listtable-checkable').html(H.getSprite(settings.icons.checked));
                } else {
                    $(this).parent('.h-listtable-checkable').html(H.getSprite(settings.icons.unchecked));
                }
                row.data('checked', checked);

                var overallchecked = table.find('tbody tr').length === table.find('tbody tr').filter(function () { return $(this).data('checked'); }).length;
                table.find('thead tr').data('checked', overallchecked);
                table.find('thead tr th.h-listtable-checkable').html(overallchecked ? H.getSprite(settings.icons.checked) : H.getSprite(settings.icons.unchecked));
                trigger('check', { target: this, checked: checked, id: $(row).attr('id'), cargo: $(row).data('cargo') });
            });

            table.on('click', 'thead .h-listtable-checkable svg', function () {
                var row = $(this).closest('tr');
                var checked = !row.data('checked');
                if (checked) {
                    $(this).parent('.h-listtable-checkable').html(H.getSprite(settings.icons.checked));
                    table.find('tbody tr .h-listtable-checkable').html(H.getSprite(settings.icons.checked));
                } else {
                    $(this).parent('.h-listtable-checkable').html(H.getSprite(settings.icons.unchecked));
                    table.find('tbody tr .h-listtable-checkable').html(H.getSprite(settings.icons.unchecked));
                }
                row.data('checked', checked);
                table.find('tbody tr').data('checked', checked);
                trigger('checkAll', { checked: checked });
            });

            on('action', function(e) {
                if (e.action === 'url' && e.target.data('url')) {
                    location.href = e.target.data('url');
                }
            });

            var clearColumns = function () {
                table.find('thead').empty();
            };

            var clearRows = function() {
                table.find('tbody').empty();

                var checkbox = table.find('thead .h-listtable-checkable');
                checkbox.closest('tr').data('checked', false);
                checkbox.html(H.getSprite(settings.icons.unchecked));

                if (hplaceholder) {
                    hplaceholder.toggle(settings.placeholder !== false);
                }
            };

            var addColumn = function(name) {
                var hhead = table.find('thead');
                if (hhead.length === 0) {
                    hhead = $('<thead>');
                    table.prepend(hhead);
                }
                var hrow = hhead.find('tr');
                if (hrow.length === 0) {
                    hrow = $('<tr>');
                    hhead.append(hrow);
                }
                hrow.append($('<th>').html(name));
            };

            function Row(hrow) {
                this.hrow = hrow;
                this.checked = hrow.data('checked') === true;
            }
            Row.prototype.addCell = function(content, action, actionurl) {
                var hcell = $('<td>').html(content);
                if (action) {
                    hcell.addClass('h-listtable-action');
                    hcell.attr('data-action', action);
                    if (action === 'url' && actionurl) {
                        hcell.data('url', actionurl);
                    }
                }
                this.hrow.append(hcell);
            };
            Row.prototype.setCargo = function(data) {
                this.hrow.data('cargo', data);
            };

            Row.prototype.getCargo = function() {
                return this.hrow.data('cargo');
            };

            var addRow = function (id, options) {
                var rowOptions = $.extend(true,
                    {
                        checked: false,
                        hrow: null,
                        cargo: null
                    }, options);

                var hrow = rowOptions.hrow || $('<tr>');
                hrow.attr('id', id);

                if (rowOptions.cargo !== null) {
                    hrow.data('cargo', rowOptions.cargo);
                }

                if (settings.checkable) {
                    hrow.prepend($('<td>', { class: 'h-listtable-checkable' }).append(rowOptions.checked === true ? H.getSprite('checkbox-checked') : H.getSprite('checkbox-unchecked')));
                    hrow.data('checked', rowOptions.checked === true);
                }

                if (settings.sortable) {
                    var hcolumn = hrow.find('td:not(.h-listtable-transparent)').first();
                    var hsort = $('<td>', { class: 'h-listtable-sort' }).append(H.getSprite(settings.icons.sort));
                    hsort.insertBefore(hcolumn);
                }

                var hbody = table.find('tbody');
                if (hbody.length === 0) {
                    hbody = $('<tbody>');
                    table.append(hbody);
                }
                hbody.append(hrow);

                if (hplaceholder) {
                    hplaceholder.hide();
                }
                table.tableDnDUpdate();

                return new Row(hrow);
            };

            var deleteRow = function (id) {
                table.find('tbody tr[id="' + id + '"]').remove();
                if (hplaceholder && table.find('tbody tr').length === 0) {
                    hplaceholder.toggle(settings.placeholder !== false);
                }
            };

            var selectRow = function (id) {
                var hrow = table.find('tbody tr[id="' + id + '"]');
                var toggle = hrow.hasClass('h-selected');
                table.find('tbody tr').removeClass('h-selected');
                hrow.toggleClass('h-selected', !toggle);
                hrow.get(0).scrollIntoView({ block: 'nearest' });
                trigger('select', { target: this, select: !toggle, id: hrow.attr('id'), cargo: hrow.data('cargo') });
            };

            var getRow = function (id) {
                var hrow = table.find('tbody tr[id="' + id + '"]');
                if (hrow.length === 1) {
                    return new Row(hrow);
                }
                return null;
            };

            var getRows = function() {
                return table.find('tbody tr').toArray().map(function(item) {
                    return new Row($(item));
                });
            };

            var getCheckedRows = function () {
                return table.find('tbody tr').toArray()
                    .filter(function (item) {
                        return $(item).data('checked') === true;
                    })
                    .map(function (item) {
                        return new Row($(item));
                    });
            };

            function setPage(page) {
                currentPage = page > pageCount-1 ? pageCount-1 : (page < 0 ? 0 : page);

                hpager.empty();

                var from;
                var to; 

                if (pageCount < 6) {
                    from = 0;
                    to = pageCount-1;
                } else {
                    from = currentPage > 1 ? currentPage - 2 : 0;
                    if (from + 4 > pageCount-1) {
                        from = pageCount - 5;
                    }
                    to = from + 4;
                }

                var previous = $('<div>', { class: 'h-listtable-pager-previous' }).append(H.getSprite('right-angle'));
                if (currentPage === 0) {
                    previous.addClass('h-disabled');
                }
                hpager.append(previous);
                for (var i = from; i <= to; i++) {
                    var el = $('<div>', { class: 'h-listtable-pager-page' });
                    el.data('page', i);
                    if (i === currentPage) {
                        el.addClass('h-selected');
                    }
                    el.text(i+1);
                    hpager.append(el);
                }
                var next = $('<div>', { class: 'h-listtable-pager-next' }).append(H.getSprite('right-angle'));
                if (currentPage === pageCount-1) {
                    next.addClass('h-disabled');
                }
                hpager.append(next);

                trigger('pager', {
                    page: currentPage,
                    target: $(this)
                });
            }

            var setPlaceholder = function(content) {
                hplaceholder.find('.h-listtable-placeholder').html(content);
            };

            var showSpinner = function () {
                if (hplaceholder) {
                    hplaceholder.hide();
                }
                hspinner.show();
            };

            var hideSpinner = function () {
                hspinner.hide();
                if (hplaceholder && table.find('tbody tr').length === 0) {
                    hplaceholder.show();
                }
            };

            return {
                on: on,
                addColumn: addColumn,
                addRow: addRow,
                getRow: getRow,
                selectRow: selectRow,
                getRows: getRows,
                getCheckedRows: getCheckedRows,
                clearRows: clearRows,
                clearColumns: clearColumns,
                deleteRow: deleteRow,
                setPageCount: setPageCount,
                setPlaceholder: setPlaceholder,
                showSpinner: showSpinner,
                hideSpinner: hideSpinner
            };
        })(this);
    };
})(jQuery);


hmodal = (function ($) {
    'use strict';

    var hcontainer;
    var openModals = [];

    var defaults = {
        header: false,
        content: false,
        background: false,
        accept: false,
        acceptEnabled: true,
        reject: false,
        rejectEnabled: true,
        autoClose: true,
        autoDestroy: false,
        padding: 10
    };

    var create = function (options) {
        return (function () {
            var settings = $.extend(true, {}, defaults, options);

            var haccept;
            var hreject;

            var callbackid = 42;
            var callbacks = [];

            const modalId = H.uniqueId();

            var on = function (event, cb) {
                if (!Array.isArray(event)) {
                    event = [event];
                }
                var eventids = [];
                event.forEach(function (e) {
                    if (['open', 'close', 'acceptable', 'accept', 'reject', 'button'].indexOf(e) > -1) {
                        var ev = { event: e, cb: cb, _eventid: callbackid++ };
                        eventids.push(ev._eventid);
                        callbacks.push(ev);
                    }
                });
                if (eventids.length === 1) {
                    return eventids[0];
                } else {
                    return eventids;
                }
            };

            function off(eventid) {
                if (!Array.isArray(event)) {
                    eventid = [eventid];
                }
                eventid.forEach(function(e) {
                    for (var i = 0; i < callbacks.length; i++) {
                        if (e === callbacks[i]._eventid) {
                            callbacks.splice(i, 1);
                            break;
                        }
                    }
                });
            }

            function trigger(event, data) {
                var result = true;
                callbacks.filter(function (e) {
                    return e.event === event;
                }).forEach(function (value) {
                    var res = value.cb($.extend({ event: event }, data));
                    if (res === undefined || res === true) {
                        result = result && true;
                    } else {
                        result = false;
                    }
                });
                return result;
            }

            function accept() {
                if (trigger('acceptable')) {
                    close();
                    trigger('accept', { accept: true });
                }
            }

            function reject() {
                close();
                trigger('reject', { accept: false });
            }

            var header = function (content) {
                var hheader = hdialog.find('.h-modal-header');
                if (content) {
                    if (hheader.length === 0) {
                        hheader = $('<div>', { class: 'h-modal-header' });
                        if (settings.padding) {
                            hheader.css('padding-left', settings.padding);
                            hheader.css('padding-right', settings.padding);
                        }
                        hdialog.prepend(hheader);
                    }
                    hheader.html(content);
                } else {
                    hheader.remove();
                }
            };

            var hoverlaywrapper = $('<div>', { class: 'h-modal-overlay-wrapper' });
            hcontainer.append(hoverlaywrapper);
            var hoverlay = $('<div>', { class: 'h-modal-overlay' });
            hoverlaywrapper.append(hoverlay);
            var hdialog = $('<div>', { class: 'h-modal-dialog' });
            hoverlay.append(hdialog);

            if (settings.header) {
                header(settings.header);
            }

            var hcontent;
            if (settings.content) {
                if (settings.content instanceof jQuery) {
                    hcontent = settings.content.detach().removeClass('h-modal').addClass('h-modal-content');
                    if (settings.background) {
                        hcontent.css('background-color', settings.background);
                    }
                } else {
                    hcontent = $('<div>', { class: 'h-modal-content' }).html(settings.content);
                }
                if (settings.padding) {
                    hcontent.css('padding-top', settings.padding);
                    hcontent.css('padding-bottom', settings.padding);
                    hcontent.css('padding-left', settings.padding);
                    hcontent.css('padding-right', settings.padding);
                }
            } else {
                hcontent = $('<div>', { class: 'h-modal-content' });
                if (settings.padding) {
                    hcontent.css('padding-bottom', settings.padding);
                }
            }
            hdialog.append(hcontent);
            hdialog.on('click', function (e) {
                e.stopPropagation();
            });

            if (settings.reject || settings.accept) {
                var hbuttons = $('<div>', { class: 'h-button-row' });
                if (settings.background) {
                    hbuttons.css('background-color', settings.background);
                }
                if (settings.accept) {
                    haccept = $('<button>', { class: 'h-button' }).html(settings.accept).on('click', accept);
                    haccept.prop('disabled', !settings.acceptEnabled);
                    hbuttons.append(haccept);
                }
                if (settings.reject) {
                    hreject = $('<button>', { class: 'h-button' }).html(settings.reject).on('click', reject);
                    hreject.prop('disabled', !settings.rejectEnabled);
                    hbuttons.append(hreject);
                }
                hbuttons.children().first().css('margin-left', 'auto');
                if (settings.padding) {
                    hbuttons.css('padding-left', settings.padding);
                    hbuttons.css('padding-right', settings.padding);
                    hbuttons.css('padding-bottom', settings.padding);
                }
                hdialog.append(hbuttons);
            }

            if (settings.autoClose) {
                hoverlay.on('click', function () {
                    reject();
                });
                hdialog.attr('tabIndex', 0);
                hdialog.on('keydown', function (e) {
                    if (e.key === 'Escape') {
                        reject();
                    }
                });
            }

            on('acceptable', function() { return true; });

            var openaccept = null;
            var openreject = null;

            var open = function (cb) {
                if (openaccept) {
                    off(openaccept);
                    openaccept = null;
                }

                if (openreject) {
                    off(openreject);
                    openreject = null;
                }

                if (cb) {
                    openaccept = on('accept', cb);
                    openreject = on('reject', cb);
                }

                if (openModals.length === 0) {
                    hcontainer.show();
                }
                hoverlaywrapper.css('z-index', openModals.length+1);
                openModals.push(hoverlaywrapper);
                hoverlaywrapper.fadeIn(300, function () {
                    if (settings.autoClose) {
                        hdialog.focus();
                    }
                    trigger('open');
                });
            };

            var close = function () {
                hoverlaywrapper.fadeOut(300, function () {
                    openModals.splice(openModals.indexOf(hoverlaywrapper), 1);
                    if (openModals.length === 0) {
                        hcontainer.hide();
                    }
                    if (!(settings.content instanceof jQuery) || settings.autoDestroy) {
                        hoverlaywrapper.remove();
                    }
                    trigger('close');
                });
            };

            var enable = function(button, enabled) {
                if (button === 'accept') {
                    haccept.prop('disabled', !enabled);
                }
                if (button === 'reject') {
                    hreject.prop('disabled', !enabled);
                }
            };

            var visible = function (button, isVisible) {
                if (button === 'accept') {
                    haccept.css('visibility', isVisible ? 'visible' : 'hidden');
                }
                if (button === 'reject') {
                    hreject.css('visibility', isVisible ? 'visible' : 'hidden');
                }
            };

            return {
                on: on,
                open: open,
                close: close,
                reject: reject,
                accept: accept,
                header: header,
                enable: enable,
                visible: visible,
                modalId: modalId
            };
        })();
    };

    var open = function (options, cb) {
        var modal = hmodal.create(options);
        modal.open(cb);
        return modal;
    };

    $.fn.hmodal = function (options) {
        options = options || {};
        options.content = this;

        return hmodal.create(options);
    };

    $(function () {
        hcontainer = $('<div>', { class: 'h-modals' });
        $('body').append(hcontainer);
    });

    return {
        create: create,
        open: open
    };
})(jQuery);

(function ($) {
    'use strict';

    var defaults = {
        value: 0,
        max: 100
    };

    $.fn.hprogress = function (options) {
        var settings = $.extend(true, {}, defaults, options);

        var hcontainer = $(this);

        var getValue = function () {
            return settings.value;
        };

        var setValue = function (value) {
            settings.value = value;
            hcompleted.css('width', (settings.value / settings.max * 100) + '%');
        };

        var incValue = function (delta) {
            setValue(settings.value + delta);
        };

        var done = function () {
            return settings.value >= settings.max;
        };

        hcontainer.empty();

        var hprogress = $('<div>', { class: 'h-progress' });
        hcontainer.append(hprogress);
        var hcompleted = $('<div>', { class: 'h-progress-completed' });
        hprogress.append(hcompleted);
        var hmissing = $('<div>', { class: 'h-progress-missing' });
        hprogress.append(hmissing);

        return {
            setValue: setValue,
            incValue: incValue,
            getValue: getValue,
            done: done
        };
    };
})(jQuery);

(function ($) {
    'use strict';

    var defaults = {
    };

    $.fn.hproplist = function (options) {
        var settings = $.extend(true, {}, defaults, options);

        var props = [];
        var propData = {};

        if (settings.props) {
            props = settings.props.map(function (prop) {
                return { name: prop.name, prop: prop.prop };
            });
        }

        var clearValues = function () {
            propData = {};
            render();
        };

        var clear = function () {
            props = [];
            propdata = {};
            render();
        };

        var set = function (data) {
            propData = data;
            render();
        };

        function render() {
            htable.empty();

            props.forEach(function (prop) {
                var hrow = $('<tr>', { class: 'h-proplist-row' });
                var hname = $('<td>', { class: 'h-proplist-name' }).html(prop.name);
                var hvalue = $('<td>', { class: 'h-proplist-value' });
                if (propData.hasOwnProperty(prop.prop)) {
                    hvalue.html(propData[prop.prop]);
                }
                hrow.append(hname);
                hrow.append(hvalue);

                htable.append(hrow);
            });
        }

        var hcontainer = $(this);
        hcontainer.empty();
        hcontainer.addClass('h-proplist');
        var htable = $('<table>', { class: 'h-proplist-table' });
        hcontainer.append(htable);

        render();

        return {
            set: set,
            clear: clear,
            clearValues: clearValues
        };
    };
})(jQuery);

/*! Split.js - v1.6.4 */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Split=t()}(this,(function(){"use strict";var e="undefined"!=typeof window?window:null,t=null===e,n=t?void 0:e.document,i=function(){return!1},r=t?"calc":["","-webkit-","-moz-","-o-"].filter((function(e){var t=n.createElement("div");return t.style.cssText="width:"+e+"calc(9px)",!!t.style.length})).shift()+"calc",s=function(e){return"string"==typeof e||e instanceof String},o=function(e){if(s(e)){var t=n.querySelector(e);if(!t)throw new Error("Selector "+e+" did not match a DOM element");return t}return e},a=function(e,t,n){var i=e[t];return void 0!==i?i:n},u=function(e,t,n,i){if(t){if("end"===i)return 0;if("center"===i)return e/2}else if(n){if("start"===i)return 0;if("center"===i)return e/2}return e},l=function(e,t){var i=n.createElement("div");return i.className="gutter gutter-"+t,i},c=function(e,t,n){var i={};return s(t)?i[e]=t:i[e]=r+"("+t+"% - "+n+"px)",i},h=function(e,t){var n;return(n={})[e]=t+"px",n};return function(r,s){if(void 0===s&&(s={}),t)return{};var d,f,v,m,g,p,y=r;Array.from&&(y=Array.from(y));var z=o(y[0]).parentNode,S=getComputedStyle?getComputedStyle(z):null,b=S?S.flexDirection:null,E=a(s,"sizes")||y.map((function(){return 100/y.length})),_=a(s,"minSize",100),L=Array.isArray(_)?_:y.map((function(){return _})),w=a(s,"maxSize",1/0),x=Array.isArray(w)?w:y.map((function(){return w})),k=a(s,"expandToMin",!1),C=a(s,"gutterSize",10),M=a(s,"gutterAlign","center"),U=a(s,"snapOffset",30),A=a(s,"dragInterval",1),O=a(s,"direction","horizontal"),D=a(s,"cursor","horizontal"===O?"col-resize":"row-resize"),B=a(s,"gutter",l),T=a(s,"elementStyle",c),j=a(s,"gutterStyle",h);function F(e,t,n,i){var r=T(d,t,n,i);Object.keys(r).forEach((function(t){e.style[t]=r[t]}))}function R(){return p.map((function(e){return e.size}))}function N(e){return"touches"in e?e.touches[0][f]:e[f]}function q(e){var t=p[this.a],n=p[this.b],i=t.size+n.size;t.size=e/this.size*i,n.size=i-e/this.size*i,F(t.element,t.size,this._b,t.i),F(n.element,n.size,this._c,n.i)}function H(e){var t,n=p[this.a],r=p[this.b];this.dragging&&(t=N(e)-this.start+(this._b-this.dragOffset),A>1&&(t=Math.round(t/A)*A),t<=n.minSize+U+this._b?t=n.minSize+this._b:t>=this.size-(r.minSize+U+this._c)&&(t=this.size-(r.minSize+this._c)),t>=n.maxSize-U+this._b?t=n.maxSize+this._b:t<=this.size-(r.maxSize-U+this._c)&&(t=this.size-(r.maxSize+this._c)),q.call(this,t),a(s,"onDrag",i)(R()))}function I(){var e=p[this.a].element,t=p[this.b].element,n=e.getBoundingClientRect(),i=t.getBoundingClientRect();this.size=n[d]+i[d]+this._b+this._c,this.start=n[v],this.end=n[m]}function W(e){var t=function(e){if(!getComputedStyle)return null;var t=getComputedStyle(e);if(!t)return null;var n=e[g];return 0===n?null:n-="horizontal"===O?parseFloat(t.paddingLeft)+parseFloat(t.paddingRight):parseFloat(t.paddingTop)+parseFloat(t.paddingBottom)}(z);if(null===t)return e;if(L.reduce((function(e,t){return e+t}),0)>t)return e;var n=0,i=[],r=e.map((function(r,s){var o=t*r/100,a=u(C,0===s,s===e.length-1,M),l=L[s]+a;return o<l?(n+=l-o,i.push(0),l):(i.push(o-l),o)}));return 0===n?e:r.map((function(e,r){var s=e;if(n>0&&i[r]-n>0){var o=Math.min(n,i[r]-n);n-=o,s=e-o}return s/t*100}))}function X(){var t=p[this.a].element,r=p[this.b].element;this.dragging&&a(s,"onDragEnd",i)(R()),this.dragging=!1,e.removeEventListener("mouseup",this.stop),e.removeEventListener("touchend",this.stop),e.removeEventListener("touchcancel",this.stop),e.removeEventListener("mousemove",this.move),e.removeEventListener("touchmove",this.move),this.stop=null,this.move=null,t.removeEventListener("selectstart",i),t.removeEventListener("dragstart",i),r.removeEventListener("selectstart",i),r.removeEventListener("dragstart",i),t.style.userSelect="",t.style.webkitUserSelect="",t.style.MozUserSelect="",t.style.pointerEvents="",r.style.userSelect="",r.style.webkitUserSelect="",r.style.MozUserSelect="",r.style.pointerEvents="",this.gutter.style.cursor="",this.parent.style.cursor="",n.body.style.cursor=""}function Y(t){if(!("button"in t)||0===t.button){var r=p[this.a].element,o=p[this.b].element;this.dragging||a(s,"onDragStart",i)(R()),t.preventDefault(),this.dragging=!0,this.move=H.bind(this),this.stop=X.bind(this),e.addEventListener("mouseup",this.stop),e.addEventListener("touchend",this.stop),e.addEventListener("touchcancel",this.stop),e.addEventListener("mousemove",this.move),e.addEventListener("touchmove",this.move),r.addEventListener("selectstart",i),r.addEventListener("dragstart",i),o.addEventListener("selectstart",i),o.addEventListener("dragstart",i),r.style.userSelect="none",r.style.webkitUserSelect="none",r.style.MozUserSelect="none",r.style.pointerEvents="none",o.style.userSelect="none",o.style.webkitUserSelect="none",o.style.MozUserSelect="none",o.style.pointerEvents="none",this.gutter.style.cursor=D,this.parent.style.cursor=D,n.body.style.cursor=D,I.call(this),this.dragOffset=N(t)-this.end}}"horizontal"===O?(d="width",f="clientX",v="left",m="right",g="clientWidth"):"vertical"===O&&(d="height",f="clientY",v="top",m="bottom",g="clientHeight"),E=W(E);var G=[];function J(e){var t=e.i===G.length,n=t?G[e.i-1]:G[e.i];I.call(n);var i=t?n.size-e.minSize-n._c:e.minSize+n._b;q.call(n,i)}return(p=y.map((function(e,t){var n,i={element:o(e),size:E[t],minSize:L[t],maxSize:x[t],i:t};if(t>0&&((n={a:t-1,b:t,dragging:!1,direction:O,parent:z})._b=u(C,t-1==0,!1,M),n._c=u(C,!1,t===y.length-1,M),"row-reverse"===b||"column-reverse"===b)){var r=n.a;n.a=n.b,n.b=r}if(t>0){var s=B(t,O,i.element);!function(e,t,n){var i=j(d,t,n);Object.keys(i).forEach((function(t){e.style[t]=i[t]}))}(s,C,t),n._a=Y.bind(n),s.addEventListener("mousedown",n._a),s.addEventListener("touchstart",n._a),z.insertBefore(s,i.element),n.gutter=s}return F(i.element,i.size,u(C,0===t,t===y.length-1,M),t),t>0&&G.push(n),i}))).forEach((function(e){var t=e.element.getBoundingClientRect()[d];t<e.minSize&&(k?J(e):e.minSize=t)})),{setSizes:function(e){var t=W(e);t.forEach((function(e,n){if(n>0){var i=G[n-1],r=p[i.a],s=p[i.b];r.size=t[n-1],s.size=e,F(r.element,r.size,i._b,r.i),F(s.element,s.size,i._c,s.i)}}))},getSizes:R,collapse:function(e){J(p[e])},destroy:function(e,t){G.forEach((function(n){if(!0!==t?n.parent.removeChild(n.gutter):(n.gutter.removeEventListener("mousedown",n._a),n.gutter.removeEventListener("touchstart",n._a)),!0!==e){var i=T(d,n.a.size,n._b);Object.keys(i).forEach((function(e){p[n.a].element.style[e]="",p[n.b].element.style[e]=""}))}}))},parent:z,pairs:G}}}));

class HSplit extends H.HEventable {
    constructor(options) {
        super(['change']);
        this.defaultSizes = options.defaultSizes || [50, 50];        

        const element = document.querySelector(options.element);
        element.classList.add('h-splitter');        
        this.split = Split([element.children[0], element.children[1]], {
            direction: options.mode === 'vertical' ? 'horizontal' : 'vertical',
            gutterSize: 10,
            sizes: options.sizes || this.defaultSizes,
            onDragEnd: () => {
                this.trigger('change', { sizes: this.split.getSizes() });
            }
        });

        const gutter = element.children[0].nextElementSibling;
        gutter.title = options.tooltip;
        gutter.addEventListener('dblclick', e => this.reset());
    }

    reset() {
        this.split.setSizes(this.defaultSizes);
        this.trigger('change', { sizes: this.split.getSizes() });
    }
}

(function ($) {
    'use strict';

    $.fn.htabs = function (options) {
        var defaults = {
            index: 1
        };

        return (function (tabs) {
            var settings = $.extend(defaults, options);

            var callbacks = [];
            var index = settings.index;

            var on = function (event, cb) {
                if (!Array.isArray(event)) {
                    event = [event];
                }
                event.forEach(function (e) {
                    if (['select'].indexOf(e) > -1) {
                        callbacks.push({ event: e, cb: cb });
                    }
                });
            };

            function trigger(event, data) {
                var result = true;
                callbacks.filter(function (e) {
                    return e.event === event;
                }).forEach(function (value) {
                    var res = value.cb($.extend({ event: event }, data));
                    if (res === undefined || res === true) {
                        result = result && true;
                    } else {
                        result = false;
                    }
                });
                return result;
            }

            var select = function(idx) {
                $('.h-tab-button').removeClass('h-selected');
                $('.h-tab').hide();
                $('.h-tab-button:nth-child(' + idx + ')').addClass('h-selected');
                $('.h-tab:nth-child(' + (idx + 1) + ')').show();
                trigger('select', { index: idx });
            };

            tabs.on('click', '.h-tab-button', function () {
                select($(this).index() + 1);
            });

            select(index);

            return {
                on: on,
                select: select
            };
        })(this);
    };
})(jQuery);
(function ($) {
    'use strict';

    $.fn.htogglegrid = function (data, options) {
        var defaults = {
            caption: '',
            columns: 6,
            all: 'All',
            none: 'None'
        };

        var self = (function (grid) {
            var settings = $.extend(defaults, options);

            var commands = [];

            if (settings.all !== false) {
                commands.push({ id: 'all', caption: settings.all, handler: function() { all(); } });
            }
            if (settings.none !== false) {
                commands.push({ id: 'none', caption: settings.none, handler: function() { none(); } });
            }

            var callbacks = [];

            var on = function (event, cb) {
                if (!Array.isArray(event)) {
                    event = [event];
                }
                event.forEach(function (e) {
                    if (['changed'].indexOf(e) > -1) {
                        callbacks.push({ event: e, cb: cb });
                    }
                });
            };

            function trigger(event, data) {
                var result = true;
                callbacks.filter(function (e) {
                    return e.event === event;
                }).forEach(function (value) {
                    var res = value.cb($.extend({ event: event }, data));
                    if (res === undefined || res === true) {
                        result = result && true;
                    } else {
                        result = false;
                    }
                });
                return result;
            }

            function addCells(celldefs) {
                if (settings.commands) {
                    settings.commands.forEach(function (command) {
                        commands.unshift({ caption: command.caption, id: command.id, handler: command.handler });
                    });
                }

                var header = $('<div>', { class: 'h-togglegrid-header' });
                header.append($('<label>', { class: 'h-togglegrid-caption' }).html(settings.caption));
                commands.forEach(function (command) {
                    header.append($('<div>', { class: 'h-togglegrid-command', 'data-command': command.id }).html(command.caption));
                });
                grid.append(header);

                var options = $('<div>', { class: 'h-togglegrid-options' });
                grid.append(options);

                var row;
                celldefs.forEach(function (celldef, idx) {
                    if (idx % settings.columns === 0) {
                        row = $('<div>', { class: 'h-togglegrid-row' });
                        options.append(row);
                    }

                    var cls = 'h-togglegrid-cell';
                    if (celldef.selected) {
                        cls += ' h-selected';
                    }
                    var cell = $('<div>', { class: cls }).html(celldef.caption);
                    cell.data('value', celldef.value);
                    row.append(cell);
                });

                if (celldefs.length % settings.columns > 0) {
                    for (var i = 0; i < settings.columns - (celldefs.length % settings.columns); i++) {
                        row.append($('<div>', { class: 'h-togglegrid-padding-cell' }));
                    }
                }
            }

            function setCells(cells) {
                if (cells) {
                    cells.addClass('h-selected');
                } else {
                    grid.find('.h-togglegrid-cell').addClass('h-selected');
                }
            }

            function clearCells(cells) {
                if (cells) {
                    cells.removeClass('h-selected');
                } else {
                    grid.find('.h-togglegrid-cell').removeClass('h-selected');
                }
            }

            function toggleCells(cells) {
                if (cells) {
                    cells.toggleClass('h-selected');
                } else {
                    grid.find('.h-togglegrid-cell').toggleClass('h-selected');
                }
            }

            function getCells(values)
            {
                if (!Array.isArray(values)) {
                    values = [values];
                }
                return grid.find('.h-togglegrid-cell').filter(function () {
                    return values.indexOf($(this).data('value')) > -1;
                });
            }

            function checkChanged(before) {
                var after = get();
                var equal = before.length === after.length && before.every(function(item, idx) {
                    return after[idx] === item;
                });
                if (!equal) {
                    trigger('changed');
                }
            }

            grid.on('click', '.h-togglegrid-cell', function () {
                if (grid.data('readonly') === false) {
                    var before = get();
                    toggleCells($(this));
                    checkChanged(before);
                }
            });

            grid.on('click', '.h-togglegrid-command', function () {
                var id = $(this).data('command');
                var command = commands.filter(function (item) {
                    return item.id === id;
                });
                if (command) {
                    command[0].handler.apply(self, [id]);
                }
            });

            var all = function() {
                var before = get();
                setCells();
                checkChanged(before);
            };

            var none = function() {
                var before = get();
                clearCells();
                checkChanged(before);
            };

            var set = function(values) {
                var before = get();
                setCells(values);
                checkChanged(before);
            };

            var clear = function(values) {
                var before = get();
                clearCells(values);
                checkChanged(before);
            };

            var assign = function(values) {
                var before = get();
                clearCells();
                setCells(getCells(values));
                checkChanged(before);
            };

            var invert = function() {
                var before = get();
                toggleCells();
                checkChanged(before);
            };

            var get = function () {
                return grid.find('.h-togglegrid-cell').filter(function () {
                    return $(this).hasClass('h-selected');
                }).map(function () {
                    return $(this).data('value');
                }).get();
            };

            grid.empty();
            grid.addClass('h-togglegrid');
            addCells(data);

            return {
                on: on,
                all: all,
                none: none,
                set: set,
                clear: clear,
                assign: assign,
                invert: invert,
                get: get
            };
        })(this);

        return self;
    };
})(jQuery);
htranslationeditor = (function ($) {
    'use strict';

    var defaults = {
        header: '<header>',
        valueLabel: '<text>',
        ok: '<ok>',
        cancel: '<cancel>',
        cultures: [],
        cb: null
    };

    var open = function (value, localization, options, cb) {
        var settings = $.extend(true, {}, defaults, options);

        var hcontent = $('<div>', { class: 'h-translationeditor h-form' });
        var hneutral = $('<div>', { class: 'h-form-row' })
            .append($('<div>', { class: 'h-form-group' })
                .append($('<label>', { for: 'h-te-input-neutral' }).html(settings.valueLabel))
                .append($('<input>', { id: 'h-te-input-neutral', type: 'text', readonly: true }).val(value)));
        hcontent.append(hneutral);

        var htable = $('<table>', { id: 'h-te-translations-table', class: 'h-te-translations-table' });
        settings.cultures.forEach(function (culture) {
            var hrow = $('<tr>');
            htable.append(hrow);
            var hlabel = $('<td>').html(culture.name);
            hrow.append(hlabel);
            var translation = localization.translations.find(function (translation) { return translation.cultureCode === culture.code; });
            var hinput = $('<input>', { type: 'text', value: translation ? translation.value : '', class: 'h-te-translations-table-input' }).data('culture', culture.code);
            hrow.append(hinput);
        });
        var htranslations = $('<div>', { class: 'h-form-row' })
            .append($('<div>', { class: 'h-form-group' }).append(htable));
        hcontent.append(htranslations);

        hmodal.open({
            header: settings.header,
            content: hcontent,
            autoClose: false,
            accept: settings.ok,
            reject: settings.cancel,
            background: '#f2f2f2'
        }, function(e) {
            if (e.accept) {
                if (cb) {
                    cb({
                        type: localization.type,
                        key: localization.key,
                        items: $('.h-te-translations-table-input').toArray().map(function(item) {
                            return {
                                cultureCode: $(item).data('culture'),
                                value: $(item).val()
                            };
                        })
                    });
                }
            }
        });
    };

    $.fn.htranslationeditor = function (localization, options, cb) {
        htranslationeditor.open($(this).val(), localization, options, cb);
    };

    return {
        open: open
    };
})(jQuery);

(function ($) {
    'use strict';

    var defaults = {
        icon: 'upload',
        text: null,
        content: null,
        accept: null,
        multiple: false,
        autoHideText: false
    };

    $.fn.hupload = function (options) {
        var settings = $.extend(true, {}, defaults, options);

        var uploadedFiles = null;

        var callbacks = [];

        var on = function (event, cb) {
            if (!Array.isArray(event)) {
                event = [event];
            }
            event.forEach(function (e) {
                if (['upload', 'remove'].indexOf(e) > -1) {
                    var ev = { event: e, cb: cb };
                    callbacks.push(ev);
                }
            });
        };

        function trigger(event, data) {
            var result = true;
            callbacks.filter(function (e) {
                return e.event === event;
            }).forEach(function (value) {
                var res = value.cb($.extend({ event: event }, data));
                if (res === undefined || res === true) {
                    result = result && true;
                } else {
                    result = false;
                }
            });
            return result;
        }

        var setContent = function (content) {
            if (content) {
                hcontent.html(content);
                showRemove();
                if (settings.autoHideText && htext) {
                    htext.hide();
                }
            } else {
                hcontent.html(H.getSprite(settings.icon));
                hideRemove();
                if (settings.autoHideText && htext) {
                    htext.show();
                }
            }
        };

        function showRemove () {
            hremove.css('display', 'flex');
        }

        function hideRemove() {
            hremove.css('display', 'none');
        }

        function deleteUploaded() {
            var promises = [];

            if (uploadedFiles) {
                uploadedFiles.forEach(f => {
                    promises.push(H.admApi.get('File/Delete', { id: f.fileid }));
                });
            }

            Promise.all(promises).then(() => {
                uploadedFiles = null;
            });
        };

        var clearUploaded = function () {
            deleteUploaded();
            hinput.val('');
        };

        var id = H.uniqueId();

        var hcontainer = $(this);
        hcontainer.empty();
        hcontainer.addClass('h-upload');

        var hremove = $('<div>', { class: 'h-upload-remove' }).html(H.getSprite('cross'));
        hcontainer.append(hremove);

        var hinput = $('<input>', { type: 'file', id: id, class: 'h-upload-input' });
        if (settings.multiple) {
            hinput.prop('multiple', true);
        }
        if (settings.accept) {
            hinput.attr('accept', settings.accept.join(','));
        }
        hcontainer.append(hinput);

        var hlabel = $('<label>', { class: 'h-upload-control', for: id, style: 'display: flex' });

        var hcontent = $('<div>', { class: 'h-upload-content' });

        hlabel.append(hcontent);

        var htext;
        if (settings.text) {
            htext = $('<div>', { class: 'h-upload-text' }).html(settings.text);
            hlabel.append(htext);
        }

        setContent(settings.content);

        hcontainer.append(hlabel);

        if (settings.showRemove) {
            showRemove();
        }

        hinput.on('change', function (e) {
            var self = $(this)[0];

            if (self.files.length > 0) {
                deleteUploaded();
                uploadedFiles = null;

                var fd = new FormData();
                for (var i = 0; i < self.files.length; i++) {
                    fd.append(self.files[i].name, self.files[i]);
                }

                H.admApi.uploadFiles(fd).then(response => {
                    uploadedFiles = JSON.parse(response.data).files;

                    if (settings.multiple) {
                        trigger('upload', { files: uploadedFiles });
                    } else {
                        trigger('upload', uploadedFiles[0]);
                    }
                });
            }
        });

        hremove.on('click', function () {
            if (uploadedFiles) {
                clearUploaded();
                trigger('remove', { mode: 'internal' });
                setContent(settings.content);
            } else {
                trigger('remove', { mode: 'external' });
            }
        });

        return {
            on: on,
            setContent: setContent,
            clearUploaded: clearUploaded
        };
    };
})(jQuery);

Vue.component('v-button', {
    template: `
        <a v-if="href" role="button" class="v-button" :class="[{ 'v-button-compact': mode === 'compact' }, cls]" :href="href">
            <svg v-if="icon"><use :xlink:href="'/Content/Images/h-icons.svg#h-' + icon"/></svg>
            <div v-if="text">{{ text }}</div>
        </a>
        <button v-else type="button" class="v-button" :class="[{ 'v-button-compact': mode === 'compact' }, cls]" @click="$emit('click')">
            <svg v-if="icon"><use :xlink:href="'/Content/Images/h-icons.svg#h-' + icon"/></svg>
            <div v-if="text">{{ text }}</div>
        </button>
    `,
    props: ['icon', 'text', 'cls', 'mode', 'href']
});

//Deprecated
//window.vbutton = (() => {
//    return {
//        template: `
//            <button type="button" class="v-button" :class="[{ 'v-button-compact': mode === 'compact' }, cls]" @click="$emit('click')">
//                <svg v-if="icon"><use :xlink:href="'/Content/Images/h-icons.svg#h-' + icon"/></svg>
//                <div v-if="text">{{ text }}</div>
//            </button>
//        `,
//        props: ['icon', 'text', 'cls', 'mode']
//    };
//})();

/*!
 * ==============================================================
 *  COLOR PICKER 2.1.6
 * ==============================================================
 * Author: Taufik Nurrohman <https://github.com/taufik-nurrohman>
 * License: MIT
 * --------------------------------------------------------------
 */

((win, doc, name) => {

    let html = doc.documentElement,
        HEX = 'HEX',
        top = 'top',
        right = 'right',
        left = 'left',
        px = 'px',
        delay = win.setTimeout,
        instances = 'instances',

        downEvents = ['touchstart', 'mousedown'],
        moveEvents = ['touchmove', 'mousemove'],
        resizeEvents = ['orientationchange', 'resize'],
        upEvents = ['touchend', 'mouseup'];

    // Convert cursor position to RGBA
    function P2RGB(a) {
        let h = +a[0],
            s = +a[1],
            v = +a[2],
            r, g, b, i, f, p, q, t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        i = i || 0;
        q = q || 0;
        t = t || 0;
        switch (i % 6) {
            case 0:
                r = v, g = t, b = p;
                break;
            case 1:
                r = q, g = v, b = p;
                break;
            case 2:
                r = p, g = v, b = t;
                break;
            case 3:
                r = p, g = q, b = v;
                break;
            case 4:
                r = t, g = p, b = v;
                break;
            case 5:
                r = v, g = p, b = q;
                break;
        }
        return [toRound(r * 255), toRound(g * 255), toRound(b * 255), isSet(a[3]) ? +a[3] : 1];
    }

    // Convert RGBA to HSVA
    function RGB2HSV(a) {
        let r = +a[0] / 255,
            g = +a[1] / 255,
            b = +a[2] / 255,
            max = Math.max(r, g, b),
            min = Math.min(r, g, b),
            h, s, v = max,
            d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max === min) {
            h = 0; // Achromatic
        } else {
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return [h, s, v, isSet(a[3]) ? +a[3] : 1];
    }

    function axixGet(el, e) {
        let touches = 'touches',
            clientX = 'clientX',
            clientY = 'clientY',
            x = !!e[touches] ? e[touches][0][clientX] : e[clientX],
            y = !!e[touches] ? e[touches][0][clientY] : e[clientY],
            offset = offsetGet(el);
        return [x - offset[0], y - offset[1]];
    }

    function closestGet(a, b) {
        if (a === b) {
            return a;
        }
        while ((a = a.parentElement) && a !== b);
        return a;
    }

    function doPreventDefault(e) {
        e && e.preventDefault();
    }

    function eventsLet(to, events, fn) {
        for (let i = 0, j = events.length; i < j; ++i) {
            to.removeEventListener(events[i], fn, false);
        }
    }

    function eventsSet(to, events, fn) {
        for (let i = 0, j = events.length; i < j; ++i) {
            to.addEventListener(events[i], fn, false);
        }
    }

    function isFunction(x) {
        return 'function' === typeof x;
    }

    function isObject(x) {
        return 'object' === typeof x;
    }

    function isSet(x) {
        return 'undefined' !== typeof x && null !== x;
    }

    function isString(x) {
        return 'string' === typeof x;
    }

    function offsetGet(el) {
        let x, y, rect;
        if (el === win) {
            x = win.pageXOffset || html.scrollLeft;
            y = win.pageYOffset || html.scrollTop;
        } else {
            rect = el.getBoundingClientRect();
            x = rect.left;
            y = rect.top;
        }
        return [x, y];
    }

    function sizeGet(el) {
        return el === win ? [win.innerWidth, win.innerHeight] : [el.offsetWidth, el.offsetHeight];
    }

    function styleSet(to, prop, value) {
        to.style[prop] = value;
    }

    function toEdge(a, b) {
        if (a < b[0]) return b[0];
        if (a > b[1]) return b[1];
        return a;
    }

    function toInt(a, b) {
        return parseInt(a, b || 10);
    }

    function toNode(a, b, c) {
        a = doc.createElement(a);
        b && b.appendChild(a);
        c && (a.className = c);
        return a;
    }

    function toRound(a) {
        return Math.round(a);
    }

    function toString(a, b) {
        return a.toString(b);
    }

    ($$ => {

        $$[HEX] = x => {
            if (isString(x)) {
                let count = (x = x.trim()).length;
                if ((4 === count || 7 === count) && '#' === x[0]) {
                    if (/^#([a-f\d]{3}){1,2}$/i.test(x)) {
                        if (4 === count) {
                            return [toInt(x[1] + x[1], 16), toInt(x[2] + x[2], 16), toInt(x[3] + x[3], 16), 1];
                        }
                        return [toInt(x[1] + x[2], 16), toInt(x[3] + x[4], 16), toInt(x[5] + x[6], 16), 1];
                    }
                } else if ((5 === count || 9 === count) && '#' === x[0]) {
                    if (/^#([a-f\d]{3,4}){1,2}$/i.test(x)) {
                        if (5 === count) {
                            return [toInt(x[1] + x[1], 16), toInt(x[2] + x[2], 16), toInt(x[3] + x[3], 16), toInt(x[4] + x[4], 16) / 255];
                        }
                        return [toInt(x[1] + x[2], 16), toInt(x[3] + x[4], 16), toInt(x[5] + x[6], 16), toInt(x[7] + x[8], 16) / 255];
                    }
                }
                return [0, 0, 0, 1]; // Default to black
            }
            return '#' + ('000000' + toString(+x[2] | (+x[1] << 8) | (+x[0] << 16), 16)).slice(-6) + (isSet(x[3]) && x[3] < 1 ? toString(toRound(x[3] * 255) + 0x10000, 16).substr(-2) : "");
        };

        // Collect all instance(s)
        $$[instances] = {};

        $$.state = {
            'class': 'color-picker',
            'color': HEX,
            'parent': null
        };

        $$.version = '2.1.6';

    })(win[name] = function(source, o) {

        if (!source) return;

        let $ = this,
            $$ = win[name],
            hooks = {},
            state = Object.assign({}, $$.state, isString(o) ? {
                'color': o
            } : (o || {})),
            cn = state['class'],
            self = toNode('div', 0, cn);

        // Already instantiated, skip!
        if (source[name]) {
            return $;
        }

        // Return new instance if `CP` was called without the `new` operator
        if (!($ instanceof $$)) {
            return new $$(source, o);
        }

        // Store color picker instance to `CP.instances`
        $$[instances][source.id || source.name || Object.keys($$[instances]).length] = $;

        // Mark current DOM as active color picker to prevent duplicate instance
        source[name] = 1;

        $.visible = false;

        let doEnter,
            doExit,
            doFit,
            doFitTo,
            body = doc.body,
            color = value(),
            data = RGB2HSV(color),
            C = toNode('div', self),
            SV = toNode('div', C, cn + ':sv'),
            H = toNode('div', C, cn + ':h'),
            A = toNode('div', C, cn + ':a'),

            SVColor = toNode('div', SV),
            SVSaturation = toNode('div', SV),
            SVValue = toNode('div', SV),
            SVCursor = toNode('i', SV),

            HColor = toNode('div', H),
            HCursor = toNode('i', H),

            AColor = toNode('div', A),
            APattern = toNode('div', A),
            ACursor = toNode('i', A),

            SVStarting = 0,
            HStarting = 0,
            AStarting = 0,

            SVDragging = 0,
            HDragging = 0,
            ADragging = 0;

        function doApply(isFirst, to) {

            // Refresh value
            data = RGB2HSV(color = value());

            if (!isFirst) {
                (to || state.parent || body).appendChild(self), ($.visible = true);
            }

            doEnter = to => {
                return doApply(0, to), hookFire('enter', color), $;
            };

            doExit = () => {
                let exist = isVisible();
                if (exist) {
                    exist.removeChild(self);
                    $.current = null;
                    $.visible = false;
                }
                eventsLet(SV, downEvents, doDownSV);
                eventsLet(H, downEvents, doDownH);
                eventsLet(A, downEvents, doDownA);
                eventsLet(doc, moveEvents, doMove);
                eventsLet(doc, upEvents, doStop);
                eventsLet(win, resizeEvents, doFitTo);
                return hookFire('exit', color), $;
            };

            doFit = to => {
                let winSize = sizeGet(win),
                    htmlSize = sizeGet(html),
                    scrollBarSizeV = winSize[0] - htmlSize[0], // Vertical scroll bar
                    scrollBarSizeH = winSize[1] - html.clientHeight, // Horizontal scroll bar
                    winOffset = offsetGet(win),
                    sourceOffset = offsetGet(source),
                    selfSize = sizeGet(self),
                    selfSizeWidth = selfSize[0],
                    selfSizeHeight = selfSize[1],
                    selfOffsetLeft = sourceOffset[0] + winOffset[0],
                    selfOffsetTop = sourceOffset[1] + winOffset[1] + sizeGet(source)[1]; // Drop!
                if (isObject(to)) {
                    isSet(to[0]) && (selfOffsetLeft = to[0]);
                    isSet(to[1]) && (selfOffsetTop = to[1]);
                } else {
                    let minX = winOffset[0],
                        minY = winOffset[1],
                        maxX = winOffset[0] + winSize[0] - selfSizeWidth - scrollBarSizeV,
                        maxY = winOffset[1] + winSize[1] - selfSizeHeight - scrollBarSizeH;
                    selfOffsetLeft = toEdge(selfOffsetLeft, [minX, maxX]) >> 0;
                    selfOffsetTop = toEdge(selfOffsetTop, [minY, maxY]) >> 0;
                }
                styleSet(self, left, selfOffsetLeft + px);
                styleSet(self, top, selfOffsetTop + px);
                return hookFire('fit', color), $;
            };

            doFitTo = () => doFit();

            let SVSize = sizeGet(SV),
                SVSizeWidth = SVSize[0],
                SVSizeHeight = SVSize[1],
                SVCursorSize = sizeGet(SVCursor),
                SVCursorSizeWidth = SVCursorSize[0],
                SVCursorSizeHeight = SVCursorSize[1],
                HSizeHeight = sizeGet(H)[1],
                HCursorSizeHeight = sizeGet(HCursor)[1],
                ASizeHeight = sizeGet(A)[1],
                ACursorSizeHeight = sizeGet(ACursor)[1];

            if (isFirst) {
                eventsSet(source, downEvents, doClick);
                delay(() => {
                    hookFire('change', color);
                }, 1);
            } else {
                eventsSet(SV, downEvents, doDownSV);
                eventsSet(H, downEvents, doDownH);
                eventsSet(A, downEvents, doDownA);
                eventsSet(doc, moveEvents, doMove);
                eventsSet(doc, upEvents, doStop);
                eventsSet(win, resizeEvents, doFitTo);
                doFit();
            }

            function doMove(e) {
                SVDragging && cursorSVSet(e);
                HDragging && cursorHSet(e);
                ADragging && cursorASet(e);
                color = P2RGB(data);
                if (SVDragging || HDragging || ADragging) {
                    hookFire((SVStarting || HStarting || AStarting ? 'start' : 'drag'), color);
                    hookFire('change', color);
                }
                SVStarting = HStarting = AStarting = 0;
            }

            function doStop(e) {
                color = P2RGB(data);
                let t = e.target,
                    isSource = source === closestGet(t, source),
                    isSelf = self === closestGet(t, self);
                $.current = null;
                if (!isSource && !isSelf) {
                    if (hooks.blur) {
                        hookFire('blur', color);
                    } else {
                        // Click outside the source or picker element to exit
                        isVisible() && doExit();
                    }
                } else {
                    if (isSelf) {
                        if (SVDragging || HDragging || ADragging) {
                            hookFire('stop', color);
                        }
                    }
                }
                SVDragging = HDragging = ADragging = 0;
            }

            function doDownSV(e) {
                $.current = SV;
                SVStarting = SVDragging = 1;
                doMove(e);
                doPreventDefault(e);
            }

            function doDownH(e) {
                $.current = H;
                HStarting = HDragging = 1;
                doMove(e);
                doPreventDefault(e);
            }

            function doDownA(e) {
                $.current = A;
                AStarting = ADragging = 1;
                doMove(e);
                doPreventDefault(e);
            }

            function cursorSet(x) {
                isSet(x[1]) && styleSet(SVCursor, right, (SVSizeWidth - (SVCursorSizeWidth / 2) - (SVSizeWidth * +x[1])) + px);
                isSet(x[2]) && styleSet(SVCursor, top, (SVSizeHeight - (SVCursorSizeHeight / 2) - (SVSizeHeight * +x[2])) + px);
                isSet(x[0]) && styleSet(HCursor, top, (HSizeHeight - (HCursorSizeHeight / 2) - (HSizeHeight * +x[0])) + px);
                isSet(x[3]) && styleSet(ACursor, top, (ASizeHeight - (ACursorSizeHeight / 2) - (ASizeHeight * +x[3])) + px);
            }

            $.get = () => value();

            $.set = (r, g, b, a) => {
                data = RGB2HSV([r, g, b, a]);
                return colorSet(), $;
            };

            function cursorSVSet(e) {
                let SVPoint = axixGet(SV, e),
                    x = toEdge(SVPoint[0], [0, SVSizeWidth]),
                    y = toEdge(SVPoint[1], [0, SVSizeHeight]);
                data[1] = 1 - ((SVSizeWidth - x) / SVSizeWidth);
                data[2] = (SVSizeHeight - y) / SVSizeHeight;
                colorSet();
            }

            function cursorHSet(e) {
                data[0] = (HSizeHeight - toEdge(axixGet(H, e)[1], [0, HSizeHeight])) / HSizeHeight;
                colorSet();
            }

            function cursorASet(e) {
                data[3] = (ASizeHeight - toEdge(axixGet(A, e)[1], [0, ASizeHeight])) / ASizeHeight;
                colorSet();
            }

            function colorSet() {
                cursorSet(data);
                let a = P2RGB(data),
                    b = P2RGB([data[0], 1, 1]);
                styleSet(SVColor, 'backgroundColor', 'rgb(' + b[0] + ',' + b[1] + ',' + b[2] + ')');
                styleSet(AColor, 'backgroundImage', 'linear-gradient(rgb(' + a[0] + ',' + a[1] + ',' + a[2] + '),transparent)');
            } colorSet();

        } doApply(1);

        function doClick(e) {
            if (hooks.focus) {
                hookFire('focus', color);
            } else {
                let t = e.target,
                    isSource = source === closestGet(t, source);
                if (isSource) {
                    !isVisible() && doEnter(state.parent);
                } else {
                    doExit();
                }
            }
        }

        function hookFire(name, lot) {
            if (!isSet(hooks[name])) {
                return $;
            }
            for (let i = 0, j = hooks[name].length; i < j; ++i) {
                hooks[name][i].apply($, lot);
            }
            return $;
        }

        function hookLet(name, fn) {
            if (!isSet(name)) {
                return (hooks = {}), $;
            }
            if (isSet(hooks[name])) {
                if (isSet(fn)) {
                    for (let i = 0, j = hooks[name].length; i < j; ++i) {
                        if (fn === hooks[name][i]) {
                            hooks[name].splice(i, 1);
                        }
                    }
                    // Clean-up empty hook(s)
                    if (0 === j) {
                        delete hooks[name];
                    }
                } else {
                    delete hooks[name];
                }
            }
            return $;
        }

        function hookSet(name, fn) {
            if (!isSet(hooks[name])) {
                hooks[name] = [];
            }
            if (isSet(fn)) {
                hooks[name].push(fn);
            }
            return $;
        }

        function isVisible() {
            return self.parentNode;
        }

        function value(a) {
            let to = $$[isFunction($$[state.color]) ? state.color : HEX],
                color;
            if (color = source.dataset.color) {
                if (isSet(a)) {
                    return (source.dataset.color = to(color));
                }
                return to(color);
            }
            if (color = source.value) {
                if (isSet(a)) {
                    return (source.value = to(color));
                }
                return to(color);
            }
            if (color = source.textContent) {
                if (isSet(a)) {
                    return (source.textContent = to(color));
                }
                return to(color);
            }
            if (isSet(a)) {
                return; // Do nothing
            }
            return [0, 0, 0, 1]; // Default to black
        }

        $.color = (r, g, b, a) => $$[isFunction($$[state.color]) ? state.color : HEX]([r, g, b, a]);

        $.current = null;
        $.enter = doEnter;
        $.exit = doExit;
        $.fire = hookFire;
        $.fit = doFit;
        $.hooks = hooks;
        $.off = hookLet;
        $.on = hookSet;

        $.pop = () => {
            if (!source[name]) {
                return $; // Already ejected
            }
            delete source[name];
            eventsLet(source, downEvents, doClick);
            return doExit(), hookFire('pop', color);
        };

        $.self = self;
        $.source = source;
        $.state = state;

        $.value = (r, g, b, a) => ($.set(r, g, b, a), hookFire('change', [r, g, b, a]));

    });

})(window, document, 'CP');

Vue.component('v-colorpicker', {
    template: `
        <div class="v-colorpicker">
            <div class="v-colorpicker-sample" :style="bgstyle" @click="picker.enter()"/>
            <input ref="input" type="text" class="v-colorpicker-input" :value="color" @change="inputChanged($event)" :disabled="disabled" @blur="picker.exit()">
        </div>
    `,
    props: ['value', 'disabled'],
    data() {
        return {
            picker: null,
            color: this.value
        };
    },
    computed: {
        bgstyle() {
            if (this.color) {
                const rgba = CP.HEX(this.color);
                return `background-color: rgba(${rgba[0]},${rgba[1]},${rgba[2]},${rgba[3]})`;
            } else {
                return 'background-color: none';
            }
        }
    },
    watch: {
        value: function () {
            this.color = this.value;
        },
    },
    methods: {
        inputChanged(e) {
            this.color = e.target.value;
            const rgba = CP.HEX(this.color);
            if (this.picker.visible) {
                this.picker.set(rgba).enter();
            }
            this.$emit('input', this.color);
        }
    },
    mounted() {
        this.picker = new CP(this.$refs.input);
        this.picker.on('change', (r, g, b, a) => {
            this.color = this.picker.color(r, g, b, a);
            this.$emit('input', this.color);
        });
    }
});

/* flatpickr v4.6.6,, @license MIT */
!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):(e=e||self).flatpickr=n()}(this,(function(){"use strict";var e=function(){return(e=Object.assign||function(e){for(var n,t=1,a=arguments.length;t<a;t++)for(var i in n=arguments[t])Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i]);return e}).apply(this,arguments)};function n(){for(var e=0,n=0,t=arguments.length;n<t;n++)e+=arguments[n].length;var a=Array(e),i=0;for(n=0;n<t;n++)for(var o=arguments[n],r=0,l=o.length;r<l;r++,i++)a[i]=o[r];return a}var t=["onChange","onClose","onDayCreate","onDestroy","onKeyDown","onMonthChange","onOpen","onParseConfig","onReady","onValueUpdate","onYearChange","onPreCalendarPosition"],a={_disable:[],_enable:[],allowInput:!1,allowInvalidPreload:!1,altFormat:"F j, Y",altInput:!1,altInputClass:"form-control input",animate:"object"==typeof window&&-1===window.navigator.userAgent.indexOf("MSIE"),ariaDateFormat:"F j, Y",autoFillDefaultTime:!0,clickOpens:!0,closeOnSelect:!0,conjunction:", ",dateFormat:"Y-m-d",defaultHour:12,defaultMinute:0,defaultSeconds:0,disable:[],disableMobile:!1,enable:[],enableSeconds:!1,enableTime:!1,errorHandler:function(e){return"undefined"!=typeof console&&console.warn(e)},getWeek:function(e){var n=new Date(e.getTime());n.setHours(0,0,0,0),n.setDate(n.getDate()+3-(n.getDay()+6)%7);var t=new Date(n.getFullYear(),0,4);return 1+Math.round(((n.getTime()-t.getTime())/864e5-3+(t.getDay()+6)%7)/7)},hourIncrement:1,ignoredFocusElements:[],inline:!1,locale:"default",minuteIncrement:5,mode:"single",monthSelectorType:"dropdown",nextArrow:"<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",noCalendar:!1,now:new Date,onChange:[],onClose:[],onDayCreate:[],onDestroy:[],onKeyDown:[],onMonthChange:[],onOpen:[],onParseConfig:[],onReady:[],onValueUpdate:[],onYearChange:[],onPreCalendarPosition:[],plugins:[],position:"auto",positionElement:void 0,prevArrow:"<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",shorthandCurrentMonth:!1,showMonths:1,static:!1,time_24hr:!1,weekNumbers:!1,wrap:!1},i={weekdays:{shorthand:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],longhand:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},months:{shorthand:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],longhand:["January","February","March","April","May","June","July","August","September","October","November","December"]},daysInMonth:[31,28,31,30,31,30,31,31,30,31,30,31],firstDayOfWeek:0,ordinal:function(e){var n=e%100;if(n>3&&n<21)return"th";switch(n%10){case 1:return"st";case 2:return"nd";case 3:return"rd";default:return"th"}},rangeSeparator:" to ",weekAbbreviation:"Wk",scrollTitle:"Scroll to increment",toggleTitle:"Click to toggle",amPM:["AM","PM"],yearAriaLabel:"Year",monthAriaLabel:"Month",hourAriaLabel:"Hour",minuteAriaLabel:"Minute",time_24hr:!1},o=function(e,n){return void 0===n&&(n=2),("000"+e).slice(-1*n)},r=function(e){return!0===e?1:0};function l(e,n,t){var a;return void 0===t&&(t=!1),function(){var i=this,o=arguments;null!==a&&clearTimeout(a),a=window.setTimeout((function(){a=null,t||e.apply(i,o)}),n),t&&!a&&e.apply(i,o)}}var c=function(e){return e instanceof Array?e:[e]};function d(e,n,t){if(!0===t)return e.classList.add(n);e.classList.remove(n)}function s(e,n,t){var a=window.document.createElement(e);return n=n||"",t=t||"",a.className=n,void 0!==t&&(a.textContent=t),a}function u(e){for(;e.firstChild;)e.removeChild(e.firstChild)}function f(e,n){var t=s("div","numInputWrapper"),a=s("input","numInput "+e),i=s("span","arrowUp"),o=s("span","arrowDown");if(-1===navigator.userAgent.indexOf("MSIE 9.0")?a.type="number":(a.type="text",a.pattern="\\d*"),void 0!==n)for(var r in n)a.setAttribute(r,n[r]);return t.appendChild(a),t.appendChild(i),t.appendChild(o),t}function m(e){try{return"function"==typeof e.composedPath?e.composedPath()[0]:e.target}catch(n){return e.target}}var g=function(){},p=function(e,n,t){return t.months[n?"shorthand":"longhand"][e]},h={D:g,F:function(e,n,t){e.setMonth(t.months.longhand.indexOf(n))},G:function(e,n){e.setHours(parseFloat(n))},H:function(e,n){e.setHours(parseFloat(n))},J:function(e,n){e.setDate(parseFloat(n))},K:function(e,n,t){e.setHours(e.getHours()%12+12*r(new RegExp(t.amPM[1],"i").test(n)))},M:function(e,n,t){e.setMonth(t.months.shorthand.indexOf(n))},S:function(e,n){e.setSeconds(parseFloat(n))},U:function(e,n){return new Date(1e3*parseFloat(n))},W:function(e,n,t){var a=parseInt(n),i=new Date(e.getFullYear(),0,2+7*(a-1),0,0,0,0);return i.setDate(i.getDate()-i.getDay()+t.firstDayOfWeek),i},Y:function(e,n){e.setFullYear(parseFloat(n))},Z:function(e,n){return new Date(n)},d:function(e,n){e.setDate(parseFloat(n))},h:function(e,n){e.setHours(parseFloat(n))},i:function(e,n){e.setMinutes(parseFloat(n))},j:function(e,n){e.setDate(parseFloat(n))},l:g,m:function(e,n){e.setMonth(parseFloat(n)-1)},n:function(e,n){e.setMonth(parseFloat(n)-1)},s:function(e,n){e.setSeconds(parseFloat(n))},u:function(e,n){return new Date(parseFloat(n))},w:g,y:function(e,n){e.setFullYear(2e3+parseFloat(n))}},v={D:"(\\w+)",F:"(\\w+)",G:"(\\d\\d|\\d)",H:"(\\d\\d|\\d)",J:"(\\d\\d|\\d)\\w+",K:"",M:"(\\w+)",S:"(\\d\\d|\\d)",U:"(.+)",W:"(\\d\\d|\\d)",Y:"(\\d{4})",Z:"(.+)",d:"(\\d\\d|\\d)",h:"(\\d\\d|\\d)",i:"(\\d\\d|\\d)",j:"(\\d\\d|\\d)",l:"(\\w+)",m:"(\\d\\d|\\d)",n:"(\\d\\d|\\d)",s:"(\\d\\d|\\d)",u:"(.+)",w:"(\\d\\d|\\d)",y:"(\\d{2})"},D={Z:function(e){return e.toISOString()},D:function(e,n,t){return n.weekdays.shorthand[D.w(e,n,t)]},F:function(e,n,t){return p(D.n(e,n,t)-1,!1,n)},G:function(e,n,t){return o(D.h(e,n,t))},H:function(e){return o(e.getHours())},J:function(e,n){return void 0!==n.ordinal?e.getDate()+n.ordinal(e.getDate()):e.getDate()},K:function(e,n){return n.amPM[r(e.getHours()>11)]},M:function(e,n){return p(e.getMonth(),!0,n)},S:function(e){return o(e.getSeconds())},U:function(e){return e.getTime()/1e3},W:function(e,n,t){return t.getWeek(e)},Y:function(e){return o(e.getFullYear(),4)},d:function(e){return o(e.getDate())},h:function(e){return e.getHours()%12?e.getHours()%12:12},i:function(e){return o(e.getMinutes())},j:function(e){return e.getDate()},l:function(e,n){return n.weekdays.longhand[e.getDay()]},m:function(e){return o(e.getMonth()+1)},n:function(e){return e.getMonth()+1},s:function(e){return e.getSeconds()},u:function(e){return e.getTime()},w:function(e){return e.getDay()},y:function(e){return String(e.getFullYear()).substring(2)}},w=function(e){var n=e.config,t=void 0===n?a:n,o=e.l10n,r=void 0===o?i:o,l=e.isMobile,c=void 0!==l&&l;return function(e,n,a){var i=a||r;return void 0===t.formatDate||c?n.split("").map((function(n,a,o){return D[n]&&"\\"!==o[a-1]?D[n](e,i,t):"\\"!==n?n:""})).join(""):t.formatDate(e,n,i)}},b=function(e){var n=e.config,t=void 0===n?a:n,o=e.l10n,r=void 0===o?i:o;return function(e,n,i,o){if(0===e||e){var l,c=o||r,d=e;if(e instanceof Date)l=new Date(e.getTime());else if("string"!=typeof e&&void 0!==e.toFixed)l=new Date(e);else if("string"==typeof e){var s=n||(t||a).dateFormat,u=String(e).trim();if("today"===u)l=new Date,i=!0;else if(/Z$/.test(u)||/GMT$/.test(u))l=new Date(e);else if(t&&t.parseDate)l=t.parseDate(e,s);else{l=t&&t.noCalendar?new Date((new Date).setHours(0,0,0,0)):new Date((new Date).getFullYear(),0,1,0,0,0,0);for(var f=void 0,m=[],g=0,p=0,D="";g<s.length;g++){var w=s[g],b="\\"===w,C="\\"===s[g-1]||b;if(v[w]&&!C){D+=v[w];var M=new RegExp(D).exec(e);M&&(f=!0)&&m["Y"!==w?"push":"unshift"]({fn:h[w],val:M[++p]})}else b||(D+=".");m.forEach((function(e){var n=e.fn,t=e.val;return l=n(l,t,c)||l}))}l=f?l:void 0}}if(l instanceof Date&&!isNaN(l.getTime()))return!0===i&&l.setHours(0,0,0,0),l;t.errorHandler(new Error("Invalid date provided: "+d))}}};function C(e,n,t){return void 0===t&&(t=!0),!1!==t?new Date(e.getTime()).setHours(0,0,0,0)-new Date(n.getTime()).setHours(0,0,0,0):e.getTime()-n.getTime()}var M=864e5;"function"!=typeof Object.assign&&(Object.assign=function(e){for(var n=[],t=1;t<arguments.length;t++)n[t-1]=arguments[t];if(!e)throw TypeError("Cannot convert undefined or null to object");for(var a=function(n){n&&Object.keys(n).forEach((function(t){return e[t]=n[t]}))},i=0,o=n;i<o.length;i++){var r=o[i];a(r)}return e});function y(g,h){var D={config:e(e({},a),E.defaultConfig),l10n:i};function y(e){return e.bind(D)}function x(){var e=D.config;!1===e.weekNumbers&&1===e.showMonths||!0!==e.noCalendar&&window.requestAnimationFrame((function(){if(void 0!==D.calendarContainer&&(D.calendarContainer.style.visibility="hidden",D.calendarContainer.style.display="block"),void 0!==D.daysContainer){var n=(D.days.offsetWidth+1)*e.showMonths;D.daysContainer.style.width=n+"px",D.calendarContainer.style.width=n+(void 0!==D.weekWrapper?D.weekWrapper.offsetWidth:0)+"px",D.calendarContainer.style.removeProperty("visibility"),D.calendarContainer.style.removeProperty("display")}}))}function k(e){if(0===D.selectedDates.length){var n=void 0!==D.config.minDate?new Date(D.config.minDate.getTime()):new Date,t=S(),a=t.hours,i=t.minutes,l=t.seconds;n.setHours(a,i,l,0),D.setDate(n,!1)}void 0!==e&&"blur"!==e.type&&function(e){e.preventDefault();var n="keydown"===e.type,t=m(e),a=t;void 0!==D.amPM&&t===D.amPM&&(D.amPM.textContent=D.l10n.amPM[r(D.amPM.textContent===D.l10n.amPM[0])]);var i=parseFloat(a.getAttribute("min")),l=parseFloat(a.getAttribute("max")),c=parseFloat(a.getAttribute("step")),d=parseInt(a.value,10),s=e.delta||(n?38===e.which?1:-1:0),u=d+c*s;if(void 0!==a.value&&2===a.value.length){var f=a===D.hourElement,g=a===D.minuteElement;u<i?(u=l+u+r(!f)+(r(f)&&r(!D.amPM)),g&&Y(void 0,-1,D.hourElement)):u>l&&(u=a===D.hourElement?u-l-r(!D.amPM):i,g&&Y(void 0,1,D.hourElement)),D.amPM&&f&&(1===c?u+d===23:Math.abs(u-d)>c)&&(D.amPM.textContent=D.l10n.amPM[r(D.amPM.textContent===D.l10n.amPM[0])]),a.value=o(u)}}(e);var c=D._input.value;T(),we(),D._input.value!==c&&D._debouncedChange()}function T(){if(void 0!==D.hourElement&&void 0!==D.minuteElement){var e,n,t=(parseInt(D.hourElement.value.slice(-2),10)||0)%24,a=(parseInt(D.minuteElement.value,10)||0)%60,i=void 0!==D.secondElement?(parseInt(D.secondElement.value,10)||0)%60:0;void 0!==D.amPM&&(e=t,n=D.amPM.textContent,t=e%12+12*r(n===D.l10n.amPM[1]));var o=void 0!==D.config.minTime||D.config.minDate&&D.minDateHasTime&&D.latestSelectedDateObj&&0===C(D.latestSelectedDateObj,D.config.minDate,!0);if(void 0!==D.config.maxTime||D.config.maxDate&&D.maxDateHasTime&&D.latestSelectedDateObj&&0===C(D.latestSelectedDateObj,D.config.maxDate,!0)){var l=void 0!==D.config.maxTime?D.config.maxTime:D.config.maxDate;(t=Math.min(t,l.getHours()))===l.getHours()&&(a=Math.min(a,l.getMinutes())),a===l.getMinutes()&&(i=Math.min(i,l.getSeconds()))}if(o){var c=void 0!==D.config.minTime?D.config.minTime:D.config.minDate;(t=Math.max(t,c.getHours()))===c.getHours()&&(a=Math.max(a,c.getMinutes())),a===c.getMinutes()&&(i=Math.max(i,c.getSeconds()))}_(t,a,i)}}function I(e){var n=e||D.latestSelectedDateObj;n&&_(n.getHours(),n.getMinutes(),n.getSeconds())}function S(){var e=D.config.defaultHour,n=D.config.defaultMinute,t=D.config.defaultSeconds;if(void 0!==D.config.minDate){var a=D.config.minDate.getHours(),i=D.config.minDate.getMinutes();(e=Math.max(e,a))===a&&(n=Math.max(i,n)),e===a&&n===i&&(t=D.config.minDate.getSeconds())}if(void 0!==D.config.maxDate){var o=D.config.maxDate.getHours(),r=D.config.maxDate.getMinutes();(e=Math.min(e,o))===o&&(n=Math.min(r,n)),e===o&&n===r&&(t=D.config.maxDate.getSeconds())}return{hours:e,minutes:n,seconds:t}}function _(e,n,t){void 0!==D.latestSelectedDateObj&&D.latestSelectedDateObj.setHours(e%24,n,t||0,0),D.hourElement&&D.minuteElement&&!D.isMobile&&(D.hourElement.value=o(D.config.time_24hr?e:(12+e)%12+12*r(e%12==0)),D.minuteElement.value=o(n),void 0!==D.amPM&&(D.amPM.textContent=D.l10n.amPM[r(e>=12)]),void 0!==D.secondElement&&(D.secondElement.value=o(t)))}function O(e){var n=m(e),t=parseInt(n.value)+(e.delta||0);(t/1e3>1||"Enter"===e.key&&!/[^\d]/.test(t.toString()))&&Z(t)}function F(e,n,t,a){return n instanceof Array?n.forEach((function(n){return F(e,n,t,a)})):e instanceof Array?e.forEach((function(e){return F(e,n,t,a)})):(e.addEventListener(n,t,a),void D._handlers.push({element:e,event:n,handler:t,options:a}))}function N(){ge("onChange")}function A(e,n){var t=void 0!==e?D.parseDate(e):D.latestSelectedDateObj||(D.config.minDate&&D.config.minDate>D.now?D.config.minDate:D.config.maxDate&&D.config.maxDate<D.now?D.config.maxDate:D.now),a=D.currentYear,i=D.currentMonth;try{void 0!==t&&(D.currentYear=t.getFullYear(),D.currentMonth=t.getMonth())}catch(e){e.message="Invalid date supplied: "+t,D.config.errorHandler(e)}n&&D.currentYear!==a&&(ge("onYearChange"),J()),!n||D.currentYear===a&&D.currentMonth===i||ge("onMonthChange"),D.redraw()}function P(e){var n=m(e);~n.className.indexOf("arrow")&&Y(e,n.classList.contains("arrowUp")?1:-1)}function Y(e,n,t){var a=e&&m(e),i=t||a&&a.parentNode&&a.parentNode.firstChild,o=pe("increment");o.delta=n,i&&i.dispatchEvent(o)}function H(e,n,t,a){var i=Q(n,!0),o=s("span","flatpickr-day "+e,n.getDate().toString());return o.dateObj=n,o.$i=a,o.setAttribute("aria-label",D.formatDate(n,D.config.ariaDateFormat)),-1===e.indexOf("hidden")&&0===C(n,D.now)&&(D.todayDateElem=o,o.classList.add("today"),o.setAttribute("aria-current","date")),i?(o.tabIndex=-1,he(n)&&(o.classList.add("selected"),D.selectedDateElem=o,"range"===D.config.mode&&(d(o,"startRange",D.selectedDates[0]&&0===C(n,D.selectedDates[0],!0)),d(o,"endRange",D.selectedDates[1]&&0===C(n,D.selectedDates[1],!0)),"nextMonthDay"===e&&o.classList.add("inRange")))):o.classList.add("flatpickr-disabled"),"range"===D.config.mode&&function(e){return!("range"!==D.config.mode||D.selectedDates.length<2)&&(C(e,D.selectedDates[0])>=0&&C(e,D.selectedDates[1])<=0)}(n)&&!he(n)&&o.classList.add("inRange"),D.weekNumbers&&1===D.config.showMonths&&"prevMonthDay"!==e&&t%7==1&&D.weekNumbers.insertAdjacentHTML("beforeend","<span class='flatpickr-day'>"+D.config.getWeek(n)+"</span>"),ge("onDayCreate",o),o}function j(e){e.focus(),"range"===D.config.mode&&te(e)}function L(e){for(var n=e>0?0:D.config.showMonths-1,t=e>0?D.config.showMonths:-1,a=n;a!=t;a+=e)for(var i=D.daysContainer.children[a],o=e>0?0:i.children.length-1,r=e>0?i.children.length:-1,l=o;l!=r;l+=e){var c=i.children[l];if(-1===c.className.indexOf("hidden")&&Q(c.dateObj))return c}}function W(e,n){var t=X(document.activeElement||document.body),a=void 0!==e?e:t?document.activeElement:void 0!==D.selectedDateElem&&X(D.selectedDateElem)?D.selectedDateElem:void 0!==D.todayDateElem&&X(D.todayDateElem)?D.todayDateElem:L(n>0?1:-1);void 0===a?D._input.focus():t?function(e,n){for(var t=-1===e.className.indexOf("Month")?e.dateObj.getMonth():D.currentMonth,a=n>0?D.config.showMonths:-1,i=n>0?1:-1,o=t-D.currentMonth;o!=a;o+=i)for(var r=D.daysContainer.children[o],l=t-D.currentMonth===o?e.$i+n:n<0?r.children.length-1:0,c=r.children.length,d=l;d>=0&&d<c&&d!=(n>0?c:-1);d+=i){var s=r.children[d];if(-1===s.className.indexOf("hidden")&&Q(s.dateObj)&&Math.abs(e.$i-d)>=Math.abs(n))return j(s)}D.changeMonth(i),W(L(i),0)}(a,n):j(a)}function R(e,n){for(var t=(new Date(e,n,1).getDay()-D.l10n.firstDayOfWeek+7)%7,a=D.utils.getDaysInMonth((n-1+12)%12,e),i=D.utils.getDaysInMonth(n,e),o=window.document.createDocumentFragment(),r=D.config.showMonths>1,l=r?"prevMonthDay hidden":"prevMonthDay",c=r?"nextMonthDay hidden":"nextMonthDay",d=a+1-t,u=0;d<=a;d++,u++)o.appendChild(H(l,new Date(e,n-1,d),d,u));for(d=1;d<=i;d++,u++)o.appendChild(H("",new Date(e,n,d),d,u));for(var f=i+1;f<=42-t&&(1===D.config.showMonths||u%7!=0);f++,u++)o.appendChild(H(c,new Date(e,n+1,f%i),f,u));var m=s("div","dayContainer");return m.appendChild(o),m}function B(){if(void 0!==D.daysContainer){u(D.daysContainer),D.weekNumbers&&u(D.weekNumbers);for(var e=document.createDocumentFragment(),n=0;n<D.config.showMonths;n++){var t=new Date(D.currentYear,D.currentMonth,1);t.setMonth(D.currentMonth+n),e.appendChild(R(t.getFullYear(),t.getMonth()))}D.daysContainer.appendChild(e),D.days=D.daysContainer.firstChild,"range"===D.config.mode&&1===D.selectedDates.length&&te()}}function J(){if(!(D.config.showMonths>1||"dropdown"!==D.config.monthSelectorType)){var e=function(e){return!(void 0!==D.config.minDate&&D.currentYear===D.config.minDate.getFullYear()&&e<D.config.minDate.getMonth())&&!(void 0!==D.config.maxDate&&D.currentYear===D.config.maxDate.getFullYear()&&e>D.config.maxDate.getMonth())};D.monthsDropdownContainer.tabIndex=-1,D.monthsDropdownContainer.innerHTML="";for(var n=0;n<12;n++)if(e(n)){var t=s("option","flatpickr-monthDropdown-month");t.value=new Date(D.currentYear,n).getMonth().toString(),t.textContent=p(n,D.config.shorthandCurrentMonth,D.l10n),t.tabIndex=-1,D.currentMonth===n&&(t.selected=!0),D.monthsDropdownContainer.appendChild(t)}}}function K(){var e,n=s("div","flatpickr-month"),t=window.document.createDocumentFragment();D.config.showMonths>1||"static"===D.config.monthSelectorType?e=s("span","cur-month"):(D.monthsDropdownContainer=s("select","flatpickr-monthDropdown-months"),D.monthsDropdownContainer.setAttribute("aria-label",D.l10n.monthAriaLabel),F(D.monthsDropdownContainer,"change",(function(e){var n=m(e),t=parseInt(n.value,10);D.changeMonth(t-D.currentMonth),ge("onMonthChange")})),J(),e=D.monthsDropdownContainer);var a=f("cur-year",{tabindex:"-1"}),i=a.getElementsByTagName("input")[0];i.setAttribute("aria-label",D.l10n.yearAriaLabel),D.config.minDate&&i.setAttribute("min",D.config.minDate.getFullYear().toString()),D.config.maxDate&&(i.setAttribute("max",D.config.maxDate.getFullYear().toString()),i.disabled=!!D.config.minDate&&D.config.minDate.getFullYear()===D.config.maxDate.getFullYear());var o=s("div","flatpickr-current-month");return o.appendChild(e),o.appendChild(a),t.appendChild(o),n.appendChild(t),{container:n,yearElement:i,monthElement:e}}function U(){u(D.monthNav),D.monthNav.appendChild(D.prevMonthNav),D.config.showMonths&&(D.yearElements=[],D.monthElements=[]);for(var e=D.config.showMonths;e--;){var n=K();D.yearElements.push(n.yearElement),D.monthElements.push(n.monthElement),D.monthNav.appendChild(n.container)}D.monthNav.appendChild(D.nextMonthNav)}function q(){D.weekdayContainer?u(D.weekdayContainer):D.weekdayContainer=s("div","flatpickr-weekdays");for(var e=D.config.showMonths;e--;){var n=s("div","flatpickr-weekdaycontainer");D.weekdayContainer.appendChild(n)}return $(),D.weekdayContainer}function $(){if(D.weekdayContainer){var e=D.l10n.firstDayOfWeek,t=n(D.l10n.weekdays.shorthand);e>0&&e<t.length&&(t=n(t.splice(e,t.length),t.splice(0,e)));for(var a=D.config.showMonths;a--;)D.weekdayContainer.children[a].innerHTML="\n      <span class='flatpickr-weekday'>\n        "+t.join("</span><span class='flatpickr-weekday'>")+"\n      </span>\n      "}}function z(e,n){void 0===n&&(n=!0);var t=n?e:e-D.currentMonth;t<0&&!0===D._hidePrevMonthArrow||t>0&&!0===D._hideNextMonthArrow||(D.currentMonth+=t,(D.currentMonth<0||D.currentMonth>11)&&(D.currentYear+=D.currentMonth>11?1:-1,D.currentMonth=(D.currentMonth+12)%12,ge("onYearChange"),J()),B(),ge("onMonthChange"),ve())}function G(e){return!(!D.config.appendTo||!D.config.appendTo.contains(e))||D.calendarContainer.contains(e)}function V(e){if(D.isOpen&&!D.config.inline){var n=m(e),t=G(n),a=n===D.input||n===D.altInput||D.element.contains(n)||e.path&&e.path.indexOf&&(~e.path.indexOf(D.input)||~e.path.indexOf(D.altInput)),i="blur"===e.type?a&&e.relatedTarget&&!G(e.relatedTarget):!a&&!t&&!G(e.relatedTarget),o=!D.config.ignoredFocusElements.some((function(e){return e.contains(n)}));i&&o&&(void 0!==D.timeContainer&&void 0!==D.minuteElement&&void 0!==D.hourElement&&""!==D.input.value&&void 0!==D.input.value&&k(),D.close(),D.config&&"range"===D.config.mode&&1===D.selectedDates.length&&(D.clear(!1),D.redraw()))}}function Z(e){if(!(!e||D.config.minDate&&e<D.config.minDate.getFullYear()||D.config.maxDate&&e>D.config.maxDate.getFullYear())){var n=e,t=D.currentYear!==n;D.currentYear=n||D.currentYear,D.config.maxDate&&D.currentYear===D.config.maxDate.getFullYear()?D.currentMonth=Math.min(D.config.maxDate.getMonth(),D.currentMonth):D.config.minDate&&D.currentYear===D.config.minDate.getFullYear()&&(D.currentMonth=Math.max(D.config.minDate.getMonth(),D.currentMonth)),t&&(D.redraw(),ge("onYearChange"),J())}}function Q(e,n){void 0===n&&(n=!0);var t=D.parseDate(e,void 0,n);if(D.config.minDate&&t&&C(t,D.config.minDate,void 0!==n?n:!D.minDateHasTime)<0||D.config.maxDate&&t&&C(t,D.config.maxDate,void 0!==n?n:!D.maxDateHasTime)>0)return!1;if(0===D.config.enable.length&&0===D.config.disable.length)return!0;if(void 0===t)return!1;for(var a=D.config.enable.length>0,i=a?D.config.enable:D.config.disable,o=0,r=void 0;o<i.length;o++){if("function"==typeof(r=i[o])&&r(t))return a;if(r instanceof Date&&void 0!==t&&r.getTime()===t.getTime())return a;if("string"==typeof r&&void 0!==t){var l=D.parseDate(r,void 0,!0);return l&&l.getTime()===t.getTime()?a:!a}if("object"==typeof r&&void 0!==t&&r.from&&r.to&&t.getTime()>=r.from.getTime()&&t.getTime()<=r.to.getTime())return a}return!a}function X(e){return void 0!==D.daysContainer&&(-1===e.className.indexOf("hidden")&&-1===e.className.indexOf("flatpickr-disabled")&&D.daysContainer.contains(e))}function ee(e){!(e.target===D._input)||e.relatedTarget&&G(e.relatedTarget)||D.setDate(D._input.value,!0,e.target===D.altInput?D.config.altFormat:D.config.dateFormat)}function ne(e){var n=m(e),t=D.config.wrap?g.contains(n):n===D._input,a=D.config.allowInput,i=D.isOpen&&(!a||!t),o=D.config.inline&&t&&!a;if(13===e.keyCode&&t){if(a)return D.setDate(D._input.value,!0,n===D.altInput?D.config.altFormat:D.config.dateFormat),n.blur();D.open()}else if(G(n)||i||o){var r=!!D.timeContainer&&D.timeContainer.contains(n);switch(e.keyCode){case 13:r?(e.preventDefault(),k(),de()):se(e);break;case 27:e.preventDefault(),de();break;case 8:case 46:t&&!D.config.allowInput&&(e.preventDefault(),D.clear());break;case 37:case 39:if(r||t)D.hourElement&&D.hourElement.focus();else if(e.preventDefault(),void 0!==D.daysContainer&&(!1===a||document.activeElement&&X(document.activeElement))){var l=39===e.keyCode?1:-1;e.ctrlKey?(e.stopPropagation(),z(l),W(L(1),0)):W(void 0,l)}break;case 38:case 40:e.preventDefault();var c=40===e.keyCode?1:-1;D.daysContainer&&void 0!==n.$i||n===D.input||n===D.altInput?e.ctrlKey?(e.stopPropagation(),Z(D.currentYear-c),W(L(1),0)):r||W(void 0,7*c):n===D.currentYearElement?Z(D.currentYear-c):D.config.enableTime&&(!r&&D.hourElement&&D.hourElement.focus(),k(e),D._debouncedChange());break;case 9:if(r){var d=[D.hourElement,D.minuteElement,D.secondElement,D.amPM].concat(D.pluginElements).filter((function(e){return e})),s=d.indexOf(n);if(-1!==s){var u=d[s+(e.shiftKey?-1:1)];e.preventDefault(),(u||D._input).focus()}}else!D.config.noCalendar&&D.daysContainer&&D.daysContainer.contains(n)&&e.shiftKey&&(e.preventDefault(),D._input.focus())}}if(void 0!==D.amPM&&n===D.amPM)switch(e.key){case D.l10n.amPM[0].charAt(0):case D.l10n.amPM[0].charAt(0).toLowerCase():D.amPM.textContent=D.l10n.amPM[0],T(),we();break;case D.l10n.amPM[1].charAt(0):case D.l10n.amPM[1].charAt(0).toLowerCase():D.amPM.textContent=D.l10n.amPM[1],T(),we()}(t||G(n))&&ge("onKeyDown",e)}function te(e){if(1===D.selectedDates.length&&(!e||e.classList.contains("flatpickr-day")&&!e.classList.contains("flatpickr-disabled"))){for(var n=e?e.dateObj.getTime():D.days.firstElementChild.dateObj.getTime(),t=D.parseDate(D.selectedDates[0],void 0,!0).getTime(),a=Math.min(n,D.selectedDates[0].getTime()),i=Math.max(n,D.selectedDates[0].getTime()),o=!1,r=0,l=0,c=a;c<i;c+=M)Q(new Date(c),!0)||(o=o||c>a&&c<i,c<t&&(!r||c>r)?r=c:c>t&&(!l||c<l)&&(l=c));for(var d=0;d<D.config.showMonths;d++)for(var s=D.daysContainer.children[d],u=function(a,i){var c,d,u,f=s.children[a],m=f.dateObj.getTime(),g=r>0&&m<r||l>0&&m>l;return g?(f.classList.add("notAllowed"),["inRange","startRange","endRange"].forEach((function(e){f.classList.remove(e)})),"continue"):o&&!g?"continue":(["startRange","inRange","endRange","notAllowed"].forEach((function(e){f.classList.remove(e)})),void(void 0!==e&&(e.classList.add(n<=D.selectedDates[0].getTime()?"startRange":"endRange"),t<n&&m===t?f.classList.add("startRange"):t>n&&m===t&&f.classList.add("endRange"),m>=r&&(0===l||m<=l)&&(d=t,u=n,(c=m)>Math.min(d,u)&&c<Math.max(d,u))&&f.classList.add("inRange"))))},f=0,m=s.children.length;f<m;f++)u(f)}}function ae(){!D.isOpen||D.config.static||D.config.inline||le()}function ie(e){return function(n){var t=D.config["_"+e+"Date"]=D.parseDate(n,D.config.dateFormat),a=D.config["_"+("min"===e?"max":"min")+"Date"];void 0!==t&&(D["min"===e?"minDateHasTime":"maxDateHasTime"]=t.getHours()>0||t.getMinutes()>0||t.getSeconds()>0),D.selectedDates&&(D.selectedDates=D.selectedDates.filter((function(e){return Q(e)})),D.selectedDates.length||"min"!==e||I(t),we()),D.daysContainer&&(ce(),void 0!==t?D.currentYearElement[e]=t.getFullYear().toString():D.currentYearElement.removeAttribute(e),D.currentYearElement.disabled=!!a&&void 0!==t&&a.getFullYear()===t.getFullYear())}}function oe(){return D.config.wrap?g.querySelector("[data-input]"):g}function re(){"object"!=typeof D.config.locale&&void 0===E.l10ns[D.config.locale]&&D.config.errorHandler(new Error("flatpickr: invalid locale "+D.config.locale)),D.l10n=e(e({},E.l10ns.default),"object"==typeof D.config.locale?D.config.locale:"default"!==D.config.locale?E.l10ns[D.config.locale]:void 0),v.K="("+D.l10n.amPM[0]+"|"+D.l10n.amPM[1]+"|"+D.l10n.amPM[0].toLowerCase()+"|"+D.l10n.amPM[1].toLowerCase()+")",void 0===e(e({},h),JSON.parse(JSON.stringify(g.dataset||{}))).time_24hr&&void 0===E.defaultConfig.time_24hr&&(D.config.time_24hr=D.l10n.time_24hr),D.formatDate=w(D),D.parseDate=b({config:D.config,l10n:D.l10n})}function le(e){if(void 0!==D.calendarContainer){ge("onPreCalendarPosition");var n=e||D._positionElement,t=Array.prototype.reduce.call(D.calendarContainer.children,(function(e,n){return e+n.offsetHeight}),0),a=D.calendarContainer.offsetWidth,i=D.config.position.split(" "),o=i[0],r=i.length>1?i[1]:null,l=n.getBoundingClientRect(),c=window.innerHeight-l.bottom,s="above"===o||"below"!==o&&c<t&&l.top>t,u=window.pageYOffset+l.top+(s?-t-2:n.offsetHeight+2);if(d(D.calendarContainer,"arrowTop",!s),d(D.calendarContainer,"arrowBottom",s),!D.config.inline){var f=window.pageXOffset+l.left,m=!1,g=!1;"center"===r?(f-=(a-l.width)/2,m=!0):"right"===r&&(f-=a-l.width,g=!0),d(D.calendarContainer,"arrowLeft",!m&&!g),d(D.calendarContainer,"arrowCenter",m),d(D.calendarContainer,"arrowRight",g);var p=window.document.body.offsetWidth-(window.pageXOffset+l.right),h=f+a>window.document.body.offsetWidth,v=p+a>window.document.body.offsetWidth;if(d(D.calendarContainer,"rightMost",h),!D.config.static)if(D.calendarContainer.style.top=u+"px",h)if(v){var w=function(){for(var e=null,n=0;n<document.styleSheets.length;n++){var t=document.styleSheets[n];try{t.cssRules}catch(e){continue}e=t;break}return null!=e?e:(a=document.createElement("style"),document.head.appendChild(a),a.sheet);var a}();if(void 0===w)return;var b=window.document.body.offsetWidth,C=Math.max(0,b/2-a/2),M=w.cssRules.length,y="{left:"+l.left+"px;right:auto;}";d(D.calendarContainer,"rightMost",!1),d(D.calendarContainer,"centerMost",!0),w.insertRule(".flatpickr-calendar.centerMost:before,.flatpickr-calendar.centerMost:after"+y,M),D.calendarContainer.style.left=C+"px",D.calendarContainer.style.right="auto"}else D.calendarContainer.style.left="auto",D.calendarContainer.style.right=p+"px";else D.calendarContainer.style.left=f+"px",D.calendarContainer.style.right="auto"}}}function ce(){D.config.noCalendar||D.isMobile||(J(),ve(),B())}function de(){D._input.focus(),-1!==window.navigator.userAgent.indexOf("MSIE")||void 0!==navigator.msMaxTouchPoints?setTimeout(D.close,0):D.close()}function se(e){e.preventDefault(),e.stopPropagation();var n=function e(n,t){return t(n)?n:n.parentNode?e(n.parentNode,t):void 0}(m(e),(function(e){return e.classList&&e.classList.contains("flatpickr-day")&&!e.classList.contains("flatpickr-disabled")&&!e.classList.contains("notAllowed")}));if(void 0!==n){var t=n,a=D.latestSelectedDateObj=new Date(t.dateObj.getTime()),i=(a.getMonth()<D.currentMonth||a.getMonth()>D.currentMonth+D.config.showMonths-1)&&"range"!==D.config.mode;if(D.selectedDateElem=t,"single"===D.config.mode)D.selectedDates=[a];else if("multiple"===D.config.mode){var o=he(a);o?D.selectedDates.splice(parseInt(o),1):D.selectedDates.push(a)}else"range"===D.config.mode&&(2===D.selectedDates.length&&D.clear(!1,!1),D.latestSelectedDateObj=a,D.selectedDates.push(a),0!==C(a,D.selectedDates[0],!0)&&D.selectedDates.sort((function(e,n){return e.getTime()-n.getTime()})));if(T(),i){var r=D.currentYear!==a.getFullYear();D.currentYear=a.getFullYear(),D.currentMonth=a.getMonth(),r&&(ge("onYearChange"),J()),ge("onMonthChange")}if(ve(),B(),we(),i||"range"===D.config.mode||1!==D.config.showMonths?void 0!==D.selectedDateElem&&void 0===D.hourElement&&D.selectedDateElem&&D.selectedDateElem.focus():j(t),void 0!==D.hourElement&&void 0!==D.hourElement&&D.hourElement.focus(),D.config.closeOnSelect){var l="single"===D.config.mode&&!D.config.enableTime,c="range"===D.config.mode&&2===D.selectedDates.length&&!D.config.enableTime;(l||c)&&de()}N()}}D.parseDate=b({config:D.config,l10n:D.l10n}),D._handlers=[],D.pluginElements=[],D.loadedPlugins=[],D._bind=F,D._setHoursFromDate=I,D._positionCalendar=le,D.changeMonth=z,D.changeYear=Z,D.clear=function(e,n){void 0===e&&(e=!0);void 0===n&&(n=!0);D.input.value="",void 0!==D.altInput&&(D.altInput.value="");void 0!==D.mobileInput&&(D.mobileInput.value="");D.selectedDates=[],D.latestSelectedDateObj=void 0,!0===n&&(D.currentYear=D._initialDate.getFullYear(),D.currentMonth=D._initialDate.getMonth());if(!0===D.config.enableTime){var t=S(),a=t.hours,i=t.minutes,o=t.seconds;_(a,i,o)}D.redraw(),e&&ge("onChange")},D.close=function(){D.isOpen=!1,D.isMobile||(void 0!==D.calendarContainer&&D.calendarContainer.classList.remove("open"),void 0!==D._input&&D._input.classList.remove("active"));ge("onClose")},D._createElement=s,D.destroy=function(){void 0!==D.config&&ge("onDestroy");for(var e=D._handlers.length;e--;){var n=D._handlers[e];n.element.removeEventListener(n.event,n.handler,n.options)}if(D._handlers=[],D.mobileInput)D.mobileInput.parentNode&&D.mobileInput.parentNode.removeChild(D.mobileInput),D.mobileInput=void 0;else if(D.calendarContainer&&D.calendarContainer.parentNode)if(D.config.static&&D.calendarContainer.parentNode){var t=D.calendarContainer.parentNode;if(t.lastChild&&t.removeChild(t.lastChild),t.parentNode){for(;t.firstChild;)t.parentNode.insertBefore(t.firstChild,t);t.parentNode.removeChild(t)}}else D.calendarContainer.parentNode.removeChild(D.calendarContainer);D.altInput&&(D.input.type="text",D.altInput.parentNode&&D.altInput.parentNode.removeChild(D.altInput),delete D.altInput);D.input&&(D.input.type=D.input._type,D.input.classList.remove("flatpickr-input"),D.input.removeAttribute("readonly"));["_showTimeInput","latestSelectedDateObj","_hideNextMonthArrow","_hidePrevMonthArrow","__hideNextMonthArrow","__hidePrevMonthArrow","isMobile","isOpen","selectedDateElem","minDateHasTime","maxDateHasTime","days","daysContainer","_input","_positionElement","innerContainer","rContainer","monthNav","todayDateElem","calendarContainer","weekdayContainer","prevMonthNav","nextMonthNav","monthsDropdownContainer","currentMonthElement","currentYearElement","navigationCurrentMonth","selectedDateElem","config"].forEach((function(e){try{delete D[e]}catch(e){}}))},D.isEnabled=Q,D.jumpToDate=A,D.open=function(e,n){void 0===n&&(n=D._positionElement);if(!0===D.isMobile){if(e){e.preventDefault();var t=m(e);t&&t.blur()}return void 0!==D.mobileInput&&(D.mobileInput.focus(),D.mobileInput.click()),void ge("onOpen")}if(D._input.disabled||D.config.inline)return;var a=D.isOpen;D.isOpen=!0,a||(D.calendarContainer.classList.add("open"),D._input.classList.add("active"),ge("onOpen"),le(n));!0===D.config.enableTime&&!0===D.config.noCalendar&&(!1!==D.config.allowInput||void 0!==e&&D.timeContainer.contains(e.relatedTarget)||setTimeout((function(){return D.hourElement.select()}),50))},D.redraw=ce,D.set=function(e,n){if(null!==e&&"object"==typeof e)for(var a in Object.assign(D.config,e),e)void 0!==ue[a]&&ue[a].forEach((function(e){return e()}));else D.config[e]=n,void 0!==ue[e]?ue[e].forEach((function(e){return e()})):t.indexOf(e)>-1&&(D.config[e]=c(n));D.redraw(),we(!0)},D.setDate=function(e,n,t){void 0===n&&(n=!1);void 0===t&&(t=D.config.dateFormat);if(0!==e&&!e||e instanceof Array&&0===e.length)return D.clear(n);fe(e,t),D.latestSelectedDateObj=D.selectedDates[D.selectedDates.length-1],D.redraw(),A(void 0,n),I(),0===D.selectedDates.length&&D.clear(!1);we(n),n&&ge("onChange")},D.toggle=function(e){if(!0===D.isOpen)return D.close();D.open(e)};var ue={locale:[re,$],showMonths:[U,x,q],minDate:[A],maxDate:[A]};function fe(e,n){var t=[];if(e instanceof Array)t=e.map((function(e){return D.parseDate(e,n)}));else if(e instanceof Date||"number"==typeof e)t=[D.parseDate(e,n)];else if("string"==typeof e)switch(D.config.mode){case"single":case"time":t=[D.parseDate(e,n)];break;case"multiple":t=e.split(D.config.conjunction).map((function(e){return D.parseDate(e,n)}));break;case"range":t=e.split(D.l10n.rangeSeparator).map((function(e){return D.parseDate(e,n)}))}else D.config.errorHandler(new Error("Invalid date supplied: "+JSON.stringify(e)));D.selectedDates=D.config.allowInvalidPreload?t:t.filter((function(e){return e instanceof Date&&Q(e,!1)})),"range"===D.config.mode&&D.selectedDates.sort((function(e,n){return e.getTime()-n.getTime()}))}function me(e){return e.slice().map((function(e){return"string"==typeof e||"number"==typeof e||e instanceof Date?D.parseDate(e,void 0,!0):e&&"object"==typeof e&&e.from&&e.to?{from:D.parseDate(e.from,void 0),to:D.parseDate(e.to,void 0)}:e})).filter((function(e){return e}))}function ge(e,n){if(void 0!==D.config){var t=D.config[e];if(void 0!==t&&t.length>0)for(var a=0;t[a]&&a<t.length;a++)t[a](D.selectedDates,D.input.value,D,n);"onChange"===e&&(D.input.dispatchEvent(pe("change")),D.input.dispatchEvent(pe("input")))}}function pe(e){var n=document.createEvent("Event");return n.initEvent(e,!0,!0),n}function he(e){for(var n=0;n<D.selectedDates.length;n++)if(0===C(D.selectedDates[n],e))return""+n;return!1}function ve(){D.config.noCalendar||D.isMobile||!D.monthNav||(D.yearElements.forEach((function(e,n){var t=new Date(D.currentYear,D.currentMonth,1);t.setMonth(D.currentMonth+n),D.config.showMonths>1||"static"===D.config.monthSelectorType?D.monthElements[n].textContent=p(t.getMonth(),D.config.shorthandCurrentMonth,D.l10n)+" ":D.monthsDropdownContainer.value=t.getMonth().toString(),e.value=t.getFullYear().toString()})),D._hidePrevMonthArrow=void 0!==D.config.minDate&&(D.currentYear===D.config.minDate.getFullYear()?D.currentMonth<=D.config.minDate.getMonth():D.currentYear<D.config.minDate.getFullYear()),D._hideNextMonthArrow=void 0!==D.config.maxDate&&(D.currentYear===D.config.maxDate.getFullYear()?D.currentMonth+1>D.config.maxDate.getMonth():D.currentYear>D.config.maxDate.getFullYear()))}function De(e){return D.selectedDates.map((function(n){return D.formatDate(n,e)})).filter((function(e,n,t){return"range"!==D.config.mode||D.config.enableTime||t.indexOf(e)===n})).join("range"!==D.config.mode?D.config.conjunction:D.l10n.rangeSeparator)}function we(e){void 0===e&&(e=!0),void 0!==D.mobileInput&&D.mobileFormatStr&&(D.mobileInput.value=void 0!==D.latestSelectedDateObj?D.formatDate(D.latestSelectedDateObj,D.mobileFormatStr):""),D.input.value=De(D.config.dateFormat),void 0!==D.altInput&&(D.altInput.value=De(D.config.altFormat)),!1!==e&&ge("onValueUpdate")}function be(e){var n=m(e),t=D.prevMonthNav.contains(n),a=D.nextMonthNav.contains(n);t||a?z(t?-1:1):D.yearElements.indexOf(n)>=0?n.select():n.classList.contains("arrowUp")?D.changeYear(D.currentYear+1):n.classList.contains("arrowDown")&&D.changeYear(D.currentYear-1)}return function(){D.element=D.input=g,D.isOpen=!1,function(){var n=["wrap","weekNumbers","allowInput","allowInvalidPreload","clickOpens","time_24hr","enableTime","noCalendar","altInput","shorthandCurrentMonth","inline","static","enableSeconds","disableMobile"],i=e(e({},JSON.parse(JSON.stringify(g.dataset||{}))),h),o={};D.config.parseDate=i.parseDate,D.config.formatDate=i.formatDate,Object.defineProperty(D.config,"enable",{get:function(){return D.config._enable},set:function(e){D.config._enable=me(e)}}),Object.defineProperty(D.config,"disable",{get:function(){return D.config._disable},set:function(e){D.config._disable=me(e)}});var r="time"===i.mode;if(!i.dateFormat&&(i.enableTime||r)){var l=E.defaultConfig.dateFormat||a.dateFormat;o.dateFormat=i.noCalendar||r?"H:i"+(i.enableSeconds?":S":""):l+" H:i"+(i.enableSeconds?":S":"")}if(i.altInput&&(i.enableTime||r)&&!i.altFormat){var d=E.defaultConfig.altFormat||a.altFormat;o.altFormat=i.noCalendar||r?"h:i"+(i.enableSeconds?":S K":" K"):d+" h:i"+(i.enableSeconds?":S":"")+" K"}Object.defineProperty(D.config,"minDate",{get:function(){return D.config._minDate},set:ie("min")}),Object.defineProperty(D.config,"maxDate",{get:function(){return D.config._maxDate},set:ie("max")});var s=function(e){return function(n){D.config["min"===e?"_minTime":"_maxTime"]=D.parseDate(n,"H:i:S")}};Object.defineProperty(D.config,"minTime",{get:function(){return D.config._minTime},set:s("min")}),Object.defineProperty(D.config,"maxTime",{get:function(){return D.config._maxTime},set:s("max")}),"time"===i.mode&&(D.config.noCalendar=!0,D.config.enableTime=!0);Object.assign(D.config,o,i);for(var u=0;u<n.length;u++)D.config[n[u]]=!0===D.config[n[u]]||"true"===D.config[n[u]];t.filter((function(e){return void 0!==D.config[e]})).forEach((function(e){D.config[e]=c(D.config[e]||[]).map(y)})),D.isMobile=!D.config.disableMobile&&!D.config.inline&&"single"===D.config.mode&&!D.config.disable.length&&!D.config.enable.length&&!D.config.weekNumbers&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);for(u=0;u<D.config.plugins.length;u++){var f=D.config.plugins[u](D)||{};for(var m in f)t.indexOf(m)>-1?D.config[m]=c(f[m]).map(y).concat(D.config[m]):void 0===i[m]&&(D.config[m]=f[m])}i.altInputClass||(D.config.altInputClass=oe().className+" "+D.config.altInputClass);ge("onParseConfig")}(),re(),function(){if(D.input=oe(),!D.input)return void D.config.errorHandler(new Error("Invalid input element specified"));D.input._type=D.input.type,D.input.type="text",D.input.classList.add("flatpickr-input"),D._input=D.input,D.config.altInput&&(D.altInput=s(D.input.nodeName,D.config.altInputClass),D._input=D.altInput,D.altInput.placeholder=D.input.placeholder,D.altInput.disabled=D.input.disabled,D.altInput.required=D.input.required,D.altInput.tabIndex=D.input.tabIndex,D.altInput.type="text",D.input.setAttribute("type","hidden"),!D.config.static&&D.input.parentNode&&D.input.parentNode.insertBefore(D.altInput,D.input.nextSibling));D.config.allowInput||D._input.setAttribute("readonly","readonly");D._positionElement=D.config.positionElement||D._input}(),function(){D.selectedDates=[],D.now=D.parseDate(D.config.now)||new Date;var e=D.config.defaultDate||("INPUT"!==D.input.nodeName&&"TEXTAREA"!==D.input.nodeName||!D.input.placeholder||D.input.value!==D.input.placeholder?D.input.value:null);e&&fe(e,D.config.dateFormat);D._initialDate=D.selectedDates.length>0?D.selectedDates[0]:D.config.minDate&&D.config.minDate.getTime()>D.now.getTime()?D.config.minDate:D.config.maxDate&&D.config.maxDate.getTime()<D.now.getTime()?D.config.maxDate:D.now,D.currentYear=D._initialDate.getFullYear(),D.currentMonth=D._initialDate.getMonth(),D.selectedDates.length>0&&(D.latestSelectedDateObj=D.selectedDates[0]);void 0!==D.config.minTime&&(D.config.minTime=D.parseDate(D.config.minTime,"H:i"));void 0!==D.config.maxTime&&(D.config.maxTime=D.parseDate(D.config.maxTime,"H:i"));D.minDateHasTime=!!D.config.minDate&&(D.config.minDate.getHours()>0||D.config.minDate.getMinutes()>0||D.config.minDate.getSeconds()>0),D.maxDateHasTime=!!D.config.maxDate&&(D.config.maxDate.getHours()>0||D.config.maxDate.getMinutes()>0||D.config.maxDate.getSeconds()>0)}(),D.utils={getDaysInMonth:function(e,n){return void 0===e&&(e=D.currentMonth),void 0===n&&(n=D.currentYear),1===e&&(n%4==0&&n%100!=0||n%400==0)?29:D.l10n.daysInMonth[e]}},D.isMobile||function(){var e=window.document.createDocumentFragment();if(D.calendarContainer=s("div","flatpickr-calendar"),D.calendarContainer.tabIndex=-1,!D.config.noCalendar){if(e.appendChild((D.monthNav=s("div","flatpickr-months"),D.yearElements=[],D.monthElements=[],D.prevMonthNav=s("span","flatpickr-prev-month"),D.prevMonthNav.innerHTML=D.config.prevArrow,D.nextMonthNav=s("span","flatpickr-next-month"),D.nextMonthNav.innerHTML=D.config.nextArrow,U(),Object.defineProperty(D,"_hidePrevMonthArrow",{get:function(){return D.__hidePrevMonthArrow},set:function(e){D.__hidePrevMonthArrow!==e&&(d(D.prevMonthNav,"flatpickr-disabled",e),D.__hidePrevMonthArrow=e)}}),Object.defineProperty(D,"_hideNextMonthArrow",{get:function(){return D.__hideNextMonthArrow},set:function(e){D.__hideNextMonthArrow!==e&&(d(D.nextMonthNav,"flatpickr-disabled",e),D.__hideNextMonthArrow=e)}}),D.currentYearElement=D.yearElements[0],ve(),D.monthNav)),D.innerContainer=s("div","flatpickr-innerContainer"),D.config.weekNumbers){var n=function(){D.calendarContainer.classList.add("hasWeeks");var e=s("div","flatpickr-weekwrapper");e.appendChild(s("span","flatpickr-weekday",D.l10n.weekAbbreviation));var n=s("div","flatpickr-weeks");return e.appendChild(n),{weekWrapper:e,weekNumbers:n}}(),t=n.weekWrapper,a=n.weekNumbers;D.innerContainer.appendChild(t),D.weekNumbers=a,D.weekWrapper=t}D.rContainer=s("div","flatpickr-rContainer"),D.rContainer.appendChild(q()),D.daysContainer||(D.daysContainer=s("div","flatpickr-days"),D.daysContainer.tabIndex=-1),B(),D.rContainer.appendChild(D.daysContainer),D.innerContainer.appendChild(D.rContainer),e.appendChild(D.innerContainer)}D.config.enableTime&&e.appendChild(function(){D.calendarContainer.classList.add("hasTime"),D.config.noCalendar&&D.calendarContainer.classList.add("noCalendar");D.timeContainer=s("div","flatpickr-time"),D.timeContainer.tabIndex=-1;var e=s("span","flatpickr-time-separator",":"),n=f("flatpickr-hour",{"aria-label":D.l10n.hourAriaLabel});D.hourElement=n.getElementsByTagName("input")[0];var t=f("flatpickr-minute",{"aria-label":D.l10n.minuteAriaLabel});D.minuteElement=t.getElementsByTagName("input")[0],D.hourElement.tabIndex=D.minuteElement.tabIndex=-1,D.hourElement.value=o(D.latestSelectedDateObj?D.latestSelectedDateObj.getHours():D.config.time_24hr?D.config.defaultHour:function(e){switch(e%24){case 0:case 12:return 12;default:return e%12}}(D.config.defaultHour)),D.minuteElement.value=o(D.latestSelectedDateObj?D.latestSelectedDateObj.getMinutes():D.config.defaultMinute),D.hourElement.setAttribute("step",D.config.hourIncrement.toString()),D.minuteElement.setAttribute("step",D.config.minuteIncrement.toString()),D.hourElement.setAttribute("min",D.config.time_24hr?"0":"1"),D.hourElement.setAttribute("max",D.config.time_24hr?"23":"12"),D.minuteElement.setAttribute("min","0"),D.minuteElement.setAttribute("max","59"),D.timeContainer.appendChild(n),D.timeContainer.appendChild(e),D.timeContainer.appendChild(t),D.config.time_24hr&&D.timeContainer.classList.add("time24hr");if(D.config.enableSeconds){D.timeContainer.classList.add("hasSeconds");var a=f("flatpickr-second");D.secondElement=a.getElementsByTagName("input")[0],D.secondElement.value=o(D.latestSelectedDateObj?D.latestSelectedDateObj.getSeconds():D.config.defaultSeconds),D.secondElement.setAttribute("step",D.minuteElement.getAttribute("step")),D.secondElement.setAttribute("min","0"),D.secondElement.setAttribute("max","59"),D.timeContainer.appendChild(s("span","flatpickr-time-separator",":")),D.timeContainer.appendChild(a)}D.config.time_24hr||(D.amPM=s("span","flatpickr-am-pm",D.l10n.amPM[r((D.latestSelectedDateObj?D.hourElement.value:D.config.defaultHour)>11)]),D.amPM.title=D.l10n.toggleTitle,D.amPM.tabIndex=-1,D.timeContainer.appendChild(D.amPM));return D.timeContainer}());d(D.calendarContainer,"rangeMode","range"===D.config.mode),d(D.calendarContainer,"animate",!0===D.config.animate),d(D.calendarContainer,"multiMonth",D.config.showMonths>1),D.calendarContainer.appendChild(e);var i=void 0!==D.config.appendTo&&void 0!==D.config.appendTo.nodeType;if((D.config.inline||D.config.static)&&(D.calendarContainer.classList.add(D.config.inline?"inline":"static"),D.config.inline&&(!i&&D.element.parentNode?D.element.parentNode.insertBefore(D.calendarContainer,D._input.nextSibling):void 0!==D.config.appendTo&&D.config.appendTo.appendChild(D.calendarContainer)),D.config.static)){var l=s("div","flatpickr-wrapper");D.element.parentNode&&D.element.parentNode.insertBefore(l,D.element),l.appendChild(D.element),D.altInput&&l.appendChild(D.altInput),l.appendChild(D.calendarContainer)}D.config.static||D.config.inline||(void 0!==D.config.appendTo?D.config.appendTo:window.document.body).appendChild(D.calendarContainer)}(),function(){D.config.wrap&&["open","close","toggle","clear"].forEach((function(e){Array.prototype.forEach.call(D.element.querySelectorAll("[data-"+e+"]"),(function(n){return F(n,"click",D[e])}))}));if(D.isMobile)return void function(){var e=D.config.enableTime?D.config.noCalendar?"time":"datetime-local":"date";D.mobileInput=s("input",D.input.className+" flatpickr-mobile"),D.mobileInput.tabIndex=1,D.mobileInput.type=e,D.mobileInput.disabled=D.input.disabled,D.mobileInput.required=D.input.required,D.mobileInput.placeholder=D.input.placeholder,D.mobileFormatStr="datetime-local"===e?"Y-m-d\\TH:i:S":"date"===e?"Y-m-d":"H:i:S",D.selectedDates.length>0&&(D.mobileInput.defaultValue=D.mobileInput.value=D.formatDate(D.selectedDates[0],D.mobileFormatStr));D.config.minDate&&(D.mobileInput.min=D.formatDate(D.config.minDate,"Y-m-d"));D.config.maxDate&&(D.mobileInput.max=D.formatDate(D.config.maxDate,"Y-m-d"));D.input.getAttribute("step")&&(D.mobileInput.step=String(D.input.getAttribute("step")));D.input.type="hidden",void 0!==D.altInput&&(D.altInput.type="hidden");try{D.input.parentNode&&D.input.parentNode.insertBefore(D.mobileInput,D.input.nextSibling)}catch(e){}F(D.mobileInput,"change",(function(e){D.setDate(m(e).value,!1,D.mobileFormatStr),ge("onChange"),ge("onClose")}))}();var e=l(ae,50);D._debouncedChange=l(N,300),D.daysContainer&&!/iPhone|iPad|iPod/i.test(navigator.userAgent)&&F(D.daysContainer,"mouseover",(function(e){"range"===D.config.mode&&te(m(e))}));F(window.document.body,"keydown",ne),D.config.inline||D.config.static||F(window,"resize",e);void 0!==window.ontouchstart?F(window.document,"touchstart",V):F(window.document,"click",V);F(window.document,"focus",V,{capture:!0}),!0===D.config.clickOpens&&(F(D._input,"focus",D.open),F(D._input,"click",D.open));void 0!==D.daysContainer&&(F(D.monthNav,"click",be),F(D.monthNav,["keyup","increment"],O),F(D.daysContainer,"click",se));if(void 0!==D.timeContainer&&void 0!==D.minuteElement&&void 0!==D.hourElement){F(D.timeContainer,["increment"],k),F(D.timeContainer,"blur",k,{capture:!0}),F(D.timeContainer,"click",P),F([D.hourElement,D.minuteElement],["focus","click"],(function(e){return m(e).select()})),void 0!==D.secondElement&&F(D.secondElement,"focus",(function(){return D.secondElement&&D.secondElement.select()})),void 0!==D.amPM&&F(D.amPM,"click",(function(e){k(e),N()}))}D.config.allowInput&&F(D._input,"blur",ee)}(),(D.selectedDates.length||D.config.noCalendar)&&(D.config.enableTime&&I(D.config.noCalendar?D.latestSelectedDateObj||D.config.minDate:void 0),we(!1)),x();var n=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);!D.isMobile&&n&&le(),ge("onReady")}(),D}function x(e,n){for(var t=Array.prototype.slice.call(e).filter((function(e){return e instanceof HTMLElement})),a=[],i=0;i<t.length;i++){var o=t[i];try{if(null!==o.getAttribute("data-fp-omit"))continue;void 0!==o._flatpickr&&(o._flatpickr.destroy(),o._flatpickr=void 0),o._flatpickr=y(o,n||{}),a.push(o._flatpickr)}catch(e){console.error(e)}}return 1===a.length?a[0]:a}"undefined"!=typeof HTMLElement&&"undefined"!=typeof HTMLCollection&&"undefined"!=typeof NodeList&&(HTMLCollection.prototype.flatpickr=NodeList.prototype.flatpickr=function(e){return x(this,e)},HTMLElement.prototype.flatpickr=function(e){return x([this],e)});var E=function(e,n){return"string"==typeof e?x(window.document.querySelectorAll(e),n):e instanceof Node?x([e],n):x(e,n)};return E.defaultConfig={},E.l10ns={en:e({},i),default:e({},i)},E.localize=function(n){E.l10ns.default=e(e({},E.l10ns.default),n)},E.setDefaults=function(n){E.defaultConfig=e(e({},E.defaultConfig),n)},E.parseDate=b({}),E.formatDate=w({}),E.compareDates=C,"undefined"!=typeof jQuery&&void 0!==jQuery.fn&&(jQuery.fn.flatpickr=function(e){return x(this,e)}),Date.prototype.fp_incr=function(e){return new Date(this.getFullYear(),this.getMonth(),this.getDate()+("string"==typeof e?parseInt(e,10):e))},"undefined"!=typeof window&&(window.flatpickr=E),E}));
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.da = {}));
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var Danish = {
      weekdays: {
          shorthand: ["søn", "man", "tir", "ons", "tors", "fre", "lør"],
          longhand: [
              "søndag",
              "mandag",
              "tirsdag",
              "onsdag",
              "torsdag",
              "fredag",
              "lørdag",
          ],
      },
      months: {
          shorthand: [
              "jan",
              "feb",
              "mar",
              "apr",
              "maj",
              "jun",
              "jul",
              "aug",
              "sep",
              "okt",
              "nov",
              "dec",
          ],
          longhand: [
              "januar",
              "februar",
              "marts",
              "april",
              "maj",
              "juni",
              "juli",
              "august",
              "september",
              "oktober",
              "november",
              "december",
          ],
      },
      ordinal: function () {
          return ".";
      },
      firstDayOfWeek: 1,
      rangeSeparator: " til ",
      weekAbbreviation: "uge",
      time_24hr: true,
  };
  fp.l10ns.da = Danish;
  var da = fp.l10ns;

  exports.Danish = Danish;
  exports.default = da;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.monthSelectPlugin = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber]; };

    function getEventTarget(event) {
        try {
            if (typeof event.composedPath === "function") {
                var path = event.composedPath();
                return path[0];
            }
            return event.target;
        }
        catch (error) {
            return event.target;
        }
    }

    var defaultConfig = {
        shorthand: false,
        dateFormat: "F Y",
        altFormat: "F Y",
        theme: "light",
    };
    function monthSelectPlugin(pluginConfig) {
        var config = __assign(__assign({}, defaultConfig), pluginConfig);
        return function (fp) {
            fp.config.dateFormat = config.dateFormat;
            fp.config.altFormat = config.altFormat;
            var self = { monthsContainer: null };
            function clearUnnecessaryDOMElements() {
                if (!fp.rContainer || !fp.daysContainer || !fp.weekdayContainer)
                    return;
                fp.rContainer.removeChild(fp.daysContainer);
                fp.rContainer.removeChild(fp.weekdayContainer);
                for (var index = 0; index < fp.monthElements.length; index++) {
                    var element = fp.monthElements[index];
                    if (!element.parentNode)
                        continue;
                    element.parentNode.removeChild(element);
                }
            }
            function addListeners() {
                fp._bind(fp.prevMonthNav, "click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    fp.currentYear--;
                    selectYear();
                });
                fp._bind(fp.nextMonthNav, "click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    fp.currentYear++;
                    selectYear();
                });
            }
            function addMonths() {
                if (!fp.rContainer)
                    return;
                self.monthsContainer = fp._createElement("div", "flatpickr-monthSelect-months");
                self.monthsContainer.tabIndex = -1;
                fp.calendarContainer.classList.add("flatpickr-monthSelect-theme-" + config.theme);
                for (var i = 0; i < 12; i++) {
                    var month = fp._createElement("span", "flatpickr-monthSelect-month");
                    month.dateObj = new Date(fp.currentYear, i);
                    month.$i = i;
                    month.textContent = monthToStr(i, config.shorthand, fp.l10n);
                    month.tabIndex = -1;
                    month.addEventListener("click", selectMonth);
                    self.monthsContainer.appendChild(month);
                    if ((fp.config.minDate && month.dateObj < fp.config.minDate) ||
                        (fp.config.maxDate && month.dateObj > fp.config.maxDate)) {
                        month.classList.add("disabled");
                    }
                }
                fp.rContainer.appendChild(self.monthsContainer);
            }
            function setCurrentlySelected() {
                if (!fp.rContainer)
                    return;
                var currentlySelected = fp.rContainer.querySelectorAll(".flatpickr-monthSelect-month.selected");
                for (var index = 0; index < currentlySelected.length; index++) {
                    currentlySelected[index].classList.remove("selected");
                }
                var month = fp.rContainer.querySelector(".flatpickr-monthSelect-month:nth-child(" + (fp.currentMonth + 1) + ")");
                if (month) {
                    month.classList.add("selected");
                }
            }
            function selectYear() {
                var selectedDate = fp.selectedDates[0];
                if (selectedDate) {
                    selectedDate = new Date(selectedDate);
                    selectedDate.setFullYear(fp.currentYear);
                    if (fp.config.minDate && selectedDate < fp.config.minDate) {
                        selectedDate = fp.config.minDate;
                    }
                    if (fp.config.maxDate && selectedDate > fp.config.maxDate) {
                        selectedDate = fp.config.maxDate;
                    }
                    fp.currentYear = selectedDate.getFullYear();
                    fp.currentYearElement.value = String(fp.currentYear);
                    fp.currentMonth = selectedDate.getMonth();
                }
                if (fp.rContainer) {
                    var months = fp.rContainer.querySelectorAll(".flatpickr-monthSelect-month");
                    months.forEach(function (month) {
                        month.dateObj.setFullYear(fp.currentYear);
                        if ((fp.config.minDate && month.dateObj < fp.config.minDate) ||
                            (fp.config.maxDate && month.dateObj > fp.config.maxDate)) {
                            month.classList.add("disabled");
                        }
                        else {
                            month.classList.remove("disabled");
                        }
                    });
                }
                setCurrentlySelected();
            }
            function selectMonth(e) {
                e.preventDefault();
                e.stopPropagation();
                var eventTarget = getEventTarget(e);
                if (eventTarget instanceof Element &&
                    !eventTarget.classList.contains("disabled")) {
                    setMonth(eventTarget.dateObj);
                    fp.close();
                }
            }
            function setMonth(date) {
                var selectedDate = new Date(date);
                selectedDate.setFullYear(fp.currentYear);
                fp.currentMonth = selectedDate.getMonth();
                fp.setDate(selectedDate, true);
                setCurrentlySelected();
            }
            var shifts = {
                37: -1,
                39: 1,
                40: 3,
                38: -3,
            };
            function onKeyDown(_, __, ___, e) {
                var shouldMove = shifts[e.keyCode] !== undefined;
                if (!shouldMove && e.keyCode !== 13) {
                    return;
                }
                if (!fp.rContainer || !self.monthsContainer)
                    return;
                var currentlySelected = fp.rContainer.querySelector(".flatpickr-monthSelect-month.selected");
                var index = Array.prototype.indexOf.call(self.monthsContainer.children, document.activeElement);
                if (index === -1) {
                    var target = currentlySelected || self.monthsContainer.firstElementChild;
                    target.focus();
                    index = target.$i;
                }
                if (shouldMove) {
                    self.monthsContainer.children[(12 + index + shifts[e.keyCode]) % 12].focus();
                }
                else if (e.keyCode === 13 &&
                    self.monthsContainer.contains(document.activeElement)) {
                    setMonth(document.activeElement.dateObj);
                }
            }
            function destroyPluginInstance() {
                if (self.monthsContainer !== null) {
                    var months = self.monthsContainer.querySelectorAll(".flatpickr-monthSelect-month");
                    for (var index = 0; index < months.length; index++) {
                        months[index].removeEventListener("click", selectMonth);
                    }
                }
            }
            return {
                onParseConfig: function () {
                    fp.config.mode = "single";
                    fp.config.enableTime = false;
                },
                onValueUpdate: setCurrentlySelected,
                onKeyDown: onKeyDown,
                onReady: [
                    clearUnnecessaryDOMElements,
                    addListeners,
                    addMonths,
                    setCurrentlySelected,
                    function () {
                        fp.loadedPlugins.push("monthSelect");
                    },
                ],
                onDestroy: destroyPluginInstance,
            };
        };
    }

    return monthSelectPlugin;

})));

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.weekSelect = factory());
}(this, (function () { 'use strict';

  function getEventTarget(event) {
      try {
          if (typeof event.composedPath === "function") {
              var path = event.composedPath();
              return path[0];
          }
          return event.target;
      }
      catch (error) {
          return event.target;
      }
  }

  function weekSelectPlugin() {
      return function (fp) {
          function onDayHover(event) {
              var day = getEventTarget(event);
              if (!day.classList.contains("flatpickr-day"))
                  return;
              var days = fp.days.childNodes;
              var dayIndex = day.$i;
              var dayIndSeven = dayIndex / 7;
              var weekStartDay = days[7 * Math.floor(dayIndSeven)]
                  .dateObj;
              var weekEndDay = days[7 * Math.ceil(dayIndSeven + 0.01) - 1].dateObj;
              for (var i = days.length; i--;) {
                  var day_1 = days[i];
                  var date = day_1.dateObj;
                  if (date > weekEndDay || date < weekStartDay)
                      day_1.classList.remove("inRange");
                  else
                      day_1.classList.add("inRange");
              }
          }
          function highlightWeek() {
              var selDate = fp.latestSelectedDateObj;
              if (selDate !== undefined &&
                  selDate.getMonth() === fp.currentMonth &&
                  selDate.getFullYear() === fp.currentYear) {
                  fp.weekStartDay = fp.days.childNodes[7 * Math.floor(fp.selectedDateElem.$i / 7)].dateObj;
                  fp.weekEndDay = fp.days.childNodes[7 * Math.ceil(fp.selectedDateElem.$i / 7 + 0.01) - 1].dateObj;
              }
              var days = fp.days.childNodes;
              for (var i = days.length; i--;) {
                  var date = days[i].dateObj;
                  if (date >= fp.weekStartDay && date <= fp.weekEndDay)
                      days[i].classList.add("week", "selected");
              }
          }
          function clearHover() {
              var days = fp.days.childNodes;
              for (var i = days.length; i--;)
                  days[i].classList.remove("inRange");
          }
          function onReady() {
              if (fp.daysContainer !== undefined)
                  fp.daysContainer.addEventListener("mouseover", onDayHover);
          }
          function onDestroy() {
              if (fp.daysContainer !== undefined)
                  fp.daysContainer.removeEventListener("mouseover", onDayHover);
          }
          return {
              onValueUpdate: highlightWeek,
              onMonthChange: highlightWeek,
              onYearChange: highlightWeek,
              onOpen: highlightWeek,
              onClose: clearHover,
              onParseConfig: function () {
                  fp.config.mode = "single";
                  fp.config.enableTime = false;
                  fp.config.dateFormat = fp.config.dateFormat
                      ? fp.config.dateFormat
                      : "\\W\\e\\e\\k #W, Y";
                  fp.config.altFormat = fp.config.altFormat
                      ? fp.config.altFormat
                      : "\\W\\e\\e\\k #W, Y";
              },
              onReady: [
                  onReady,
                  highlightWeek,
                  function () {
                      fp.loadedPlugins.push("weekSelect");
                  },
              ],
              onDestroy: onDestroy,
          };
      };
  }

  return weekSelectPlugin;

})));

(function ($) {
    'use strict';

    var defaults = {
        icon: 'calendar',
        editable: false,
        date: new Date(),
        language: 'en',
        format: false,
        mode: 'day'
    };

    $.fn.hdatepicker = function(options) {
        var settings = $.extend(true, {}, defaults, options);

        return (function (hpicker) {
            var callbacks = [];

            var on = function (event, cb) {
                if (!Array.isArray(event)) {
                    event = [event];
                }
                event.forEach(function (e) {
                    if (['change'].indexOf(e) > -1) {
                        callbacks.push({ event: e, cb: cb });
                    }
                });
            };

            function trigger(event, data) {
                var result = true;
                callbacks.filter(function (e) {
                    return e.event === event;
                }).forEach(function (value) {
                    var res = value.cb($.extend({ event: event }, data));
                    if (res === undefined || res === true) {
                        result = result && true;
                    } else {
                        result = false;
                    }
                });
                return result;
            }

            hpicker.empty();

            hpicker.addClass('h-datepicker');

            var hinput = $('<input>', { class: 'h-datepicker-input' });
            hpicker.append(hinput);
            if (settings.icon) {
                var hbutton = $('<div>', { class: 'h-datepicker-button' }).append(H.getSprite(settings.icon));
                hpicker.append(hbutton);
                hbutton.outerWidth(hinput.outerHeight());
            }

            var rangle = H.getSprite('right-angle');
            var langle = H.getSprite('right-angle', 'h-datepicker-previous');

            var params = {
                allowInput: settings.editable,
                locale: settings.language.substring(0, 2),
                prevArrow: langle,
                nextArrow: rangle,
                onChange: function(selectedDates) {
                    trigger('change', { date: selectedDates[0] });
                },
                allowInput: true
            };

            if (settings.mode === 'month') {
                params.plugins = [new monthSelectPlugin({
                    //shorthand: false,
                    dateFormat: 'Y-m-d'
                })]
            } else if (settings.mode === 'week') {
                params.plugins = [new weekSelect()]
            }

            if (settings.format) {
                params.dateFormat = settings.format;
            }

            var fp = hinput.flatpickr(params);

            if (settings.date) {
                fp.setDate(settings.date);
            }

            if (hbutton) {
                hbutton.on('click', () => {
                    setTimeout(() => fp.open(), 0);
                });
            }

            var get = function() {
                return fp.selectedDates[0];
            };

            var set = function(date, forceTrigger) {
                fp.setDate(date, forceTrigger !== false);
            };

            var enable = function (enabled) {
                if (enabled) {
                    fp._input.removeAttribute('disabled');
                } else {
                    fp._input.setAttribute('disabled', 'disabled');
                }
            };

            return {
                on: on,
                get: get,
                enable: enable,
                set: set
            };
        })(this);
    };
})(jQuery);
Vue.component('v-datepicker', {
    template: `
        <div class="v-datepicker">
            <input class="v-datepicker-input" :class="{ 'v-datepicker-input-time': this.time }" :disabled="disabled" ref="input"/>
            <div class="v-datepicker-button" ref="button" v-html="icon" @click="open()"/>
        </div>
    `,
    props: {
        value: {
            type: Date,
            default: () => new Date()
        },
        mode: {
            type: String,
            default: 'day'
        },
        time: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            icon: H.getSprite('calendar'),
            fp: null
        };
    },
    watch: {
        value() {
            this.fp.setDate(this.value);
        }
    },
    mounted() {        
        let locale = {};
        if (vstore.user.cultureCode.startsWith('da')) {
            locale = flatpickr.l10ns.da;
        }
        locale.firstDayOfWeek = vstore.shared.firstDayOfWeek;

        const params = {
            allowInput: !this.readonly,
            enableTime: this.time,
            time_24hr: true,
            locale: locale,
            prevArrow: H.getSprite('right-angle', 'v-datepicker-previous'),
            nextArrow: H.getSprite('right-angle'),
            onChange: (selectedDates) => {
                this.$emit('input', selectedDates[0]);
            },
            onOpen: () => this.$emit('open'),
            onClose: () => this.$emit('close')
        };

        if (this.mode === 'month') {
            params.plugins = [new monthSelectPlugin({
                dateFormat: 'Y-m-d'
            })]
        } else if (this.mode === 'week') {
            params.plugins = [new weekSelect()]
        }

        this.fp = this.$refs.input.flatpickr(params);

        if (this.value) {
            this.fp.setDate(this.value);
        }
    },
    beforeDestroy() {
        this.fp.destroy();
    },
    methods: {       
        open() {
            setTimeout(() => this.fp.open(), 0);
        }
    }
});

Vue.component('v-dropdown', {
    template: `
        <select :required="required" :name="name"/>
    `,
    props: {
        items: {
            type: Array,
            default: []
        },
        value: {
            type: null,
            default: null
        },
        clearable: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        combobox: {
            type: Boolean,
            default: false
        },
        searchable: {
            type: [Boolean, Number],
            default: Infinity
        }
    },
    data() {
        return {
            store: vstore,
            options: new Map()
        }
    },
    watch: {
        value() {
            jQuery(this.$el).val(this.value).trigger('change.select2');
        },
        items() {
            const self = jQuery(this.$el);
            this.populate();
            if (this.$el.selectedIndex > -1) {
                self.trigger('change');
            }
        }
    },
    mounted() {
        this.populate();

        const self = jQuery(this.$el);

        self.on('change', e => {
            this.$emit('input', e.target.value);
            this.$emit('change', this.options.get(e.target.selectedOptions[0]) ?? null);
        });
    },
    methods: {
        populate() {
            const self = jQuery(this.$el);

            if (self.hasClass('select2-hidden-accessible')) {
                this.$el.innerHTML = '';
                self.select2('destroy');
            }

            if (this.clearable) {
                self.append(new Option('', '', false, false));
            }

            let found = false;

            this.items.forEach(i => {
                if (i.values) {
                    const group = document.createElement('optgroup');
                    group.label = i.text;
                    i.values.forEach(c => {
                        const option = new Option(c.text, c.value, false, this.value === c.value);
                        this.options.set(option, c);
                        group.appendChild(option);
                        found = found || this.value === c.value;
                    });
                    self.append(group);
                } else {
                    const option = new Option(i.text, i.value, false, this.value === i.value);
                    this.options.set(option, i);
                    self.append(option);
                    found = found || this.value === i.value;
                }
            });

            if (!found && !this.value) {
                this.$el.selectedIndex = -1;
            }

            let limit = Infinity;
            if (this.combobox === true) {
                limit = 0;
            } else if (typeof this.searchable === 'boolean') {
                if (this.searchable === true) {
                    limit = 0;
                }
            } else if (Number.isInteger(this.searchable)) {
                limit = this.searchable;
            }

            self.select2({
                language: this.store.user.cultureCode,
                minimumResultsForSearch: limit,
                placeholder: this.placeholder || '',
                allowClear: this.clearable ?? true,
                tags: this.combobox === true
            });

            if (this.clearable) {
                self.on('select2:unselecting', () => {
                    self.data('unselecting', true);
                }).on('select2:open', () => {
                    if (self.data('unselecting')) {
                        self.removeData('unselecting');
                        self.select2('close');
                    }
                });
            }
        }
    }
});

window.vform = (() => {
    class Form extends H.HEventable {
        constructor(options) {
            super(['action']);

            this.loading = options.loading || false;
            this.data = options.data || {};
            this.errors = {};

            this._component = null;
        }

        validate() {
            return this._component.validate();
        }

        setErrors(errors) {
            errors.filter(e => e.key).forEach(e => {
                Vue.set(this.errors, e.key, { message: e.message });
            });
        }

        setError(name, message, hint) {
            Vue.set(this.errors, name, { message: e.message, hint: hint });
        }
    }

    return {
        Form: Form
    };
})();

Vue.component('v-form', {
    template: `
        <form class="v-form">
            <v-spinner v-if="config.loading" :size="50"/>
            <slot v-else name="default" :errors="config.errors" :config="config"/>
        </form>
    `,
    props: ['config'],
    created() {
        this.config._component = this;
    },
    methods: {
        validate() {
            let result = true;
            this.config.errors = {};

            this.$el.querySelectorAll('input[name], textarea[name], select[name]').forEach(el => {
                const error = {
                    message: null,
                    hint: null
                };

                if (el.checkValidity() === false) {
                    result = false;
                    var pm;

                    error.message = el.validationMessage;
                    if (el.validity.patternMismatch) {
                        pm = el.dataset.patternmismatch;
                        if (pm) {
                            error.message = pm;
                        }
                    } else if (el.validity.valueMissing) {
                        pm = el.dataset.valuemissing;
                        if (pm) {
                            error.message = pm;
                        }
                    } else if (el.validity.typeMismatch) {
                        pm = el.dataset.typemismatch;
                        if (pm) {
                            error.message = pm;
                        }
                    }

                    if (error.message !== el.validationMessage) {
                        error.hint = el.validationMessage;
                    }

                    this.$set(this.config.errors, el.name, error);
                }
            });

            return result;
        }
    }
});

Vue.component('v-form-errormessage', {
    template: `
        <span v-if="error" :title="error.hint" class="v-form-errormessage">{{ error.message }}</span>
    `,
    props: ['error']
});

window.vgridtable = (() => {
    class Column {
        constructor(options) {
            options = options || {};
            this.name = options.name;
            this.caption = options.caption;
            this.tooltip = options.tooltip;
            this.width = options.hasOwnProperty('width') ? options.width : 'minmax(max-content, 1fr)';
            this.hidden = options.hidden === true;
            this.kind = 'default'; //selector, expander, action, transparent
            this.showWhenSelected = options.showWhenSelected;
            this.sortable = options.sortable;
            this.sortNeutral = options.sortNeutral === true;
            this.sortFunc = options.sortFunc;
            if (!this.sortFunc) {
                this.sortFunc = (a, b, direction) => H.textComparer(a.data[this.name], b.data[this.name], direction)
            }
        }
    }

    class Row {
        constructor(options) {
            options = options || {};
            this.data = options.data;
            this.selectable = options.hasOwnProperty('selectable') ? options.selectable : true;

            this.group = options.group;
            this.groupLevel = 0;
            this.expandable = options.expandable;
            this.rows = options.rows || [];
            this.ref = null;
            this.hidden = options.hidden || false;
        }
    }

    class Table extends H.HEventable {
        constructor(options) {
            super(['action', 'change', 'cellClick', 'headerCellClick', 'selectionChanged', 'expandedChanged']);

            options = options || {};
            this.loading = options.loading === true;
            this.rows = options.rows || [];
            this.compact = options.compact === true;
            this.expandable = options.expandable;
            this.selectable = options.selectable || false;
            this.selection = [];
            this.expanded = [];
            this.sortColumn = null;
            this.sortDirection = 'asc';
            this.headerBackgroundColor = options.headerBackgroundColor;

            this.placeholder = options.placeholder === true;
            this.spinner = H.getSpinner(50).get(0).outerHTML;

            this.preColumns = []
            this.columns = [];
            this.postColumns = [];
            this.selectorColumn = null;
            this.expanderColumn = null;

            this._component = null;
        }

        addPreColumn(column) {
            column.kind = 'transparent';
            this.preColumns.push(column);
        }

        addPostColumn(column) {
            column.kind = 'transparent';
            this.postColumns.push(column);
        }

        addContentColumn(column) {
            column.kind = 'default';
            this.columns.push(column);
        }

        addActionColumn(column) {
            column.kind = 'action';
            this.columns.push(column);
        }

        deleteRow(row) {
            const idx = this.rows.indexOf(row);
            if (idx > -1) {
                this.rows.splice(idx, 1);
            }
        }

        replaceRow(row, newRow) {
            const idx = this.rows.indexOf(row);
            if (idx > -1) {
                this.rows.splice(idx, 1, newRow);
            }
        }

        unselectRow(row) {
            const idx = this.selection.indexOf(row);
            if (idx > -1) {
                this.selection.splice(idx, 1);
            }
        }

        getColumn(name) {
            let result = this.preColumns.find(c => c.name === name);

            if (!result) {
                result = this.postColumns.find(c => c.name === name);
            }
            if (!result) {
                result = this.columns.find(c => c.name === name);
            }

            return result;
        }

        setColumnVisibility(name, visible) {
            let col = this.getColumn(name);
            if (col) {
                col.hidden = !visible;
            }
        }

        scrollToFirstSelected() {
            if (this.selection.length > 0) {
                this._component.$nextTick(() => {
                    const hrow = this._component.$refs[this.selection[0].ref];
                    if (hrow && hrow.length > 0) {
                        hrow[0].children[0].scrollIntoView({ block: 'center' });
                    }
                });
            }
        }

        action(name, data) {
            this.trigger('action', { action: name, data: data });
        }

        get totalCount() {
            function getTotalCountRecursive(r) {
                let result = r.data ? 1 : 0;

                r.rows.forEach(c => result += getTotalCountRecursive(c));

                return result;
            }

            let result = 0;

            this.rows.forEach(c => result += getTotalCountRecursive(c));

            return result;
        }

        get visibleCount() {
            function getVisibleCountRecursive(r) {
                if (r.hidden) {
                    return 0;
                }

                let result = r.data ? 1 : 0;

                r.rows.forEach(c => result += getVisibleCountRecursive(c));

                return result;
            }

            let result = 0;

            this.rows.forEach(c => result += getVisibleCountRecursive(c));

            return result;
        }

        expandSelected() {
            const self = this;

            function expandRecursive(r) {
                let result = false;

                if (self.selection.includes(r)) {
                    result = true;
                }

                r.rows.forEach(c => result = result || expandRecursive(c));

                if (result && r.expandable && !self.expanded.includes(r)) {
                    self.expanded.push(r);
                    self.trigger('expandedChanged', { rows: self.expanded, row: r, expand: true });
                }

                return result;
            }
            this.rows.forEach(r => expandRecursive(r));
        }
    }

    return {
        Table: Table,
        Column: Column,
        Row: Row
    };
})();

Vue.component('v-gridtable', {
    template: `
        <div class="v-gridtable" :class="{ 'v-gridtable-compact': config.compact }" :style="gridStyle()">
            <div class="v-gridtable-header">                        
            <div v-for="(col, idx) in getColumns()" :key="idx" class="v-gridtable-header-cell" :class="{ 'v-gridtable-header-cell-sortable': col.sortable }" :style="headerCellStyle()" :tooltip="col.tooltip" @click="headerCellClicked(col)">
                <slot :name="col.name + 'header'" :col="col">{{ col.caption }}</slot>
                <div v-if="col.sortable && col.name === config.sortColumn && config.sortDirection === 'asc'" class="v-gridtable-sortarrow-asc"/>
                <div v-else-if="col.sortable && col.name === config.sortColumn && config.sortDirection === 'desc'" class="v-gridtable-sortarrow-desc"/>
                <div v-else-if="col.sortable" class="v-gridtable-sortarrow"/>
            </div>
            </div>
            <div v-if="config.loading" class="v-gridtable-placeholder" v-html="config.spinner"/>
            <div v-else-if="visibleRows.length === 0 && config.placeholder" class="v-gridtable-placeholder" v-html="config.placeholder"/>
            <div v-else class="v-gridtable-body">
            <div v-for="(row, ridx) in visibleRows" :key="ridx" :ref="'r' + ridx" class="v-gridtable-row" :class="{ 'h-selected': config.selectable && row.selectable && config.selection.includes(row) }">
                <div v-for="(col, cidx) in getColumns(row)" :key="ridx + '-' + cidx" class="v-gridtable-cell" :class="cellClass(col, row)" :style="cellStyle(col, row)" @click="cellClicked(col, row)">
                    <template v-if="col.kind === 'expander'">
                        <div v-if="row.expandable" class="v-gridtable-cell-expander" :class="{ 'v-expanded': config.expanded.includes(row) }" :style="'margin-left: ' + row.groupLevel * 15  + 'px'">          
                            <svg viewBox="0 0 10 5"><polyline points="1,0 5,5 9,0" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </div>
                    </template>
                    <template v-else-if="col.kind === 'selector'">
                        <div v-if="row.group && !row.data"><span class="v-gridtable-cell-group">{{ row.group }}</span> ({{ row.rows.filter(r => !r.hidden).length }})</div>
                        <div v-else-if="row.selectable" class="v-gridtable-cell-checkbox" :style="checkboxStyle(row)"/>
                    </template>
                    <template v-else-if="row.data">
                        <slot v-if="(col.showWhenSelected && config.selection.includes(row)) || !col.showWhenSelected" :name="col.name" :row="row">{{ row.data[col.name] }}</slot>
                    </template>
                </div>
            </div>
            </div>
        </div>
    `,
    props: ['config'],
    computed: {
        visibleRows() {
            const rows = [...this.config.rows]

            if (this.config.sortColumn) {
                const col = this.config.getColumn(this.config.sortColumn);
                if (col) {
                    this.sortRecursive(col, rows);
                }
            }

            let result = [];

            let refIdx = 0;

            const getRow = (r, l) => {
                r.ref = `r${refIdx++}`;
                r.groupLevel = l;
                result.push(r);
                if (r.expandable && this.config.expanded.includes(r)) {
                    r.rows.filter(c => !c.hidden).forEach(c => getRow(c, l + 1));
                }
            }

            rows.filter(r => !r.hidden).forEach(r => getRow(r, 0));

            return result;
        }
    },
    created() {
        this.config._component = this;

        this.expanderColumn = new vgridtable.Column({
            name: '_expander_',
            width: 'max-content'
        });
        this.expanderColumn.kind = 'expander';

        this.selectorColumn = new vgridtable.Column({
            name: '_selector_',
            width: '38px'
        });
        this.selectorColumn.kind = 'selector';
    },
    updated() {
        this.config.trigger('change');
    },
    methods: {
        sortRecursive(col, rows) {
            if (rows.length === 1 && rows[0].expandable) {
                this.sortRecursive(col, rows[0].rows);
            } else {
                rows.sort((a, b) => {
                    if (a.expandable) {
                        this.sortRecursive(col, a.rows);
                    }
                    if (b.expandable) {
                        this.sortRecursive(col, b.rows);
                    }

                    if (!a.data && b.data) {
                        return -1;
                    } else if (a.data && !b.data) {
                        return 1;
                    } else if (!a.data && !b.data) {
                        return 0;
                    } else {
                        return col.sortFunc(a, b, this.config.sortDirection === 'asc' ? -1 : 1);
                    }
                });
            }
        },
        getColumns(row) {
            const result = [];

            this.config.preColumns.filter(c => !c.hidden).forEach(c => result.push(c));

            if (this.config.expandable) {
                result.push(this.expanderColumn);
            }
            if (this.config.selectable === 'multi') {
                result.push(this.selectorColumn);
            }

            if (!row || row.data) {
                this.config.columns.filter(c => !c.hidden).forEach(c => result.push(c));
            }
            this.config.postColumns.filter(c => !c.hidden).forEach(c => result.push(c));

            return result;
        },
        getNonTransparentColumns(row) {
            return this.getColumns(row).filter(r => r.kind !== 'transparent');
        },
        gridStyle() {
            return 'grid-template-columns: ' + this.getColumns().map(c => c.width).join(' ');
        },
        headerCellStyle() {
            if (this.config.headerBackgroundColor) {
                return `background-color: ${this.config.headerBackgroundColor}`;
            }
        },
        cellStyle(col, row) {
            if (col.kind === 'selector' && row.group && !row.data) {
                return `grid-column-end: span ${this.config.columns.filter(c => !c.hidden).length + 1}`;
            }
        },
        cellClass(col, row) {
            const classes = [];

            if (col.kind !== 'transparent') {
                const cols = this.getNonTransparentColumns(row);
                const idx = cols.indexOf(col);

                if (idx === 0) {
                    classes.push('v-gridtable-cell-boxed-first');
                } else if (col.kind !== 'default') {
                    classes.push('v-gridtable-cell-border-left');
                }

                if (idx === cols.length - 1) {
                    classes.push('v-gridtable-cell-boxed-last');
                } else if (col.kind !== 'default' && cols[idx + 1].kind === 'default') {
                    classes.push('v-gridtable-cell-border-right');
                }
            }

            if (col.kind !== 'transparent') {
                classes.push('v-gridtable-cell-boxed');
            }

            return classes.join(' ');
        },
        checkboxStyle(row) {
            return 'background-color: ' + (this.config.selection.includes(row) ? H.getColor(this.config.selection.indexOf(row)) : 'transparent');
        },
        toggleRowSelected(row, mutex) {
            if (row.selectable) {
                if (mutex) {
                    this.config.selection = [];
                }
                if (this.config.selection.includes(row)) {
                    if (this.config.selection.length > 1) {
                        this.config.selection.splice(this.config.selection.indexOf(row), 1);
                        this.config.trigger('selectionChanged', { rows: this.config.selection });
                    }
                } else {
                    this.config.selection.push(row);
                    this.config.trigger('selectionChanged', { rows: this.config.selection });
                }
            }
        },
        toggleRowExpanded(row) {
            if (row.expandable) {
                if (this.config.expanded.includes(row)) {
                    this.config.expanded.splice(this.config.expanded.indexOf(row), 1);
                    this.config.trigger('expandedChanged', { rows: this.config.expanded, row: row, expand: false });
                } else {
                    this.config.expanded.push(row);
                    this.config.trigger('expandedChanged', { rows: this.config.expanded, row: row, expand: true });
                }
            }
        },
        headerCellClicked(col) {
            if (col.sortable) {
                if (this.config.sortColumn === col.name) {
                    if (this.config.sortDirection === 'asc') {
                        this.config.sortDirection = 'desc';
                    } else if (col.sortNeutral) {
                        this.config.sortColumn = null
                    } else {
                        this.config.sortDirection = 'asc';
                    }
                } else {
                    this.config.sortColumn = col.name;
                    this.config.sortDirection = 'asc';
                }
            }
            this.config.trigger('headerCellClick', { col });
        },
        cellClicked(col, row) {
            switch (col.kind) {
                case 'transparent':
                    this.config.trigger('cellClick', { col, row });
                    this.config.trigger('action', { action: col.name, col, row });
                    break;
                case 'expander':
                    this.toggleRowExpanded(row);
                    break;
                case 'selector':
                    if (row.group && !row.data) {
                        this.toggleRowExpanded(row);
                    } else {
                        this.toggleRowSelected(row, false);
                    }
                    break;
                case 'action':
                    this.config.trigger('cellClick', { col, row });
                    this.config.trigger('action', { action: col.name, col, row });
                    break;
                default:
                    this.toggleRowSelected(row, true);
                    break;
            }
        }
    }
});

window.vgrid = (() => {
    class Grid extends vgridtable.Table {
        constructor(options) {
            options = options || {};
            super(options);

            this.caption = options.caption;

            this.filters = [];
        }

        addFilter(filter) {
            this.filters.push(filter);

            filter.on('change', () => this.filter());

            this.filter();
        }


        filter() {
            const self = this;
            function filterRecursive(rows) {
                rows.forEach(r => {
                    filterRecursive(r.rows);

                    if (r.rows.filter(c => !c.hidden).length > 0) {
                        r.hidden = false;
                    } else {
                        let visible = true;

                        for (let i = 0; i < self.filters.length; i++) {
                            if (r.group && !self.filters[i].filterGroups) {
                                continue;
                            }
                            visible = self.filters[i].filterFunc(r, self.filters[i].value);
                            if (!visible) {
                                break;
                            }
                        }
                        r.hidden = !visible;
                    }
                });
            }

            filterRecursive(this.rows);
        }
    }

    class Filter extends H.HEventable {
        constructor(options) {
            super(['change']);

            this.filterGroups = options.filterGroups || false;
            this.filterFunc = options.filterFunc || (() => true);
        }
    }

    class FilterText extends Filter {
        constructor(options) {
            super(options);
            this.caption = options.caption;
            this.value = options.value || '';
        }
    }

    class FilterDropDown extends Filter {
        constructor(options) {
            super(options);
            this.caption = options.caption;
            this.options = options.options || [];
            this.value = options.value || '';
        }
    }

    class FilterSwitch extends Filter {
        constructor(options) {
            super(options);
            this.caption = options.caption;
            this.value = options.value === true;
        }
    }

    return {
        Grid: Grid,
        FilterText: FilterText,
        FilterDropDown: FilterDropDown,
        FilterSwitch: FilterSwitch
    };
})();

Vue.component('v-grid-toolbar', {
    template: `
        <div class="v-grid-toolbar">
            <slot />
        </div>
    `
});

Vue.component('v-grid-toolbar-section', {
    template: `
        <div class="v-grid-toolbar-section" :class="{ 'v-grid-toolbar-section-divider': showDivider, 'v-grid-toolbar-position-right': position === 'right' }">
            <slot/>
        </div>
    `,
    props: ['showDivider', 'position']
});

Vue.component('v-grid-filter-displaycounts', {
    template: `
        <div>
            <label v-if="gridConfig.caption">{{ gridConfig.caption }}</label>
            <div style="font-size: 0.9rem; text-align: center"><template v-if="gridConfig.visibleCount !== gridConfig.totalCount"><span>{{ gridConfig.visibleCount }}</span> / </template><span>{{ gridConfig.totalCount }}</span></div>
        </div>
    `,
    props: ['gridConfig']
});

Vue.component('v-grid-filter-text', {
    template: `
        <div class="v-grid-filter v-grid-filter-text">
            <div v-if="config.caption">
                <label>{{ config.caption }}</label>
            </div>
            <input type="search" autocomplete="off" class="v-grid-filter-text-input" :value="config.value" @input="changed($event)">
        </div>
    `,
    props: ['config'],
    methods: {
        changed(e) {
            this.config.value = e.target.value;
            this.config.trigger('change', { value: this.config.value });
        }
    }
});

Vue.component('v-grid-filter-dropdown', {
    template: `
        <div class="v-grid-filter v-grid-filter-select">
            <div v-if="config.caption">
                <label>{{ config.caption }}</label>
            </div>
            <v-dropdown :items="config.options" :value="config.value" :clearable="true" :searchable="10" @change="changed($event)" style="min-width: 150px"/>
        </div>
    `,
    props: ['config'],
    methods: {
        changed(e) {
            this.config.value = e ? e.value : null;
            this.config.trigger('change', { value: this.config.value });
        }
    }
});

Vue.component('v-grid-filter-switch', {
    template: `
        <div class="v-grid-filter">
            <div v-if="config.caption">
                <label>{{ config.caption }}</label>
            </div>
            <v-switch :value="config.value" @input="changed($event)" style="margin-top: 1px"/>
        </div>
    `,
    props: ['config'],
    methods: {
        changed(e) {
            this.config.value = e;
            this.config.trigger('change', { value: e });
        }
    }
});

Vue.component('v-grid', {
    template: `
        <div class="v-grid">
            <slot />
            <v-gridtable :config="config">
                <template v-for="(_, name) in $scopedSlots" v-slot:[name]="{ row, col }">
                    <slot :name="name" :row="row" :col="col"/>
                </template>
            </v-gridtable>
        </div>
    `,
    props: ['config']
});

Vue.component('v-modal', {
    template: `
        <div :id="'h-modal-' + config.name" class="h-modal">
            <slot><div v-html="config.content"></div></slot>
        </div>
    `,
    props: ['config']
});

window.vmodal = (() => {
    class Modal {
        constructor(options) {
            options = options || {};

            this.name = options.name;
            this.hmodal = null;
            this.header = options.header;
            this.accept = options.accept;
            this.reject = options.reject;
            this.autoClose = options.hasOwnProperty('autoClose') ? options.autoClose === true : true;
            this.acceptable = options.acceptable;
        }

        open(cb) {            
            if (!this.hmodal) {
                this.hmodal = jQuery('#h-modal-' + this.name).hmodal({
                    header: this.header,
                    accept: this.accept,
                    reject: this.reject,
                    autoClose: this.autoClose
                });
            } else {
                if (this.header) {
                    this.hmodal.header(this.header);
                }
            }
            if (this.acceptable) {
                this.hmodal.on('acceptable', this.acceptable);
            }
            this.hmodal.open(cb);
        }

        close() {
            this.hmodal.close();
        }
    }

    return {
        Modal: Modal
    };
})();
Vue.component('v-props', {
    template: `
        <div class="v-props">
            <template v-for="(prop, idx) in items" class="v-prop">
                <div class="v-prop-caption">{{ prop.caption }}</div>
                <div class="v-prop-value">{{ prop.value }}</div>
            </template>
        </div>
    `,
    props: ['items']
});

window.vsorttable = (() => {
    class Column {
        constructor(options) {
            options = options || {};
            this.name = options.name;
            this.caption = options.caption;
            this.tooltip = options.tooltip;
            this.width = options.hasOwnProperty('width') ? options.width : 'auto';
        }
    }

    class Row {
        constructor(options) {
            options = options || {};
            this.data = options.data;
            this.key = H.uniqueId();
        }
    }

    class Table {
        constructor(options) {
            options = options || {};
            this.rows = options.rows || [];
            this.headerBackgroundColor = options.headerBackgroundColor;

            this.placeholder = options.placeholder === true;

            this.columns = [];
        }

        addColumn(column) {
            this.columns.push(column);
        }

        getColumn(name) {
            return this.columns.find(c => c.name === name);
        }
    }

    return {
        Table: Table,
        Column: Column,
        Row: Row
    };
})();

Vue.component('v-sorttable', {
    template: `
        <div class="v-sorttable">
            <div class="v-sorttable-header">
                <div class="v-sorttable-cell v-sorttable-handle"/>
                <div v-for="(col, idx) in config.columns" class="v-sorttable-cell" :style="'width: ' + col.width">{{ col.caption }}</div>
            </div>
            <draggable v-model="config.rows" handle=".v-sorttable-handle" :animation="200" class="v-sorttable-body-wrapper" drag-class="v-sorttable-row-drag" ghost-class="v-sorttable-row-ghost" :remove-clone-on-hide="false" @start="drag = true" @end="drag = false">
                <transition-group type="transition" :name="!drag ? 'flip-list' : null" tag="div" class="v-sorttable-body">
                    <div v-for="row in config.rows" :key="row.key" class="v-sorttable-row">
                        <div class="v-sorttable-cell v-sorttable-handle">&#8942;</div>
                        <div v-for="(col, idx) in config.columns" :key="idx" class="v-sorttable-cell" :style="'width: ' + col.width">
                            <slot :name="col.name" :row="row">{{ row.data[col.name] }}</slot>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>
    `,
    components: {
        draggable: vuedraggable
    },
    props: ['config'],
    data() {
        return {
            drag: false
        };
    },
    methods: {
        headerCellStyle() {
            if (this.config.headerBackgroundColor) {
                return `background-color: ${this.config.headerBackgroundColor}`;
            }
        }
    }
});

Vue.component('v-spinner', {
    template: `
        <div class="v-spinner">
            <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :fill="color" viewBox="0 0 512 512">
                <path class="v-spinner-t1" d="M256.001,0c-8.284,0-15,6.716-15,15v96.4c0,8.284,6.716,15,15,15s15-6.716,15-15V15C271.001,6.716,264.285,0,256.001,0z"/>
                <path class="v-spinner-t2" d="M384.001,34.3c-7.175-4.145-16.349-1.686-20.49,5.49l-48.199,83.483c-4.143,7.173-1.684,16.347,5.49,20.49c2.362,1.364,4.941,2.013,7.486,2.013c5.184,0,10.226-2.69,13.004-7.503l48.199-83.483C393.634,47.616,391.175,38.442,384.001,34.3z"/>
                <path class="v-spinner-t3" d="M477.702,128.002c-4.142-7.175-13.315-9.634-20.49-5.49l-83.484,48.2c-7.174,4.142-9.631,13.315-5.49,20.49c2.778,4.813,7.819,7.503,13.005,7.503c2.544,0,5.123-0.648,7.485-2.013l83.484-48.2C479.387,144.35,481.844,135.176,477.702,128.002z"/>
                <path class="v-spinner-t4" d="M497,241.002h-96.398c-8.284,0-15,6.716-15,15s6.716,15,15,15H497c8.284,0,15-6.716,15-15S505.284,241.002,497,241.002z"/>
                <path class="v-spinner-t5" d="M472.213,363.51l-83.484-48.198c-7.177-4.145-16.349-1.684-20.49,5.49c-4.142,7.175-1.685,16.349,5.49,20.49,l83.484,48.198c2.362,1.364,4.94,2.013,7.485,2.013c5.185,0,10.227-2.691,13.005-7.503C481.845,376.825,479.388,367.651,472.213,363.51z"/>
                <path class="v-spinner-t6" d="M389.491,457.212l-48.199-83.483c-4.142-7.175-13.315-9.635-20.49-5.49c-7.174,4.142-9.633,13.315-5.49,20.49,l48.199,83.483c2.778,4.813,7.82,7.503,13.004,7.503c2.545,0,5.125-0.648,7.486-2.013C391.175,473.56,393.634,464.387,389.491,457.212z"/>
                <path class="v-spinner-t7" d="M256.001,385.601c-8.284,0-15,6.716-15,15V497c0,8.284,6.716,15,15,15s15-6.716,15-15v-96.399C271.001,392.316,264.285,385.601,256.001,385.601z"/>
                <path class="v-spinner-t8" d="M191.201,368.239c-7.175-4.145-16.349-1.685-20.49,5.49l-48.2,83.485c-4.142,7.175-1.684,16.349,5.49,20.49c2.362,1.364,4.941,2.013,7.486,2.013c5.184,0,10.227-2.691,13.004-7.503l48.2-83.485C200.833,381.555,198.376,372.381,191.201,368.239z"/>
                <path class="v-spinner-t9" d="M143.765,320.802c-4.141-7.175-13.314-9.635-20.49-5.49l-83.486,48.2c-7.174,4.142-9.632,13.315-5.49,20.49c2.778,4.813,7.82,7.503,13.004,7.503c2.545,0,5.124-0.648,7.486-2.013l83.486-48.2C145.449,337.15,147.907,327.977,143.765,320.802z"/>
                <path class="v-spinner-t10" d="M111.401,241.002H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h96.401c8.284,0,15-6.716,15-15S119.685,241.002,111.401,241.002z"/>
                <path class="v-spinner-t11" d="M138.274,170.712L54.788,122.51c-7.174-4.145-16.348-1.685-20.49,5.49c-4.142,7.174-1.684,16.348,5.49,20.49,l83.486,48.202c2.362,1.364,4.941,2.013,7.486,2.013c5.184,0,10.226-2.691,13.004-7.503C147.906,184.028,145.448,174.854,138.274,170.712z"/>
                <path class="v-spinner-t12" d="M196.691,123.272l-48.2-83.485c-4.142-7.175-13.315-9.635-20.49-5.49c-7.174,4.142-9.632,13.315-5.49,20.49l48.2,83.485c2.778,4.813,7.82,7.503,13.004,7.503c2.545,0,5.124-0.648,7.486-2.013C198.376,139.62,200.833,130.447,196.691,123.272z"/>
            </svg>
        </div>
    `,
    props: {
        size: {
            type: Number,
            default: 25
        },
        color: {
            type: String,
            default: 'black'
        }
    }
});
Vue.component('v-pointstyle', {
    template: `
        <span v-if="pointstyle.type" :style="'width: ' + Math.min(pointstyle.size, 27) + 'px; height: ' + Math.min(pointstyle.size, 27) + 'px'">                
            <span v-if="pointstyle.type === 'svg'" v-html="pointstyle.symbol" :style="svgStyle"/>
            <img v-else="pointstyle.type === 'image'" :src="'data:image/png;base64,' + pointstyle.symbol" :style="imgStyle"/>
        </span>
    `,
    props: ['pointstyle'],
    computed: {
        svgStyle() {
            return `
                fill: ${this.pointstyle.fill};
                stroke: ${this.pointstyle.stroke};                
            `;
        },
        imgStyle() {
            return `
                max-width: 100%;
                max-height: 100%;
            `;
        }
    }
});

Vue.component('v-stylebutton', {
    template: `
        <div class="v-stylebutton" @click="$emit('click')">
            <v-pointstyle :pointstyle="pointstyle"/>
        </div>
    `,
    props: ['pointstyle']
});

window.vpointstyle = (() => {
    class PointStyle {
        constructor(options) {
            this.type = options.type || 'svg';
            this.symbol = options.symbol;
            this.stroke = options.stroke;
            this.fill = options.fill;
            this.size = options.size;
        }

        clone() {
            return new PointStyle(this);
        }

        assign(style) {
            this.type = style.type;
            this.symbol = style.symbol;
            this.stroke = style.stroke;
            this.fill = style.fill;
            this.size = style.size;
        }
    }

    return {
        PointStyle: PointStyle
    };
})();

Vue.component('v-switch', {
    template: `
        <div class="v-switch" :class="{ 'v-switch-on': state }" :style="switchStyle()" @click="switchClicked()">
            <div class="v-switch-indicator" :style="indicatorStyle()"/>
        </div>
    `,
    props: ['value', 'onColor', 'offColor'],
    data() {
        return {
            state: false
        }
    },
    created() {
        this.state = this.value;
    },
    watch: {
        value() {
            this.state = this.value;
        }
    },
    methods: {
        switchStyle() {
            return 'border-color: ' + (this.state ? this.onColor || '#4c82a4' : this.offColor || '#aaa');
        },
        indicatorStyle() {
            return 'background-color: ' + (this.state ? this.onColor || '#4c82a4' : this.offColor || '#aaa');
        },
        switchClicked() {
            this.state = !this.state;
            this.$emit('input', this.state);
        },

    }
});

Vue.component('v-toggleselector', {
    template: `
        <div class="v-toggleselector">
            <div v-for="item in items" class="v-toggleselector-item" :class="{ 'v-selected': item.id === value }" @click="$emit('input', item.id)">
                <slot name="default" :item="item">{{ item.text }}</slot>
            </div>
        </div>
    `,
    props: ['items', 'value']
});

window.vtreeselector = (() => {
    class Node {
        constructor(options) {
            options = options || {};
            this.expanded = options.expanded;
            this.expandable = options.hasOwnProperty('expandable') ? options.expandable === true : true;
            this.selectable = options.hasOwnProperty('selectable') ? options.selectable === true : true;
            this.filterable = options.hasOwnProperty('filterable') ? options.filterable === true : true;
            this.countable = options.countable ?? true;
            this.id = options.id;
            this.text = options.text;
            this.data = options.data;
            this.children = options.children || [];
            this.hidden = options.hidden || false;
            this.showTooltip = options.hasOwnProperty('showTooltip') ? options.showTooltip === true : true;
            this.link = options.hasOwnProperty('link') ? options.link : null;

            this.level = 0;
            this.parent = null;
        }
    }

    class Tree extends H.HEventable {
        constructor(options) {
            super(['select']);
            options = options || {};
            this.multiSelect = options.hasOwnProperty('multiSelect') ? options.multiSelect === true : false;
            this.selected = new Set();
            if (options.hasOwnProperty('selected')) {
                this.selected.add(options.selected);
            }
            this.nodes = options.nodes || [];
            this.filter = null;
        }

        nodeList(cb) {
            const result = [];
            function getNodeListRecursive(n, cb) {
                if ((cb && cb(n)) || !cb) {
                    result.push(n);
                }
                n.children.forEach(c => getNodeListRecursive(c, cb));
            }

            this.nodes.forEach(n => getNodeListRecursive(n, cb));

            return result;
        }

        get totalCount() {
            return this.nodeList().length;
        }

        get totalFilterableCount() {
            return this.nodeList().filter(n => n.filterable && n.countable).length;
        }

        get visibleCount() {
            function getVisibleCountRecursive(n) {
                if (n.hidden) {
                    return 0;
                }

                let result = n.countable ? 1 : 0;

                n.children.forEach(c => result += getVisibleCountRecursive(c));

                return result;
            }

            let result = 0;

            this.nodes.forEach(c => result += getVisibleCountRecursive(c));

            return result;
        }

        get visibleFilterableCount() {
            function getVisibleCountRecursive(n) {
                if (n.hidden) {
                    return 0;
                }

                let result = n.filterable ? 1 : 0;

                n.children.forEach(c => result += getVisibleCountRecursive(c));

                return result;
            }

            let result = 0;

            this.nodes.forEach(c => result += getVisibleCountRecursive(c));

            return result;
        }

        find(id) {
            const nodes = this.nodeList(n => n.id === id);

            return nodes.length > 0 ? nodes[0] : null;
        }

        expandToSelected() {
            const self = this;
            function expandSelected(node) {
                let expand = self.selected.has(node);
                node.children.forEach(c => {
                    expand = expand || expandSelected(c) || self.selected.has(c);
                });

                if (expand && node.children.length > 0) {
                    node.expanded = true;
                }

                return expand;
            }

            this.nodes.forEach(n => expandSelected(n))
        }

        filterNodes(text) {
            function filterRecursive(nodes) {
                nodes.forEach(n => {
                    filterRecursive(n.children);

                    if (n.children.filter(c => !c.hidden).length > 0) {
                        n.hidden = false;
                    } else {
                        if (text && n.filterable) {
                            n.hidden = !n.text.toLowerCase().includes(text.toLowerCase());
                        } else {
                            n.hidden = false;
                        }
                    }
                });
            }

            filterRecursive(this.nodes);
        }
    }

    return {
        Tree: Tree,
        Node: Node
    }
})();

Vue.component('v-treeselector', {
    template: `
            <div class="v-treeselector" tabindex="0" @keydown="keyDown($event)">
                <component :is="node.link ? 'a' : 'div'" v-for="(node, idx) in visibleNodes" :href="node.link" :title="node.showTooltip ? node.text : null" :key="idx" :ref="'n' + idx" class="v-treeselector-node" :class="{ 'v-treeselector-node-selectable': node.selectable, 'v-treeselector-node-selected': node.selectable && config.selected.has(node) }" @click="nodeClick(node)">
                    <div v-if="node.level > 0" :style="'width: ' + (node.level * 15) + 'px; flex: none'"/>
                    <div v-if="node.expandable" class="v-treeselector-node-expander" :class="{ 'v-treeselector-node-expanded': node.expanded }" @click.stop="expanderClick(node)">          
                        <svg v-if="node.children.length > 0" viewBox="0 0 10 5"><polyline points="1,0 5,5 9,0" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <div v-if="config.multiSelect && node.selectable" class="v-treeselector-node-checkbox" @click.stop="checkboxClick(node)">
                        <svg v-if="config.selected.has(node)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 0H4A4 4 0 0 0 0 4V28a4 4 0 0 0 4 4H28a4 4 0 0 0 4-4V4A4 4 0 0 0 28 0Zm0 28H4V4H28Z"/><path fill="currentColor" d="M28 4H4V28H28ZM14.5 22.62 8.94 17.06l2.12-2.12 3.44 3.44 7.19-7.19 2.12 2.12Z"/></svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 0H4A4 4 0 0 0 0 4V28a4 4 0 0 0 4 4H28a4 4 0 0 0 4-4V4A4 4 0 0 0 28 0Zm0 28H4V4H28Z"/></svg>
                    </div>
                    <slot :node="node">{{ node.text }}</slot>
                </component>
            </div>
        `,
    props: ['config'],
    computed: {
        visibleNodes() {
            const result = [];

            function addNode(node, level) {
                node.level = level;
                result.push(node);

                if (node.children && node.expanded) {
                    node.children.forEach(c => {
                        c.parent = node;
                        if (!c.hidden) {
                            addNode(c, level + (node.expandable ? 1 : 0));
                        }
                    });
                }
            }

            this.config.nodes.filter(n => !n.hidden).forEach(i => addNode(i, 0));

            return result;
        }
    },
    methods: {
        nodeClick(node) {
            if (node.selectable) {
                this.config.selected = new Set([node]);
                this.$emit('select', node);
                this.config.trigger('select', { node: node });
            }
        },
        checkboxClick(node) {
            if (node.selectable) {
                this.config.selected.has(node) ? this.config.selected.delete(node) : this.config.selected.add(node);
                this.config.selected = new Set(this.config.selected);
                this.$emit('select', this.config.selected);
                this.config.trigger('select', { nodes: this.config.selected });
            }
        },
        expanderClick(node) {
            if (node.children.length > 0) {
                node.expanded = !node.expanded;
            }
        },
        scrollToSelected() {
            if (this.config.selected.size > 0) {
                this.$nextTick(() => {
                    const idx = this.visibleNodes.indexOf(this.config.selected.values().next().value);
                    const el = this.$refs['n' + idx][0];
                    const selectedRect = el.getBoundingClientRect();
                    const treeRect = this.$el.getBoundingClientRect();

                    const isInViewport =
                        selectedRect.top >= treeRect.top &&
                        selectedRect.left >= treeRect.left &&
                        selectedRect.bottom <= treeRect.bottom &&
                        selectedRect.right <= treeRect.right;
                    if (!isInViewport) {
                        el.scrollIntoView({ block: 'nearest' });
                    }
                });
            }
        },
        keyDown(e) {
            if (e.key === 'ArrowDown' && !this.config.multiSelect) {
                const idx = this.visibleNodes.indexOf(this.config.selected.values().next().value);
                if (idx > -1 && idx < this.visibleNodes.length - 1) {
                    this.config.selected = new Set([this.visibleNodes[idx + 1]]);
                    this.$emit('select', this.config.selected);
                    this.config.trigger('select', { node: this.config.selected });
                    this.scrollToSelected();
                    e.preventDefault();
                }
            } else if (e.key === 'ArrowUp' && !this.config.multiSelect) {
                const idx = this.visibleNodes.indexOf(this.config.selected.values().next().value);
                if (idx > 0) {
                    this.config.selected = new Set([this.visibleNodes[idx - 1]]);
                    this.$emit('select', this.config.selected);
                    this.config.trigger('select', { node: this.config.selected });
                    this.scrollToSelected();
                    e.preventDefault();
                }
            } else if (e.key === 'ArrowLeft' && !this.config.multiSelect) {
                const node = this.config.selected.values().next().value;
                if (node.children.length > 0 && node.expanded) {
                    node.expanded = false;
                } else if (node.parent) {
                    this.config.selected = new Set([node.parent]);
                    this.$emit('select', this.config.selected);
                    this.config.trigger('select', { node: this.config.selected });
                    this.scrollToSelected();
                }
            } else if (e.key === 'ArrowRight' && !this.config.multiSelect) {
                const node = this.config.selected.values().next().value;
                if (node.children.length > 0 && !node.expanded) {
                    node.expanded = true;
                } else {
                    const idx = this.visibleNodes.indexOf(node);
                    if (idx > -1 && idx < this.visibleNodes.length - 1) {
                        this.config.selected = new Set([this.visibleNodes[idx + 1]]);
                        this.$emit('select', this.config.selected);
                        this.config.trigger('select', { node: this.config.selected });
                        this.scrollToSelected();
                        e.preventDefault();
                    }
                }
            }
        }
    }
});